import { d as __extends$1, e as __awaiter, f as __generator, _ as __read, a as __spreadArray, b as __assign, g as __rest } from './_tslib-7a01aab4.js';
import { toJS, makeObservable, observable, action, computed, flow, runInAction, extendObservable } from 'mobx';
import { HttpResponse } from './shared/core/classes/httpResponse/index.js';
import { HubConnectionState, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { CommonConnectionsMethod, GameLiveConnectionMethod, ConnectionPrefix, LobbyLiveConnectionMethod } from './shared/core/services/liveConnection/types.js';
import { chatStore } from './shared/core/store/chatStore.js';
import { gameResultStore } from './shared/core/store/gameResultStore.js';
import './shared/core/enums/GameSpecificTypes.js';
import { UpdatedFreeBetDataItemKeys, FreeBetInitialData } from './shared/core/enums/MaxPayoutDataTypes.js';
import './shared/core/enums/Chat.js';
import './shared/core/enums/GameModes.js';
import './shared/core/enums/IconTypes.js';
import { BetStatus } from './shared/core/enums/BetStatus.js';
import './shared/core/enums/PopupTypes.js';
import { ApiVersion } from './shared/core/enums/ApiVersion.js';
import { RoundStatus } from './shared/core/enums/RoundStatus.js';
import { FreeBetsStatus } from './shared/core/enums/FreeBetsStatus.js';
import { ChatSocketEvents } from './shared/core/enums/SocketEvents.js';
import { TranslationKeys } from './shared/core/enums/TranslationKeys.js';
import { TimeoutMaxValue } from './shared/core/enums/TimeoutMaxValue.js';
import { ApiServiceTypes } from './shared/core/enums/ApiServiceTypes.js';
import { EnvironmentTypes } from './shared/core/enums/EnvironmentTypes.js';
import './shared/core/enums/DefaultQueryValues.js';
import { FreeBetWinningType } from './shared/core/enums/FreeBetWinningType.js';
import { DefaultQueryParams } from './shared/core/enums/DefaultQueryParams.js';
import { BetHistoryFilterTypes } from './shared/core/enums/BetHistoryFilterTypes.js';
import { GameTheme } from './shared/core/enums/GameThemeTypes.js';
import { PathsForCancellationPrevRequests, RequestStatus } from './shared/core/enums/RequestStatus.js';
import { BetsFetchDefaultPaths, BetsFetchDefaultParamNames } from './shared/core/enums/FetchDefaultPaths.js';
import { BetResponseCode, BetResponseCodeForHideNotification } from './shared/core/enums/ResponseCodes.js';
import { checkGameIsReplied, BOG_LINE_GAME_TYPES, UPDATED_BET_DATA_KEYS, defaultMinOdd, bogLineMinOdd, betSectionIndex } from './shared/core/enums/BogLineGameConfig.js';
import { parseQuery } from './shared/core/helpers/parseQuery.js';
import { wageringStore } from './shared/core/store/wageringStore.js';
import axios__default from 'axios';
import { roundInfoStore } from './shared/core/store/roundInfoStore.js';
import './shared/core/store/userCountStore.js';
import { StatisticsSortingTypes } from './shared/core/enums/StatisticsSortingTypes.js';
import './shared/core/services/sound/types.js';
import './shared/core/services/sound/SoundService.js';
import './shared/core/services/sound/defaultSounds.js';
import { AuthHeaders } from './shared/core/services/api/types.js';
import { BaseApiService } from './shared/core/services/api/BaseApiService.js';
import './shared/core/store/resultHashStore.js';
import './shared/core/store/userWinBetsStore.js';
import { notificationStore } from './shared/core/store/notificationStore.js';
import './shared/core/store/selectedResultInfoStore.js';
import { ApiServices } from './shared/core/services/ApiServices.js';
import { deepCopy } from './shared/core/helpers/deepCopy.js';
import './shared/core/store/forCrashGame/inputValidationStore.js';
import { totalBetStore } from './shared/core/store/forCrashGame/totalBetStore.js';
import { oddStore } from './shared/core/store/forCrashGame/resultReportStore.js';
import { gameStore } from './shared/core/store/forCrashGame/gameStore.js';
import './shared/core/polyfill.js';
import { a as getStartEndDay, m as moment } from './momentFormat-e9197995.js';
import './table-line/t_types/enums/BetResponseCode.js';
import './table-line/t_types/enums/BetErrorMessages.js';
import './table-line/t_types/enums/NotificationByResponseCode.js';
import { FreeChipNames, FreeChipPopupActions } from './table-line/t_types/enums/FreeChipTypes.js';
import { PopUps } from './table-line/t_types/enums/PopupTypes.js';
import { formatDate } from './shared/core/helpers/formatDate.js';
import { isMobile } from './shared/core/helpers/isMobile.js';
import { BOG_GAME_NAMES } from './shared/core/enums/bogGameNames.js';
import { findUpdateHalfData } from './shared/core/helpers/updateHalfBets.js';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var BaseIframeService = /** @class */ (function () {
    function BaseIframeService() {
    }
    BaseIframeService.prototype.sendParentMessage = function (message, targetOrigin, transfer) {
        if (targetOrigin === void 0) { targetOrigin = '*'; }
        window.parent.postMessage(message, targetOrigin, transfer);
    };
    BaseIframeService.prototype.sendTopMessage = function (message, targetOrigin, transfer) {
        var _a;
        if (targetOrigin === void 0) { targetOrigin = '*'; }
        (_a = window.top) === null || _a === void 0 ? void 0 : _a.postMessage(message, targetOrigin, transfer);
    };
    BaseIframeService.prototype.setPostMessageListener = function (messageParams) {
        var _this = this;
        window.addEventListener('message', function (event) {
            _this.handlePostMessages(event, messageParams);
        });
    };
    BaseIframeService.prototype.handlePostMessages = function (event, messageParams) {
        throw new Error('Method not implemented -> handlePostMessages');
    };
    BaseIframeService.prototype.isInIframe = function () {
        try {
            return window.self !== window.top;
        }
        catch (e) {
            console.error(e);
            return true;
        }
    };
    return BaseIframeService;
}());

// Messages where the sender is Game and the receiver is Launcher
var PostMessage;
(function (PostMessage) {
    PostMessage["PgReload"] = "pgReload";
    PostMessage["PgLogout"] = "pgLogout";
    PostMessage["PgLoginCheck"] = "pgLoginCheck";
    PostMessage["PgGameLoaded"] = "pgGameLoaded";
    PostMessage["PgChangeGame"] = "pgChangeGame";
    PostMessage["PgGetAuthInfo"] = "pgGetAuthInfo";
    PostMessage["PgRedirectHome"] = "pgRedirectHome";
    PostMessage["PgRedirectLogin"] = "pgRedirectLogin";
    PostMessage["PgToggleFullscreen"] = "pgToggleFullscreen";
    PostMessage["PgOpenerIconClick"] = "onOpenerIconClick";
    PostMessage["PgOpenSidebar"] = "pgOpenSidebar";
    PostMessage["Reload"] = "reload";
    PostMessage["ExitGame"] = "exitGame";
    PostMessage["OpenMenu"] = "openMenu";
    PostMessage["WinUpdate"] = "winUpdate";
    PostMessage["GameReady"] = "gameReady";
    PostMessage["LoginCheck"] = "loginCheck";
    PostMessage["GameLoaded"] = "gameLoaded";
    PostMessage["GetAuthInfo"] = "getAuthInfo";
    PostMessage["StakeUpdate"] = "stakeUpdate";
    PostMessage["OpenDeposit"] = "openDeposit";
    PostMessage["RoundStarted"] = "roundStarted";
    PostMessage["ErrorReceived"] = "errorReceived";
    PostMessage["RoundFinished"] = "roundFinished";
    PostMessage["UpdateSettings"] = "updateSettings";
    PostMessage["BalanceUpdated"] = "balanceUpdated";
    PostMessage["ActionReceived"] = "actionReceived";
    PostMessage["PlayModeUpdate"] = "playModeUpdate";
    PostMessage["OpenSlotHistory"] = "openSlotHistory";
    PostMessage["AutoPlayStarted"] = "autoPlayStarted";
    PostMessage["AutoPlayFinished"] = "autoPlayFinished";
    PostMessage["JackpotWinUpdate"] = "jackpotWinUpdate";
})(PostMessage || (PostMessage = {}));
// Messages where the sender is Launcher and the receiver is Game
var PostMessageListenerMessages;
(function (PostMessageListenerMessages) {
    PostMessageListenerMessages["PauseGame"] = "pauseGame";
    PostMessageListenerMessages["ResumeGame"] = "resumeGame";
    PostMessageListenerMessages["OpenHistory"] = "openHistory";
    PostMessageListenerMessages["OpenPayTable"] = "openPaytable";
    PostMessageListenerMessages["OpenGameHelp"] = "openGameHelp";
    PostMessageListenerMessages["UpdateBalance"] = "updateBalance";
    PostMessageListenerMessages["StopAutoSpins"] = "stopAutospins";
    PostMessageListenerMessages["AuthInfoUpdate"] = "authInfoUpdate";
    PostMessageListenerMessages["UpdateSettings"] = "updateSettings";
    PostMessageListenerMessages["FullscreenChange"] = "fullscreenChange";
    PostMessageListenerMessages["OpenerIcons"] = "openerIcons";
    PostMessageListenerMessages["ShowSidebarOpener"] = "showSidebarOpener";
})(PostMessageListenerMessages || (PostMessageListenerMessages = {}));

var IframeService$1 = /** @class */ (function (_super) {
    __extends(IframeService, _super);
    function IframeService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // START: PostMessage listeners
        _this.callbackRegistry = {};
        return _this;
        // END: PostMessage listeners
    }
    IframeService.prototype.openTab = function (tab) {
        this.sendTopMessage({ action: 'openSlider', tab: tab });
    };
    IframeService.prototype.openDeposit = function () {
        this.openTab('deposit');
    };
    IframeService.prototype.openLogin = function () {
        this.openTab('login');
    };
    /**
     * @deprecated please use redirect method
     */
    IframeService.prototype.redirection = function (type) {
        if (type === void 0) { type = false; }
        console.warn('redirection method deprecated pls use redirect');
        this.redirect(type);
    };
    IframeService.prototype.redirect = function (type) {
        if (type === void 0) { type = false; }
        type ? this.exitGame() : this.sendLoginCheck();
    };
    IframeService.prototype.exitGame = function () {
        this.sendParentMessage({ name: PostMessage.ExitGame, payload: {} });
    };
    IframeService.prototype.openMenu = function () {
        this.sendParentMessage({ name: PostMessage.OpenMenu, payload: {} });
    };
    IframeService.prototype.sendLoginCheck = function () {
        this.sendParentMessage({ name: PostMessage.LoginCheck, payload: {} });
    };
    // sendLoadedState should change to gameLoaded
    IframeService.prototype.sendLoadedState = function (stakeAmount) {
        this.sendParentMessage({ name: PostMessage.GameLoaded, payload: { stakeAmount: stakeAmount } });
    };
    IframeService.prototype.sendGameReady = function () {
        this.sendParentMessage({ name: PostMessage.GameReady, payload: {} });
    };
    IframeService.prototype.sendWinUpdate = function (winAmount) {
        this.sendParentMessage({ name: PostMessage.WinUpdate, payload: { win: winAmount } });
    };
    IframeService.prototype.sendErrorReceived = function (payload) {
        this.sendParentMessage({ name: PostMessage.ErrorReceived, payload: payload });
    };
    IframeService.prototype.sendStakeUpdate = function (stake) {
        this.sendParentMessage({ name: PostMessage.StakeUpdate, payload: { stake: stake } });
    };
    // change sendReload to reloadFrame
    IframeService.prototype.sendReload = function () {
        this.sendParentMessage({ name: PostMessage.Reload, payload: {} });
    };
    IframeService.prototype.sendPlayModeUpdate = function () {
        this.sendParentMessage({ name: PostMessage.PlayModeUpdate, payload: {} });
    };
    IframeService.prototype.sendGetAuthInfo = function () {
        this.sendParentMessage({ name: PostMessage.GetAuthInfo, payload: {} });
    };
    IframeService.prototype.sendOpenDeposit = function () {
        this.sendParentMessage({ name: PostMessage.OpenDeposit, payload: {} });
    };
    IframeService.prototype.sendRoundStarted = function (balance) {
        this.sendParentMessage({ name: PostMessage.RoundStarted, payload: { balance: balance } });
    };
    IframeService.prototype.sendRoundFinished = function (win, bet) {
        this.sendParentMessage({ name: PostMessage.RoundFinished, payload: { win: win, bet: bet } });
    };
    IframeService.prototype.sendUpdateSettings = function (payload) {
        this.sendParentMessage({ name: PostMessage.UpdateSettings, payload: payload });
    };
    IframeService.prototype.sendBalanceUpdated = function (balance) {
        this.sendParentMessage({ name: PostMessage.BalanceUpdated, payload: { balance: balance } });
    };
    IframeService.prototype.sendActionReceived = function () {
        this.sendParentMessage({ name: PostMessage.ActionReceived, payload: {} });
    };
    IframeService.prototype.sendAutoPlayStarted = function () {
        this.sendParentMessage({ name: PostMessage.AutoPlayStarted, payload: {} });
    };
    IframeService.prototype.sendAutoPlayFinished = function () {
        this.sendParentMessage({ name: PostMessage.AutoPlayFinished, payload: {} });
    };
    IframeService.prototype.sendOpenSlotHistory = function () {
        this.sendParentMessage({ name: PostMessage.OpenSlotHistory, payload: {} });
    };
    IframeService.prototype.sendJackpotWinUpdate = function () {
        this.sendParentMessage({ name: PostMessage.JackpotWinUpdate, payload: {} });
    };
    IframeService.prototype.sendPgChangeGame = function (gameId) {
        this.sendParentMessage({ name: PostMessage.PgChangeGame, gameId: gameId });
    };
    IframeService.prototype.sendToggleFullscreen = function () {
        this.sendParentMessage({ name: PostMessage.PgToggleFullscreen, payload: {} });
    };
    // deprecated
    IframeService.prototype.sendOpenerIconClick = function (type) {
        this.sendParentMessage({ name: PostMessage.PgOpenerIconClick, payload: type });
    };
    IframeService.prototype.sendOpenSidebar = function () {
        this.sendParentMessage({ name: PostMessage.PgOpenSidebar, payload: {} });
    };
    IframeService.prototype.onPauseGame = function (callback) {
        this.callbackRegistry[PostMessageListenerMessages.PauseGame] = callback;
    };
    IframeService.prototype.onResumeGame = function (callback) {
        this.callbackRegistry[PostMessageListenerMessages.ResumeGame] = callback;
    };
    IframeService.prototype.onOpenHistory = function (callback) {
        this.callbackRegistry[PostMessageListenerMessages.OpenHistory] = callback;
    };
    IframeService.prototype.onOpenPayTable = function (callback) {
        this.callbackRegistry[PostMessageListenerMessages.OpenPayTable] = callback;
    };
    IframeService.prototype.onOpenGameHelp = function (callback) {
        this.callbackRegistry[PostMessageListenerMessages.OpenGameHelp] = callback;
    };
    IframeService.prototype.onUpdateBalance = function (callback) {
        this.callbackRegistry[PostMessageListenerMessages.UpdateBalance] = callback;
    };
    IframeService.prototype.onStopAutoSpins = function (callback) {
        this.callbackRegistry[PostMessageListenerMessages.StopAutoSpins] = callback;
    };
    IframeService.prototype.onAuthInfoUpdate = function (callback) {
        this.callbackRegistry[PostMessageListenerMessages.AuthInfoUpdate] = callback;
    };
    IframeService.prototype.onUpdateSettings = function (callback) {
        this.callbackRegistry[PostMessageListenerMessages.UpdateSettings] = callback;
    };
    IframeService.prototype.onFullScreenChange = function (callback) {
        this.callbackRegistry[PostMessageListenerMessages.FullscreenChange] = callback;
    };
    // deprecated
    IframeService.prototype.onOpenerIconsReceive = function (callback) {
        this.callbackRegistry[PostMessageListenerMessages.OpenerIcons] = callback;
    };
    IframeService.prototype.onSidebarOpenerShow = function (callback) {
        this.callbackRegistry[PostMessageListenerMessages.ShowSidebarOpener] = callback;
    };
    IframeService.prototype.handlePostMessages = function (event, messageParams) {
        var name = event.data.name;
        var callback = this.callbackRegistry[name];
        if (callback) {
            return void callback(event.data);
        }
        if (messageParams === null || messageParams === void 0 ? void 0 : messageParams.length) {
            messageParams.forEach(function (param) {
                if (name === param.name) {
                    param.callback(event.data);
                }
            });
        }
    };
    return IframeService;
}(BaseIframeService));

var RoundsService = /** @class */ (function (_super) {
    __extends$1(RoundsService, _super);
    function RoundsService(config) {
        return _super.call(this, config) || this;
    }
    RoundsService.prototype.checkResultHash = function (body, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        var version = options.version;
        var url = "".concat(this.url, "/api/").concat(version, "/Rounds/checkResultHash");
        return httpClient.post(url, body);
    };
    RoundsService.prototype.getGameHighestRounds = function (options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        var version = options.version;
        var url = "".concat(this.url, "/api/").concat(version, "/Rounds/getHighestRounds");
        return httpClient.get(url);
    };
    return RoundsService;
}(BaseApiService));

var BetsService = /** @class */ (function (_super) {
    __extends$1(BetsService, _super);
    function BetsService(config) {
        return _super.call(this, config) || this;
    }
    BetsService.prototype.getBets = function (params, additionalPath, options) {
        if (additionalPath === void 0) { additionalPath = ''; }
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var version, url;
            return __generator(this, function (_a) {
                version = options.version;
                url = "".concat(this.url, "/api/").concat(version, "/Bets").concat(additionalPath);
                return [2 /*return*/, httpClient.get(url, {
                        params: params,
                    })];
            });
        });
    };
    BetsService.prototype.getBetDataByBetId = function (params, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var version, url;
            return __generator(this, function (_a) {
                version = options.version;
                url = "".concat(this.url, "/api/").concat(version, "/Bets/replay");
                return [2 /*return*/, httpClient.get(url, {
                        params: params,
                    })];
            });
        });
    };
    BetsService.prototype.updateFreeBetStatus = function (params, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        var version = options.version;
        var url = "".concat(this.url, "/api/").concat(version, "/FreeBets/").concat(params.freeBetId);
        return httpClient.put(url, {
            params: params,
        });
    };
    return BetsService;
}(BaseApiService));

var StatisticsService = /** @class */ (function (_super) {
    __extends$1(StatisticsService, _super);
    function StatisticsService(config) {
        return _super.call(this, config) || this;
    }
    StatisticsService.prototype.getStatistics = function (params, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var version, url;
            return __generator(this, function (_a) {
                version = options.version;
                url = "".concat(this.url, "/api/").concat(version, "/Statistics");
                return [2 /*return*/, httpClient.get(url, {
                        params: params,
                    })];
            });
        });
    };
    return StatisticsService;
}(BaseApiService));

var UsersService = /** @class */ (function (_super) {
    __extends$1(UsersService, _super);
    function UsersService(config) {
        return _super.call(this, config) || this;
    }
    UsersService.prototype.getBalance = function (options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var version, url;
            return __generator(this, function (_a) {
                version = options.version;
                url = "".concat(this.url, "/api/").concat(version, "/Users/balance");
                return [2 /*return*/, httpClient.get(url)];
            });
        });
    };
    UsersService.prototype.updateUserAvatar = function (avatarId, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var version, url;
            return __generator(this, function (_a) {
                version = options.version;
                url = "".concat(this.url, "/api/").concat(version, "/Users/updateAvatar");
                return [2 /*return*/, httpClient.put(url, { avatarId: avatarId })];
            });
        });
    };
    UsersService.prototype.getReplayUrl = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var platformApiUrl, url;
            return __generator(this, function (_a) {
                platformApiUrl = environmentBuilder().platformApiUrl;
                url = "".concat(platformApiUrl);
                return [2 /*return*/, httpClient.get(url, { params: params })];
            });
        });
    };
    return UsersService;
}(BaseApiService));

var FreeChipService = /** @class */ (function (_super) {
    __extends$1(FreeChipService, _super);
    function FreeChipService(config) {
        return _super.call(this, config) || this;
    }
    FreeChipService.prototype.sendClaimFreeBet = function (id, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var version, url;
            return __generator(this, function (_a) {
                version = options.version;
                url = "".concat(this.url, "/api/").concat(version, "/FreeBets/").concat(id);
                return [2 /*return*/, httpClient.put(url, { id: id })];
            });
        });
    };
    return FreeChipService;
}(BaseApiService));

var ChatService = /** @class */ (function () {
    function ChatService() {
        this.socket = null;
    }
    ChatService.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chatConfig, _a, quickWords, typingNotAllowed, chatSocketUrl, _b, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(!this.socket || (this.socket && this.socket.state !== HubConnectionState.Connected))) return [3 /*break*/, 7];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, this.getChatConfigs()];
                    case 2:
                        chatConfig = _c.sent();
                        _a = chatConfig.data.data, quickWords = _a.quickWords, typingNotAllowed = _a.typingNotAllowed;
                        chatStore.setQuickWords(quickWords);
                        chatStore.setIsTypingNotAllowed(typingNotAllowed); // typingNotAllowed - if false can type
                        if (!chatConfig) return [3 /*break*/, 4];
                        chatSocketUrl = environmentBuilder().chatSocketUrl;
                        _b = this;
                        return [4 /*yield*/, new BaseLiveConnection(chatSocketUrl).init()];
                    case 3:
                        _b.socket = _c.sent();
                        this.socketEventsListeners();
                        this.invokeInitialSocketEvents();
                        chatStore.setIsShowChat(true);
                        _c.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _c.sent();
                        if (process.env.REACT_APP_ENV !== EnvironmentTypes.Production) {
                            console.log(e_1, 'Chat service failed to connect');
                        }
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        if (this.socket && this.socket.state === HubConnectionState.Connected) {
                            this.invokeInitialSocketEvents();
                        }
                        _c.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ChatService.prototype.getChatConfiguration = function (params, options) {
        if (options === void 0) { options = { version: ApiVersion.v1 }; }
        return __awaiter(this, void 0, void 0, function () {
            var chatHttpUrl, version, url;
            return __generator(this, function (_a) {
                chatHttpUrl = environmentBuilder().chatHttpUrl;
                version = options.version;
                url = "".concat(chatHttpUrl, "/api/").concat(version, "/Chat/Configuration");
                return [2 /*return*/, httpClient.get(url, {
                        params: params,
                    })];
            });
        });
    };
    ChatService.prototype.invokeInitialSocketEvents = function () {
        this.joinRoom();
        this.getChatHistory();
    };
    ChatService.prototype.socketEventsListeners = function () {
        this.socket.on(ChatSocketEvents.GetChatHistoryResult, chatStore.setChatMessageHistory);
        this.socket.on(ChatSocketEvents.ReceiveMessage, this.getMessage);
    };
    ChatService.prototype.joinRoom = function () {
        var gameTypeId = gameConfigStore.gameTypeId;
        this.socket.invoke(ChatSocketEvents.JoinRoom, +gameTypeId);
    };
    ChatService.prototype.getChatHistory = function () {
        var gameTypeId = gameConfigStore.gameTypeId;
        this.socket.invoke(ChatSocketEvents.GetChatHistory, +gameTypeId);
    };
    ChatService.prototype.leaveRoom = function (gameTypeId) {
        if (this.socket && this.socket.state === HubConnectionState.Connected) {
            this.socket.invoke(ChatSocketEvents.LeaveRoom, +gameTypeId);
            chatStore.updateUnReadCount(0);
        }
    };
    ChatService.prototype.getMessage = function (receivedMessageData) {
        if (receivedMessageData) {
            var unReadCount = chatStore.unReadCount;
            chatStore.updateChatMessageData(receivedMessageData);
            chatStore.updateUnReadCount(unReadCount + 1);
        }
    };
    ChatService.prototype.updateAdditionalData = function (gameTypeId, additionalData) {
        this.socket.invoke(ChatSocketEvents.UpdateAdditionalData, { additionalData: additionalData, gameTypeId: gameTypeId });
    };
    ChatService.prototype.sendMessage = function (data) {
        if (this.socket && this.socket.state === HubConnectionState.Connected) {
            this.socket.invoke(ChatSocketEvents.SendMessage, data);
        }
    };
    ChatService.prototype.getChatConfigs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var gameId;
            return __generator(this, function (_a) {
                gameId = gameConfigStore.gameId;
                return [2 /*return*/, ApiServices.get(ApiServiceTypes.ChatService).getChatConfiguration({ gameId: gameId })];
            });
        });
    };
    ChatService.prototype.closeConnection = function () {
        if (this.socket) {
            this.socket.stop();
        }
    };
    return ChatService;
}());
var chatService = new ChatService();

var httpClient = axios__default.create({
    withCredentials: true,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-type': 'application/json',
    },
});
var betsRequests = [];
var setHttpClientInterceptors = function () {
    httpClient.interceptors.request.use(function (config) {
        var token = applicationStore.accessToken, isBogLine = applicationStore.isBogLine;
        var isUsedBogLineComponents = platformMessageStore.isUsedBogLineComponents;
        var accessToken = token ? "".concat(AuthHeaders.Bearer, " ").concat(token) : '';
        if (accessToken) {
            config.headers[AuthHeaders.Authorization] = accessToken;
        }
        if (config.url.includes(PathsForCancellationPrevRequests.Bets) && isBogLine && isUsedBogLineComponents) {
            // Cancel all previous "/Bets" requests
            betsRequests.forEach(function (request) {
                request.cancel();
            });
            // Clear the requests array and add the current request
            betsRequests = [axios__default.CancelToken.source()];
            // Attach the cancel token to the request config
            config.cancelToken = betsRequests[0].token;
        }
        else {
            // For other requests, add to the requests array without canceling
            betsRequests.push(axios__default.CancelToken.source());
            config.cancelToken = betsRequests[betsRequests.length - 1].token;
        }
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
    httpClient.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        return Promise.reject(error);
    });
};

// Object { name , payload? }
//
// gameLoaded -  +
//   roundStarted {name, balance: number} +
// balancdeUpdated  - { name: balancdeUpdated  ,  payload : { balance: number } } +
// roundFinished -> roundFinished, {name, payload: totalWinAmount}, in round game, resultReport in turbo games +
// exitGame -> redirectHome +
// updateSettings   - payload : { sound?: boolean , fastPlay?: boolean } -> updateLocalStorage
// stakeUpdate - payload { stake: number } -> useInputValue
// winUpdate -  payload { winAmount: number } -> roundFinished, cashOutResult
// jackpotWinUpdate - payload { winAmount: number } ->
// openMenu ?
// playModeUpdate  - payload { playMode :  normal,autoSpin,freeSpin,bonussRound } freespin and autospin together?
// openDeposit ( ete uzenan unenanq )
// actionReceived  payload { actionName : realityCheckAck• errorMessageDismissed• menuOpened• menuClosed• errorMessageDisplayed• exitingGame• toggleBasicStrategy• gameHelp• continue• endSession }
// loginCheck -  +
//   getAuthInfo - +
//   reload - +
//   openSlotHistory - +
//
//   pauseGame,
//   resumeGame,
//   updateBalance,
// updateSettings   - payload : { sound?: boolean , fastPlay?: boolean },
// openPaytable
// openGameHelp
var IframeService = /** @class */ (function (_super) {
    __extends$1(IframeService, _super);
    function IframeService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // public reloadFrame(): void {
    //   this.sendParentMessage(PostMessage.PgReload);
    // }
    //
    // public logout(): void {
    //   this.sendParentMessage(PostMessage.PgLogout);
    // }
    //
    // public sendLoadedState(): void {
    //   this.sendParentMessage(PostMessage.PgGameLoaded);
    // }
    //
    // public sendGetAuthInfo(): void {
    //   this.sendParentMessage(PostMessage.PgGetAuthInfo);
    // }
    //
    // public sendPgLogin(): void {
    //   this.sendParentMessage(PostMessage.PgLoginCheck);
    // }
    // public redirectLogin(): void {
    //   this.sendParentMessage(PostMessage.PgRedirectLogin);
    // }
    // public redirectHome(): void {
    //   this.sendParentMessage(PostMessage.PgRedirectHome);
    // }
    /**
     * Start Integration postMessages
     */
    IframeService.prototype.sendParentMessageForFullscreen = function () {
        this.sendToggleFullscreen();
    };
    // sendLoadedState should change to gameLoaded
    IframeService.prototype.sendLoadedState = function (userId) {
        var _a;
        if (userId === void 0) { userId = userInfoStore.userId; }
        var bogLineGameTypeData = platformMessageStore.bogLineGameTypeData;
        var limits = gameConfigStore.limits;
        var liveBets = betStore.liveBets;
        var totalStakeAmount = ((_a = liveBets === null || liveBets === void 0 ? void 0 : liveBets.filter(function (item) { return +(item === null || item === void 0 ? void 0 : item.userId) === +(userInfoStore === null || userInfoStore === void 0 ? void 0 : userInfoStore.userId); })) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, curr) { return acc + parseNumberByPrecision(curr === null || curr === void 0 ? void 0 : curr.amount, 1); }, 0)) ||
            multiply(Number(bogLineGameTypeData === null || bogLineGameTypeData === void 0 ? void 0 : bogLineGameTypeData.sectionCount), Number((limits === null || limits === void 0 ? void 0 : limits.defaultBetAmount) || (limits === null || limits === void 0 ? void 0 : limits.minBet)));
        if (bogLineGameTypeData.isUsedPlatformIntegrationLogic) {
            this.checkSoundAndSendUpdateSettings({
                isMusicOn: userSettingsStore.isMusicOn,
                isSoundOn: userSettingsStore.isSoundOn,
                prevValue: platformMessageStore.sentSoundValue,
            });
        }
        if (process.env.REACT_APP_ENV === EnvironmentTypes.Development &&
            applicationStore.isBogLine &&
            +userId === +(userInfoStore === null || userInfoStore === void 0 ? void 0 : userInfoStore.userId)) {
            console.log(toJS(totalStakeAmount), toJS({ name: PostMessage.GameLoaded, payload: { stakeAmount: totalStakeAmount } }), "---> sendLoadedState ".concat(userInfoStore.userId));
        }
        this.sendParentMessage({ name: PostMessage.GameLoaded, payload: { stakeAmount: totalStakeAmount } });
        this.sendParentMessage({ name: PostMessage.GameReady, payload: {} });
        platformMessageStore.setIsGameLoading(false);
    };
    IframeService.prototype.sendWinUpdate = function (winAmount) {
        if (process.env.REACT_APP_ENV === EnvironmentTypes.Development && applicationStore.isBogLine) {
            console.log(toJS({ name: PostMessage.WinUpdate, payload: { win: winAmount } }), "----> sendWinUpdate ".concat(userInfoStore === null || userInfoStore === void 0 ? void 0 : userInfoStore.userId));
        }
        this.sendParentMessage({ name: PostMessage.WinUpdate, payload: { win: winAmount } });
    };
    IframeService.prototype.sendErrorReceived = function (payload) {
        if (process.env.REACT_APP_ENV === EnvironmentTypes.Development && applicationStore.isBogLine) {
            console.log(toJS({ name: PostMessage.ErrorReceived, payload: payload }), "----> sendErrorReceived ".concat(userInfoStore.userId));
        }
        this.sendParentMessage({ name: PostMessage.ErrorReceived, payload: payload });
    };
    IframeService.prototype.sendStakeUpdate = function (stake) {
        if (process.env.REACT_APP_ENV === EnvironmentTypes.Development && applicationStore.isBogLine) {
            console.log(toJS({ name: PostMessage.StakeUpdate, payload: { stake: stake } }), "----> sendStakeUpdate ".concat(userInfoStore.userId));
        }
        this.sendParentMessage({ name: PostMessage.StakeUpdate, payload: { stake: stake } });
    };
    IframeService.prototype.sendRoundStarted = function (balance) {
        platformMessageStore.setIsSentRoundStarted(true);
        if (platformMessageStore.isUsedRoundStartAndFinishedLogicAfterCashOut) {
            platformMessageStore.updateTotalWinAmount(null);
        }
        if (process.env.REACT_APP_ENV === EnvironmentTypes.Development && applicationStore.isBogLine) {
            console.log({
                name: PostMessage.RoundStarted,
                payload: { balance: balance ? balance : userInfoStore.balance },
            }, " ---> sendRoundStarted ".concat(userInfoStore.userId));
        }
        this.sendParentMessage({
            name: PostMessage.RoundStarted,
            payload: { balance: balance ? balance : userInfoStore.balance },
        });
    };
    IframeService.prototype.sendRoundFinished = function (win, totalAmount, roundFinishedBets) {
        var _this = this;
        var _a, _b;
        if (roundFinishedBets === void 0) { roundFinishedBets = null; }
        var setTotalAcceptedBetsAmount = platformMessageStore.setTotalAcceptedBetsAmount, isUsedStakeUpdateLogic = platformMessageStore.bogLineGameTypeData.isUsedStakeUpdateLogic, isUsedRoundStartAndFinishedLogicAfterCashOut = platformMessageStore.isUsedRoundStartAndFinishedLogicAfterCashOut, setIsSentRoundStarted = platformMessageStore.setIsSentRoundStarted;
        var liveBets = betStore.liveBets;
        var totalAcceptedBetsAmount = (_b = (_a = (roundFinishedBets || liveBets)) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return +(item === null || item === void 0 ? void 0 : item.userId) === +(userInfoStore === null || userInfoStore === void 0 ? void 0 : userInfoStore.userId); })) === null || _b === void 0 ? void 0 : _b.reduce(function (acc, curr) { return +toFixed(acc + (curr === null || curr === void 0 ? void 0 : curr.amount)); }, 0);
        setIsSentRoundStarted(false);
        if (!isUsedRoundStartAndFinishedLogicAfterCashOut && isUsedStakeUpdateLogic) {
            this.sendStakeUpdate(0);
        }
        if (process.env.REACT_APP_ENV === EnvironmentTypes.Development && applicationStore.isBogLine) {
            console.log({ name: PostMessage.RoundFinished, payload: { win: win, bet: totalAmount || totalAcceptedBetsAmount } }, "---> sendRoundFinished ".concat(userInfoStore.userId));
        }
        if (platformMessageStore.delayForPostMessageRoundFinished > 0) {
            setTimeout(function () {
                _this.sendParentMessage({
                    name: PostMessage.RoundFinished,
                    payload: { win: win, bet: totalAmount || totalAcceptedBetsAmount },
                });
            }, platformMessageStore.delayForPostMessageRoundFinished);
        }
        else {
            this.sendParentMessage({
                name: PostMessage.RoundFinished,
                payload: { win: win, bet: totalAmount || totalAcceptedBetsAmount },
            });
        }
        if (isUsedStakeUpdateLogic) {
            setTotalAcceptedBetsAmount(0);
        }
    };
    IframeService.prototype.sendUpdateSettings = function (payload) {
        if (process.env.REACT_APP_ENV === EnvironmentTypes.Development && applicationStore.isBogLine) {
            console.log({ name: PostMessage.UpdateSettings, payload: payload }, " ----> sendUpdateSettings ".concat(userInfoStore.userId));
        }
        platformMessageStore.updateSentSoundValue(payload.sound);
        this.sendParentMessage({ name: PostMessage.UpdateSettings, payload: payload });
    };
    IframeService.prototype.checkSoundAndSendUpdateSettings = function (soundData) {
        var isSoundOn = soundData.isSoundOn, isMusicOn = soundData.isMusicOn, prevValue = soundData.prevValue;
        var sound = !!(isSoundOn && isMusicOn);
        if (prevValue === null || sound !== prevValue) {
            this.sendUpdateSettings({ sound: sound });
        }
    };
    IframeService.prototype.checkAndSendAutoPlayState = function (autoPlayState) {
        if (autoPlayState) {
            if (!platformMessageStore.isAutoPlayedStarted) {
                this.sendAutoPlayStarted();
                platformMessageStore.setIsAutoPlayedStarted(true);
            }
        }
        else {
            if (platformMessageStore.isAutoPlayedStarted) {
                this.sendAutoPlayFinished();
                platformMessageStore.setIsAutoPlayedStarted(false);
            }
        }
    };
    IframeService.prototype.setPostMessageListener = function (messageParams) {
        if (!this.isInIframe()) {
            applicationStore.setIsAuthDataReceived(true);
        }
        else {
            window.addEventListener('message', function (message) {
                var _a, _b, _c, _d;
                if (message.data && message.data.name === PostMessageListenerMessages.AuthInfoUpdate) {
                    if (process.env.REACT_APP_ENV === EnvironmentTypes.Development && applicationStore.isBogLine) {
                        console.log(message.data, "----> AuthInfoUpdate ".concat(userInfoStore.userId));
                    }
                    // @ts-ignore when Xuch updated iframeService
                    var _e = message.data, accessToken = _e.accessToken, isAuthenticated = _e.isAuthenticated, isOperatorHandlesErrors = _e.isOperatorHandlesErrors; // todo
                    platformMessageStore.setIsShowAllNotification(!isOperatorHandlesErrors);
                    applicationStore.setIsAuthenticated(isAuthenticated);
                    applicationStore.setIsDemo(!isAuthenticated);
                    applicationStore.setAccessToken(accessToken);
                    setHttpClientInterceptors();
                    applicationStore.setIsAuthDataReceived(true);
                    checkGameIsReplied(window.location.pathname) && platformMessageStore.setIsRepliedGame(true);
                }
                if (message.data && message.data.name === PostMessageListenerMessages.UpdateSettings) {
                    var sound = message.data.payload.sound;
                    if (process.env.REACT_APP_ENV === EnvironmentTypes.Development && applicationStore.isBogLine) {
                        console.log(message.data, "----> UpdateSettings ".concat(userInfoStore.userId));
                    }
                    userSettingsStore.setIsMusicOnAndIsSoundOn(!sound, true);
                }
                if (message.data &&
                    message.data.name === PostMessageListenerMessages.UpdateBalance &&
                    (messageParams === null || messageParams === void 0 ? void 0 : messageParams.length) &&
                    !messageParams.some(function (item) { return item.name === PostMessageListenerMessages.UpdateBalance; })) {
                    (_a = userSettingsStore === null || userSettingsStore === void 0 ? void 0 : userSettingsStore.gameLiveConnection) === null || _a === void 0 ? void 0 : _a.getBalance();
                }
                if (message.data && message.data.name === PostMessageListenerMessages.OpenHistory) {
                    platformMessageStore.setIsOpenBetHistorySection(true);
                }
                if (message.data && message.data.name === PostMessageListenerMessages.OpenGameHelp) {
                    if (platformMessageStore.isOpenOddsSection) {
                        platformMessageStore.setIsOpenOddsSection(false);
                    }
                    if (platformMessageStore.isUsedBogLineComponents) {
                        popupStore.popupToggle ? popupStore.close() : popupStore.open({});
                    }
                    platformMessageStore.setIsOpenGameHelpSection(!platformMessageStore.isOpenGameHelpSection);
                }
                if (message.data && message.data.name === PostMessageListenerMessages.OpenPayTable) {
                    if (process.env.REACT_APP_ENV === EnvironmentTypes.Development) {
                        console.log(message.data, "----> ".concat(PostMessageListenerMessages.OpenPayTable, " ---- state ---- ").concat(platformMessageStore.isOpenOddsSection));
                    }
                    platformMessageStore.setIsOpenOddsSection(!platformMessageStore.isOpenOddsSection);
                    if (platformMessageStore.isUsedBogLineComponents) {
                        popupStore.popupToggle ? popupStore.close() : popupStore.open({});
                    }
                    if (lobbyStore.isShowLobbySelectGameType) {
                        // THIS PART OF CODE IS FOR BRAZIL CERTIFICATION
                        lobbyStore.setIsShowLobbySelectGameType(false);
                    }
                }
                if (message.data && message.data.name === PostMessageListenerMessages.ResumeGame) {
                    (_b = userSettingsStore === null || userSettingsStore === void 0 ? void 0 : userSettingsStore.gameLiveConnection) === null || _b === void 0 ? void 0 : _b.stop();
                    platformMessageStore.setIsGamePaused(true);
                    lobbyStore.setIsShowGameTypeLoading(true);
                    setTimeout(function () { return lobbyStore.setIsShowGameTypeLoading(false); }, 3000);
                    popupStore.toggleReconnect(false);
                    popupStore.onConnectionError(false);
                    applicationStore.setGameIsOpen(false);
                    !platformMessageStore.isUsedBogLineComponents && popupStore.close();
                    (_c = userSettingsStore.liveConnection) === null || _c === void 0 ? void 0 : _c.handleSocketInit((_d = window.location) === null || _d === void 0 ? void 0 : _d.pathname);
                    platformMessageStore.setIsGamePaused(false);
                }
                if (message.data && message.data.name === PostMessageListenerMessages.PauseGame) {
                    // const { sound, fastPlay } = message.data.payload;
                    // userSettingsStore.setIsSoundAndMusicMute(sound);
                    popupStore.close();
                    !platformMessageStore.isGamePaused && userSettingsStore.gameLiveConnection.stop();
                    platformMessageStore.setIsGamePaused(true);
                    if (!applicationStore.gameIsOpen) {
                        popupStore.toggleReconnect();
                        !platformMessageStore.isUsedBogLineComponents && popupStore.open({ name: PopUps.Reconnect });
                        popupStore.toggleReconnect(true);
                    }
                }
                if (message.data && message.data.name === PostMessageListenerMessages.ShowSidebarOpener) {
                    var notifCount = message.data.payload.notifCount;
                    gameConfigStore.setIsShowSideBarButton(true);
                    gameConfigStore.setSideBarButtonNotificationCount(notifCount);
                }
                if (messageParams && messageParams.length) {
                    messageParams.forEach(function (_a) {
                        var name = _a.name, callback = _a.callback;
                        if (message.data && message.data.name === name) {
                            callback(message.data);
                        }
                    });
                }
            });
        }
    };
    return IframeService;
}(IframeService$1));
var iframeService = new IframeService();

var parseNumberByPrecision = function (num1, num2, precision) {
    var _a, _b;
    if (precision === void 0) { precision = +userInfoStore.precision || 2; }
    var re = new RegExp("^-?\\d+(?:.\\d{0,".concat(precision, "})?"));
    var digitsAfterDotAtNum1 = ((_a = num1.toString().split('.')[1]) === null || _a === void 0 ? void 0 : _a.length) || 0;
    var digitsAfterDotAtNum2 = ((_b = num2.toString().split('.')[1]) === null || _b === void 0 ? void 0 : _b.length) || 0;
    var digitsCountAfterDot = digitsAfterDotAtNum2 + digitsAfterDotAtNum1;
    var result;
    var numMulti = (Math.round(num1 * Math.pow(10, digitsCountAfterDot)) * Math.round(num2 * Math.pow(10, digitsCountAfterDot))) /
        Math.pow(10, (digitsCountAfterDot + digitsCountAfterDot));
    result = numMulti.toString().match(re) && +numMulti.toString().match(re)[0];
    return result;
};

var toDecimal = function (num) {
    if (num === void 0) { num = 0; }
    var strNum = num.toString();
    var _a = __read(strNum.split('.'), 2), _b = _a[0], leftSide = _b === void 0 ? '' : _b, _c = _a[1], rightSide = _c === void 0 ? '' : _c;
    return [Number("".concat(leftSide).concat(rightSide)), Math.pow(10, rightSide.length)];
};
var multiply = function (num_1, num_2) {
    if (num_1 === void 0) { num_1 = 0; }
    if (num_2 === void 0) { num_2 = 0; }
    var _a = __read(toDecimal(num_1), 2), int_1 = _a[0], pow_1 = _a[1];
    var _b = __read(toDecimal(num_2), 2), int_2 = _b[0], pow_2 = _b[1];
    return (int_1 * int_2) / (pow_1 * pow_2);
};
var divide = function (num_1, num_2) {
    if (num_1 === void 0) { num_1 = 0; }
    if (num_2 === void 0) { num_2 = 0; }
    var _a = __read(toDecimal(num_1), 2), int_1 = _a[0], pow_1 = _a[1];
    var _b = __read(toDecimal(num_2), 2), int_2 = _b[0], pow_2 = _b[1];
    var internalDivide = function (a, b) { return a * Math.pow(b, -1); }; // A denominator is simply a number to the power of negative 1.
    return internalDivide(internalDivide(int_1, int_2), internalDivide(pow_1, pow_2));
};
var calculateBaseNumber = function (num_1, num_2) {
    var getRightSideLength = function (num) { return (num.toString().split('.')[1] || '').length; };
    return Math.pow(10, Math.max(getRightSideLength(num_1), getRightSideLength(num_2)));
};
var plus = function (num_1, num_2) {
    if (num_1 === void 0) { num_1 = 0; }
    if (num_2 === void 0) { num_2 = 0; }
    var baseNum = calculateBaseNumber(num_1, num_2);
    return divide(multiply(num_1, baseNum) + multiply(num_2, baseNum), baseNum);
};
var minus = function (num_1, num_2) {
    var baseNum = calculateBaseNumber(num_1, num_2);
    return divide(multiply(num_1, baseNum) - multiply(num_2, baseNum), baseNum);
};
var toFixed = function (num, precision, isNeedRightSide) {
    if (num === void 0) { num = 2; }
    var precisionPoint = precision || +userInfoStore.precision || 2;
    var numberAfterDots = null;
    if (isNeedRightSide) {
        numberAfterDots = Array.from({ length: precisionPoint }, function () { return '0'; }).join('');
    }
    var strNum = num.toString();
    var _a = __read(strNum.split('.'), 2), leftSide = _a[0], rightSide = _a[1];
    var rSide = rightSide ? ".".concat(rightSide.slice(0, precisionPoint)) : isNeedRightSide ? numberAfterDots : '';
    return Number("".concat(leftSide).concat(rSide));
};
// export const toFixed = (num: number = 2, precision?: number): string | number => {
//   const precisionPoint: number = precision || +userInfoStore.precision || 2;
//
//   const getRightSide = (currentRightSide: string): string => {
//     if (currentRightSide?.length >= precisionPoint) {
//       return `.${currentRightSide.slice(0, precisionPoint)}`;
//     }
//
//     const numberAfterDots = Array.from(
//       {
//         length: precisionPoint - (currentRightSide?.length || 0),
//       },
//       () => '0'
//     ).join('');
//
//     if (currentRightSide) {
//       return `.${currentRightSide}${numberAfterDots}`;
//     }
//
//     return `${numberAfterDots}`;
//   };
//
//   const strNum: string = num.toString();
//   const [leftSide, rightSide] = strNum.split('.');
//   const rSide = getRightSide(rightSide);
//
//   return `${leftSide}${rSide}`;
// };

var AMOUNT = 'amount';
var WIN_AMOUNT_KEY = 'winAmount';
var FREE_BET_WIN_AMOUNT_KEY = 'freeBetWinAmount';
var freeBetsWinData = [];
var isObject = function (value) { return typeof value === 'object' && value !== null; };
var calculateSumByKey = function (array, key) {
    return array === null || array === void 0 ? void 0 : array.reduce(function (sum, item) { return +toFixed(sum + (item[key] || 0)); }, 0);
};
var calculateTotalBetAmount = function (bet) {
    var _a, _b, _c;
    if (Array.isArray((bet === null || bet === void 0 ? void 0 : bet.betData) || (bet === null || bet === void 0 ? void 0 : bet.additionalParams))) {
        return +calculateSumByKey(__spreadArray([], __read(((bet === null || bet === void 0 ? void 0 : bet.betData) || (bet === null || bet === void 0 ? void 0 : bet.additionalParams))), false), AMOUNT);
    }
    else if (isObject(bet === null || bet === void 0 ? void 0 : bet.additionalParams) && Array.isArray(((_a = bet === null || bet === void 0 ? void 0 : bet.betData) === null || _a === void 0 ? void 0 : _a.markets) || (bet === null || bet === void 0 ? void 0 : bet.additionalParams.markets))) {
        return +calculateSumByKey(__spreadArray([], __read((((_b = bet === null || bet === void 0 ? void 0 : bet.betData) === null || _b === void 0 ? void 0 : _b.markets) || bet.additionalParams.markets)), false), AMOUNT);
    }
    return +(bet === null || bet === void 0 ? void 0 : bet.amount) || ((_c = bet === null || bet === void 0 ? void 0 : bet.betResult) === null || _c === void 0 ? void 0 : _c.amount);
};
var calculateSumByFreeBet = function (freeBetId, data) {
    var _a;
    if (Array.isArray(data)) {
        return data === null || data === void 0 ? void 0 : data.reduce(function (sum, item) {
            if (!sum[freeBetId]) {
                sum[freeBetId] = item.winAmount;
            }
            else {
                sum[freeBetId] += item.winAmount;
                sum[freeBetId] = +toFixed(sum[freeBetId]);
            }
            return sum;
        }, {});
    }
    return _a = {},
        _a[freeBetId] = data.winAmount,
        _a;
};
var calculateTotalWinAmount = function (bets) {
    var _a;
    freeBetsWinData = [];
    var convertedBets = bets === null || bets === void 0 ? void 0 : bets.filter(function (bet) { return (bet === null || bet === void 0 ? void 0 : bet.userId) === Number(userInfoStore.userId) && (bet === null || bet === void 0 ? void 0 : bet.status) === BetStatus.Win; }).map(function (bet) {
        var _a, _b, _c;
        var _d;
        if (Array.isArray(bet === null || bet === void 0 ? void 0 : bet.additionalParams) && (bet === null || bet === void 0 ? void 0 : bet.additionalParams[0].hasOwnProperty('winAmount'))) {
            var updatedAdditionalParams = (_d = __spreadArray([], __read(bet.additionalParams), false)) === null || _d === void 0 ? void 0 : _d.map(function (item) {
                var _a;
                if (item === null || item === void 0 ? void 0 : item.winAmount) {
                    return __assign(__assign({}, item), (_a = {}, _a[WIN_AMOUNT_KEY] = item.winAmount, _a));
                }
                return item;
            });
            return __assign(__assign({}, bet), (_a = {}, _a[WIN_AMOUNT_KEY] = calculateSumByKey(updatedAdditionalParams, WIN_AMOUNT_KEY), _a));
        }
        else if (isObject(bet === null || bet === void 0 ? void 0 : bet.additionalParams) && Array.isArray(bet.additionalParams.markets)) {
            return __assign(__assign({}, bet), (_b = {}, _b[WIN_AMOUNT_KEY] = calculateSumByKey(bet.additionalParams.markets, WIN_AMOUNT_KEY), _b));
        }
        return __assign(__assign({}, bet), (_c = {}, _c[WIN_AMOUNT_KEY] = bet.winAmount, _c));
    });
    var betsWinData = calculateSumByKey(convertedBets, WIN_AMOUNT_KEY);
    var freeBetsData = convertedBets.filter(function (item) { return item.freeBetId && item.winAmount; });
    freeBetsData.forEach(function (el) {
        if (Array.isArray(el === null || el === void 0 ? void 0 : el.additionalParams)) {
            freeBetsWinData.push(calculateSumByFreeBet(el.freeBetId, el.additionalParams));
        }
        else if (isObject(el === null || el === void 0 ? void 0 : el.additionalParams) && Array.isArray(el.additionalParams.markets)) {
            freeBetsWinData.push(calculateSumByFreeBet(el.freeBetId, el.additionalParams.markets));
        }
        else {
            freeBetsWinData.push(calculateSumByFreeBet(el.freeBetId, el));
        }
    });
    return _a = {},
        _a[WIN_AMOUNT_KEY] = betsWinData,
        _a[FREE_BET_WIN_AMOUNT_KEY] = freeBetsWinData,
        _a;
};

var checkAndSendStakeUpdate = function (doBetResultListenerData, currentUserId, sendStakeUpdate) {
    var amount = doBetResultListenerData.amount, _a = doBetResultListenerData.betData, betData = _a === void 0 ? null : _a, _b = doBetResultListenerData.userId, userId = _b === void 0 ? null : _b;
    if (Number(userId) === currentUserId) {
        if (Array.isArray(betData)) {
            var totalBetAmount = betData === null || betData === void 0 ? void 0 : betData.reduce(function (acc, curr) {
                if (curr === null || curr === void 0 ? void 0 : curr.amount) {
                    return acc + parseNumberByPrecision(curr === null || curr === void 0 ? void 0 : curr.amount, 1);
                }
                return acc;
            }, 0);
            sendStakeUpdate(Number(totalBetAmount));
        }
        else {
            sendStakeUpdate(Number(amount));
        }
    }
};
var checkCashOutResultAndUpdateGameSectionData = function (cashOutResultListener, updateGameSectionData, currentUserId, gameType, isAllSectionWithCashOutButton, gameSectionData, isUsedRoundStartAndFinishedLogicAfterCashOut, liveBets, updateTotalWinAmount, totalAcceptedBetsAmount, isUsedStakeUpdateLogic, setTotalAcceptedBetsAmount) {
    var _a, _b;
    var _c, _d, _e, _f;
    var userId = cashOutResultListener.userId, winAmount = cashOutResultListener.winAmount, additionalParams = cashOutResultListener.additionalParams, amount = cashOutResultListener.amount;
    var ONLY_CRASH = BOG_LINE_GAME_TYPES.ONLY_CRASH, MARKET_AND_CRASH = BOG_LINE_GAME_TYPES.MARKET_AND_CRASH;
    var sendStakeUpdateAfterCashOut = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (isUsedStakeUpdateLogic) {
            var isHalfCashOut_1 = ((_a = additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.cashOutInfos) === null || _a === void 0 ? void 0 : _a.length) && ((_b = additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.cashOutInfos) === null || _b === void 0 ? void 0 : _b.length) === 1;
            var isFullCashOutWithHalf = ((_c = additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.cashOutInfos) === null || _c === void 0 ? void 0 : _c.length) && ((_d = additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.cashOutInfos) === null || _d === void 0 ? void 0 : _d.length) === 2;
            var currentAmount = isHalfCashOut_1
                ? (_f = (_e = additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.cashOutInfos) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.amount
                : isFullCashOutWithHalf
                    ? (_h = (_g = additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.cashOutInfos) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.amount
                    : amount;
            iframeService.sendStakeUpdate(toFixed(minus(+totalAcceptedBetsAmount, +currentAmount)));
            setTotalAcceptedBetsAmount(+totalAcceptedBetsAmount - +currentAmount);
        }
    };
    ((_c = additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.cashOutInfos) === null || _c === void 0 ? void 0 : _c.length) && ((_d = additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.cashOutInfos) === null || _d === void 0 ? void 0 : _d.length) === 1;
    if (currentUserId === Number(userId)) {
        if (gameType === ONLY_CRASH) {
            // const myBets = liveBets.filter((bet) => +bet?.userId === +currentUserId);
            // const haveActiveBet =
            //   myBets &&
            //   myBets?.length > 1 &&
            //   myBets?.find(
            //     (item) => item?.additionalParams?.index !== additionalParams?.index && item?.statuse === BetStatus.Pending
            //   );
            if (isUsedRoundStartAndFinishedLogicAfterCashOut) {
                if ((_f = (_e = platformMessageStore.gameSectionsData) === null || _e === void 0 ? void 0 : _e.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.index) !== (additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.index) && (item === null || item === void 0 ? void 0 : item.isBetAccepted); })) === null || _f === void 0 ? void 0 : _f.length) {
                    iframeService.sendWinUpdate(+platformMessageStore.totalWinAmount + winAmount);
                    updateTotalWinAmount(winAmount);
                }
                else {
                    iframeService.sendRoundFinished(winAmount + +platformMessageStore.totalWinAmount);
                }
            }
            else {
                iframeService.sendWinUpdate(+platformMessageStore.totalWinAmount + winAmount);
                updateTotalWinAmount(winAmount);
                sendStakeUpdateAfterCashOut();
            }
            updateGameSectionData((_a = {}, _a[UPDATED_BET_DATA_KEYS.isBetAccepted] = false, _a), isAllSectionWithCashOutButton ? additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.index : 0);
        }
        else if (gameType === MARKET_AND_CRASH) {
            sendStakeUpdateAfterCashOut();
            iframeService.sendWinUpdate(+(platformMessageStore === null || platformMessageStore === void 0 ? void 0 : platformMessageStore.totalWinAmount) + winAmount);
            updateTotalWinAmount(winAmount);
            updateGameSectionData((_b = {}, _b[UPDATED_BET_DATA_KEYS.isBetAccepted] = false, _b), isAllSectionWithCashOutButton ? additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.index : 0);
        }
    }
};
var checkResultReportDataAndUpdateGameSectionData = function (resultReportListenerData, updateGameSectionData, currentUserId, gameType, isAllSectionWithCashOutButton, gameSectionData, isUsedRoundStartAndFinishedLogicAfterCashOut, liveBets, updateTotalWinAmount, totalAcceptedBetsAmount, isUsedStakeUpdateLogic, setTotalAcceptedBetsAmount) {
    var bets = resultReportListenerData.data.bets;
    if (bets === null || bets === void 0 ? void 0 : bets.length) {
        var myBets = bets === null || bets === void 0 ? void 0 : bets.filter(function (bet) { return Number(bet.userId) === currentUserId; });
        if (myBets === null || myBets === void 0 ? void 0 : myBets.length) {
            myBets === null || myBets === void 0 ? void 0 : myBets.forEach(function (item) {
                checkCashOutResultAndUpdateGameSectionData(item, updateGameSectionData, currentUserId, gameType, isAllSectionWithCashOutButton, gameSectionData, isUsedRoundStartAndFinishedLogicAfterCashOut, liveBets, updateTotalWinAmount, totalAcceptedBetsAmount, isUsedStakeUpdateLogic, setTotalAcceptedBetsAmount);
            });
        }
    }
};
var checkDoBetResultAndUpdateSectionData = function (doBetResult, gameType, updateGameSectionData, setTotalAcceptedBetsAmount, isAllSectionWithCashOutButton, totalBetsAmount, isUsedStakeUpdateLogic) {
    var _a;
    var _b, _c;
    var ONLY_CRASH = BOG_LINE_GAME_TYPES.ONLY_CRASH, MARKET_AND_CRASH = BOG_LINE_GAME_TYPES.MARKET_AND_CRASH;
    if (isUsedStakeUpdateLogic) {
        var betAmount = calculateTotalBetAmount(doBetResult);
        iframeService.sendStakeUpdate(totalBetsAmount + Number(betAmount));
        setTotalAcceptedBetsAmount(+totalBetsAmount + Number(betAmount));
    }
    if ([ONLY_CRASH, MARKET_AND_CRASH].includes(gameType) && !((_b = doBetResult === null || doBetResult === void 0 ? void 0 : doBetResult.betData) === null || _b === void 0 ? void 0 : _b.markets)) {
        updateGameSectionData((_a = {}, _a[UPDATED_BET_DATA_KEYS.isBetAccepted] = true, _a), isAllSectionWithCashOutButton ? (_c = doBetResult === null || doBetResult === void 0 ? void 0 : doBetResult.betData) === null || _c === void 0 ? void 0 : _c.index : 0);
    }
};
var buildCurrentLiveBetsOnRoundFin$1 = function (bets, bogLineGameType, callbackForFilterBets) {
    if (bogLineGameType === BOG_LINE_GAME_TYPES.ONLY_MARKET) {
        return bets;
    }
    if (bogLineGameType === BOG_LINE_GAME_TYPES.MARKET_AND_CRASH) {
        return bets.filter(callbackForFilterBets);
    }
};

var getCurrentFreeBetSectionAmountByWinType = function (odd, betAmount, freeBetType, isHalfCashOut) {
    return freeBetType === FreeBetWinningType.Win
        ? toFixed(minus(Number(toFixed(multiply(Number(odd) || 0, Number(isHalfCashOut ? divide(+betAmount, 2) : betAmount)))), Number(isHalfCashOut ? divide(+betAmount, 2) : betAmount) || 0) || 0)
        : toFixed(multiply(Number(odd) || 0, Number(isHalfCashOut ? divide(+betAmount, 2) : betAmount || 0)) || 0);
};
var checkShowMaxPayoutPopUp = function (odd, sectionId, gameName, freeBetSectionData) {
    var _a, _b, _c;
    var _d = freeBetSectionData || {}, _e = _d.freeBetType, freeBetType = _e === void 0 ? null : _e, _f = _d.isBetAccepted, isBetAccepted = _f === void 0 ? null : _f, _g = _d.betAmount, betAmount = _g === void 0 ? null : _g, _h = _d.maxPayout, maxPayout = _h === void 0 ? null : _h, _j = _d.isShowPopUp, isShowPopUp = _j === void 0 ? null : _j, _k = _d.isAlreadySeenPopUp, isAlreadySeenPopUp = _k === void 0 ? null : _k, _l = _d.isHalfCashOut, isHalfCashOut = _l === void 0 ? null : _l, _m = _d.halfCashOutedWinAmount, halfCashOutedWinAmount = _m === void 0 ? 0 : _m;
    if (isBetAccepted) {
        var freeBetAmount = getCurrentFreeBetSectionAmountByWinType(odd, betAmount, freeBetType, isHalfCashOut);
        if (gameName === BOG_GAME_NAMES.FISHING) {
            var totalOdd = 1;
            var totalAmount = betAmount;
            totalOdd *= Number(odd);
            totalAmount *= Number(totalOdd);
            if (totalAmount > maxPayout) {
                freeBetStore.updateExtraFreeBetData({
                    sectionId: Number(sectionId),
                    updatedDataByKeys: (_a = {},
                        _a[UpdatedFreeBetDataItemKeys.IS_SHOW_POP_UP] = true,
                        _a[UpdatedFreeBetDataItemKeys.IS_ALREADY_SEEN_POP_UP] = isAlreadySeenPopUp,
                        _a[UpdatedFreeBetDataItemKeys.CASH_OUT_AMOUNT] = totalAmount,
                        _a),
                });
            }
            else if (totalAmount < maxPayout && isShowPopUp) {
                freeBetStore.updateExtraFreeBetData({
                    sectionId: Number(sectionId),
                    updatedDataByKeys: (_b = {},
                        _b[UpdatedFreeBetDataItemKeys.IS_SHOW_POP_UP] = false,
                        _b[UpdatedFreeBetDataItemKeys.IS_ALREADY_SEEN_POP_UP] = false,
                        _b[UpdatedFreeBetDataItemKeys.CASH_OUT_AMOUNT] = totalAmount,
                        _b),
                });
            }
        }
        else {
            if (Number(freeBetAmount) > Number(maxPayout) - halfCashOutedWinAmount) {
                freeBetStore.updateExtraFreeBetData({
                    sectionId: Number(sectionId),
                    updatedDataByKeys: (_c = {},
                        _c[UpdatedFreeBetDataItemKeys.IS_SHOW_POP_UP] = true,
                        _c[UpdatedFreeBetDataItemKeys.IS_ALREADY_SEEN_POP_UP] = isAlreadySeenPopUp,
                        _c[UpdatedFreeBetDataItemKeys.CASH_OUT_AMOUNT] = freeBetAmount,
                        _c),
                });
            }
        }
    }
};
var checkShowMaxPayoutPopUpByGame = function (resultReportListenerData, freeBetSectionIndexes, extraFreeBetData, gameName
// isUsedRoundStartAndFinishedLogicAfterCashOut: boolean,
// updateGameSectionData: (newSectionData: Record<string, any>, sectionIndex: number) => void,
// isAllSectionWithCashOutButton: boolean
) {
    var _a;
    var _b = resultReportListenerData.data, _c = _b.resultReportData, resultReportData = _c === void 0 ? null : _c, _d = _b.gameTypeId, gameTypeId = _d === void 0 ? null : _d, bets = _b.bets;
    var PASCAL = BOG_GAME_NAMES.PASCAL, FISHING = BOG_GAME_NAMES.FISHING;
    var userAcceptedBets = [];
    var _e = resultReportData.currentItemsInfo, currentItemsInfo = _e === void 0 ? null : _e, _f = resultReportData.odd, odd = _f === void 0 ? null : _f, resultReportDataBets = resultReportData.bets;
    if (gameName === PASCAL) {
        if ((gameTypeId || gameTypeId === 0) &&
            ((freeBetSectionIndexes === null || freeBetSectionIndexes === void 0 ? void 0 : freeBetSectionIndexes[gameTypeId]) || (freeBetSectionIndexes === null || freeBetSectionIndexes === void 0 ? void 0 : freeBetSectionIndexes[gameTypeId]) == 0) &&
            ((_a = extraFreeBetData === null || extraFreeBetData === void 0 ? void 0 : extraFreeBetData[freeBetSectionIndexes === null || freeBetSectionIndexes === void 0 ? void 0 : freeBetSectionIndexes[gameTypeId]]) === null || _a === void 0 ? void 0 : _a.isBetAccepted)) {
            checkShowMaxPayoutPopUp(Number(odd), freeBetSectionIndexes === null || freeBetSectionIndexes === void 0 ? void 0 : freeBetSectionIndexes[gameTypeId], gameName, extraFreeBetData[freeBetSectionIndexes === null || freeBetSectionIndexes === void 0 ? void 0 : freeBetSectionIndexes[gameTypeId]]);
        }
    }
    else if (currentItemsInfo === null || currentItemsInfo === void 0 ? void 0 : currentItemsInfo.length) {
        var firstBets = resultReportData.firstBets, secondBets = resultReportData.secondBets, thirdBets = resultReportData.thirdBets, crashedItemsInfo = resultReportData.crashedItemsInfo, savedPigsInfo = resultReportData.savedPigsInfo, crashedJetsInfo = resultReportData.crashedJetsInfo;
        var crashedItemsInfoParsed = crashedItemsInfo || savedPigsInfo || crashedJetsInfo;
        crashedItemsInfoParsed === null || crashedItemsInfoParsed === void 0 ? void 0 : crashedItemsInfoParsed.forEach(function (_a) {
            var _b;
            var _c;
            var index = _a.index, pigIndex = _a.pigIndex, jetIndex = _a.jetIndex;
            var crashedIndex = pigIndex || pigIndex === 0 ? pigIndex : jetIndex || jetIndex === 0 ? jetIndex : index;
            if ((_c = extraFreeBetData[crashedIndex]) === null || _c === void 0 ? void 0 : _c.isBetAccepted) {
                freeBetStore.updateExtraFreeBetData({
                    sectionId: crashedIndex,
                    updatedDataByKeys: (_b = {},
                        _b[UpdatedFreeBetDataItemKeys.IS_SHOW_POP_UP] = false,
                        _b[UpdatedFreeBetDataItemKeys.IS_ALREADY_SEEN_POP_UP] = true,
                        _b[UpdatedFreeBetDataItemKeys.MAX_PAYOUT] = null,
                        _b[UpdatedFreeBetDataItemKeys.FREE_BET_ID] = null,
                        _b[UpdatedFreeBetDataItemKeys.FREE_BET_TYPE] = null,
                        _b[UpdatedFreeBetDataItemKeys.CURRENT_INDEX] = null,
                        _b[UpdatedFreeBetDataItemKeys.FREE_BET_MIN_ODD] = null,
                        _b[UpdatedFreeBetDataItemKeys.IS_BET_ACCEPTED] = false,
                        _b[UpdatedFreeBetDataItemKeys.BET_AMOUNT] = null,
                        _b[UpdatedFreeBetDataItemKeys.CASH_OUT_AMOUNT] = null,
                        _b[UpdatedFreeBetDataItemKeys.IS_AUTO_CASH_OUT] = false,
                        _b[UpdatedFreeBetDataItemKeys.IS_HALF_CASH_OUT] = false,
                        _b),
                });
            }
            // if (isUsedRoundStartAndFinishedLogicAfterCashOut) {
            //   const sectionsWithAcceptedBet = platformMessageStore.gameSectionsData?.filter((item) => item?.isBetAccepted);
            //   if (
            //     sectionsWithAcceptedBet?.length &&
            //     !sectionsWithAcceptedBet.filter((item) => crashedIndex !== item?.index).length
            //   ) {
            //     iframeService.sendRoundFinished(platformMessageStore.totalWinAmount);
            //   }
            // }
            // updateGameSectionData(
            //   { [UPDATED_BET_DATA_KEYS.isBetAccepted]: false },
            //   isAllSectionWithCashOutButton ? crashedIndex : 0
            // );
        });
        currentItemsInfo === null || currentItemsInfo === void 0 ? void 0 : currentItemsInfo.forEach(function (_a) {
            var index = _a.index, currentOdd = _a.currentOdd;
            checkShowMaxPayoutPopUp(Number(currentOdd), index, gameName, extraFreeBetData[index]);
        });
        userAcceptedBets = __spreadArray(__spreadArray(__spreadArray([], __read((firstBets || [])), false), __read((secondBets || [])), false), __read((thirdBets || [])), false).filter(function (item) { return +item.userId === +userInfoStore.userId; });
    }
    else {
        Object.keys(extraFreeBetData).forEach(function (sectionId) {
            if (gameName === FISHING) ;
            else {
                checkShowMaxPayoutPopUp(Number(odd), sectionId, gameName, extraFreeBetData[sectionId]);
            }
        });
    }
    if ((userAcceptedBets === null || userAcceptedBets === void 0 ? void 0 : userAcceptedBets.length) || (bets === null || bets === void 0 ? void 0 : bets.length) || (resultReportDataBets === null || resultReportDataBets === void 0 ? void 0 : resultReportDataBets.length)) {
        hideFreeBetMaxPayoutPopUpAfterAutoCashOut(resultReportDataBets || userAcceptedBets || bets, +(userInfoStore === null || userInfoStore === void 0 ? void 0 : userInfoStore.userId), extraFreeBetData, gameName, freeBetStore.freeBetSectionIndexes, gameTypeId);
    }
};
var autoCashOutResultReportEventMaxPayout = function (resultReportListenerData, extraFreeBetData, gameName) {
    var _a = resultReportListenerData.data, _b = _a.resultReportData, resultReportData = _b === void 0 ? null : _b, _c = _a.gameTypeId, gameTypeId = _c === void 0 ? null : _c, bets = _a.bets;
    var userAcceptedBets = [];
    var _d = resultReportData.currentItemsInfo, currentItemsInfo = _d === void 0 ? null : _d; resultReportData.odd; var resultReportDataBets = resultReportData.bets;
    if (currentItemsInfo === null || currentItemsInfo === void 0 ? void 0 : currentItemsInfo.length) {
        var firstBets = resultReportData.firstBets, secondBets = resultReportData.secondBets, thirdBets = resultReportData.thirdBets;
        userAcceptedBets = __spreadArray(__spreadArray(__spreadArray([], __read((firstBets || [])), false), __read((secondBets || [])), false), __read((thirdBets || [])), false).filter(function (item) { return +item.userId === +userInfoStore.userId; });
    }
    if ((userAcceptedBets === null || userAcceptedBets === void 0 ? void 0 : userAcceptedBets.length) || (bets === null || bets === void 0 ? void 0 : bets.length) || (resultReportDataBets === null || resultReportDataBets === void 0 ? void 0 : resultReportDataBets.length)) {
        hideFreeBetMaxPayoutPopUpAfterAutoCashOut(resultReportDataBets || userAcceptedBets || bets, +(userInfoStore === null || userInfoStore === void 0 ? void 0 : userInfoStore.userId), extraFreeBetData, gameName, freeBetStore.freeBetSectionIndexes, gameTypeId);
    }
};
var setExtraFreeBetData = function (doBetResultListenerData, currentUserId, freeBetSectionIndexes, freeBets, gameName, bogLineGameTypeData) {
    var _a, _b;
    var _c, _d;
    var _e = doBetResultListenerData || {}, amount = _e.amount, _f = _e.freeBetId, freeBetId = _f === void 0 ? null : _f, _g = _e.index, index = _g === void 0 ? 0 : _g, _h = _e.freeBetInfo, freeBetInfo = _h === void 0 ? null : _h, _j = _e.gameTypeId, gameTypeId = _j === void 0 ? null : _j, _k = _e.betData, betData = _k === void 0 ? null : _k, _l = _e.additionalParams, additionalParams = _l === void 0 ? null : _l, _m = _e.userId, userId = _m === void 0 ? null : _m, _o = _e.status, status = _o === void 0 ? null : _o;
    var currentBetData = betData || additionalParams;
    var checkIsBetAcceptedDependOnIsCashOutBet = bogLineGameTypeData.checkIsBetAcceptedDependOnIsCashOutBet, gameType = bogLineGameTypeData.gameType;
    var currentFreeBet = freeBetId ? freeBets === null || freeBets === void 0 ? void 0 : freeBets.find(function (item) { return Number(item === null || item === void 0 ? void 0 : item.id) === Number(freeBetId); }) : null;
    /// ete traqec freeBetInfo avelacrac chi et konkret xaxi backendic
    if (+currentUserId === Number(userId)) {
        var currentIndex = gameTypeId && gameName === BOG_GAME_NAMES.PASCAL
            ? freeBetSectionIndexes === null || freeBetSectionIndexes === void 0 ? void 0 : freeBetSectionIndexes[gameTypeId]
            : (currentBetData === null || currentBetData === void 0 ? void 0 : currentBetData.index) || (currentBetData === null || currentBetData === void 0 ? void 0 : currentBetData.index) === 0
                ? currentBetData === null || currentBetData === void 0 ? void 0 : currentBetData.index
                : index;
        if (freeBetId && ((freeBetInfo === null || freeBetInfo === void 0 ? void 0 : freeBetInfo.maxPayout) || (currentFreeBet === null || currentFreeBet === void 0 ? void 0 : currentFreeBet.maxPayout))) {
            var currentFreeBetMinOdd = (_d = (_c = freeBetStore === null || freeBetStore === void 0 ? void 0 : freeBetStore.freeBets) === null || _c === void 0 ? void 0 : _c.find(function (freeBet) { return (freeBet === null || freeBet === void 0 ? void 0 : freeBet.id) === freeBetId; })) === null || _d === void 0 ? void 0 : _d.minOdd;
            freeBetStore.updateExtraFreeBetData({
                sectionId: currentIndex,
                updatedDataByKeys: (_a = {},
                    _a[UpdatedFreeBetDataItemKeys.IS_BET_ACCEPTED] = gameType === BOG_LINE_GAME_TYPES.MARKET_AND_CRASH
                        ? checkIsBetAcceptedDependOnIsCashOutBet
                            ? checkIsBetAcceptedDependOnIsCashOutBet(betData)
                            : true
                        : true,
                    _a[UpdatedFreeBetDataItemKeys.FREE_BET_ID] = freeBetId,
                    _a[UpdatedFreeBetDataItemKeys.BET_AMOUNT] = Number(amount),
                    _a[UpdatedFreeBetDataItemKeys.CURRENT_INDEX] = currentIndex,
                    _a[UpdatedFreeBetDataItemKeys.FREE_BET_TYPE] = freeBetInfo ? freeBetInfo === null || freeBetInfo === void 0 ? void 0 : freeBetInfo.winType : currentFreeBet === null || currentFreeBet === void 0 ? void 0 : currentFreeBet.winType,
                    _a[UpdatedFreeBetDataItemKeys.FREE_BET_MIN_ODD] = currentFreeBetMinOdd,
                    _a[UpdatedFreeBetDataItemKeys.MAX_PAYOUT] = freeBetInfo
                        ? Number(freeBetInfo === null || freeBetInfo === void 0 ? void 0 : freeBetInfo.maxPayout)
                        : Number(currentFreeBet.maxPayout),
                    _a[UpdatedFreeBetDataItemKeys.IS_AUTO_CASH_OUT] = gameName === BOG_GAME_NAMES.PASCAL ? !!additionalParams : !!(currentBetData === null || currentBetData === void 0 ? void 0 : currentBetData.autoCashOutOdd),
                    _a),
            });
        }
        else {
            var limits = gameConfigStore.limits;
            freeBetStore.updateExtraFreeBetData({
                sectionId: currentIndex,
                updatedDataByKeys: (_b = {},
                    _b[UpdatedFreeBetDataItemKeys.IS_BET_ACCEPTED] = gameType === BOG_LINE_GAME_TYPES.MARKET_AND_CRASH
                        ? checkIsBetAcceptedDependOnIsCashOutBet
                            ? checkIsBetAcceptedDependOnIsCashOutBet(currentBetData)
                            : true
                        : status !== BetStatus.Win,
                    _b[UpdatedFreeBetDataItemKeys.BET_AMOUNT] = Number(amount),
                    _b[UpdatedFreeBetDataItemKeys.CURRENT_INDEX] = currentIndex,
                    _b[UpdatedFreeBetDataItemKeys.MAX_PAYOUT] = +limits.maxWin,
                    _b[UpdatedFreeBetDataItemKeys.IS_AUTO_CASH_OUT] = gameName === BOG_GAME_NAMES.PASCAL ? !!additionalParams : !!(currentBetData === null || currentBetData === void 0 ? void 0 : currentBetData.autoCashOutOdd),
                    _b),
            });
        }
    }
};
var checkShowMaxPayoutNotifications = function (roundFinishedListenerData, maxWin, freeBets, currentCallbackForFilterFinishedBets, currentGameType, notificationDelay) {
    var totalWinAmount;
    var bets = roundFinishedListenerData.data.bets;
    var filteredCurrentLiveBets = buildCurrentLiveBetsOnRoundFin(bets, currentGameType, currentCallbackForFilterFinishedBets);
    totalWinAmount = calculateTotalWinAmount(filteredCurrentLiveBets)[WIN_AMOUNT_KEY];
    if (totalWinAmount >= maxWin) {
        if (notificationDelay) {
            setTimeout(function () {
                notificationStore.setNotificationType({ responseCode: BetResponseCode.MaxWinNote });
            }, notificationDelay);
        }
        else {
            notificationStore.setNotificationType({ responseCode: BetResponseCode.MaxWinNote });
        }
    }
    var freeBetsWinData = calculateTotalWinAmount(filteredCurrentLiveBets)[FREE_BET_WIN_AMOUNT_KEY];
    if (freeBetsWinData.length) {
        freeBetsWinData.forEach(function (freeBetWinData) {
            Object.keys(freeBetWinData).forEach(function (freeBetId) {
                var currentFreeBet = freeBets.find(function (freeBet) { return freeBet.id === Number(freeBetId); });
                if (currentFreeBet && (currentFreeBet === null || currentFreeBet === void 0 ? void 0 : currentFreeBet.maxPayout) && freeBetWinData[freeBetId] >= currentFreeBet.maxPayout) {
                    if (notificationDelay) {
                        setTimeout(function () {
                            notificationStore.setNotificationType({
                                responseCode: BetResponseCode.FreeBetMaxWinPayout,
                                freeBetMaxPayout: currentFreeBet.maxPayout,
                            });
                        }, notificationDelay);
                    }
                    else {
                        notificationStore.setNotificationType({
                            responseCode: BetResponseCode.FreeBetMaxWinPayout,
                            freeBetMaxPayout: currentFreeBet.maxPayout,
                        });
                    }
                }
            });
        });
    }
    return totalWinAmount;
};
var getFreeBetSectionIndexes = function (extraFreeBetData, fromAutoCashOut) {
    var _a, _b;
    return ((_b = (_a = Object.keys(extraFreeBetData)) === null || _a === void 0 ? void 0 : _a.filter(function (item) {
        var _a, _b, _c;
        return ((_a = extraFreeBetData === null || extraFreeBetData === void 0 ? void 0 : extraFreeBetData[item]) === null || _a === void 0 ? void 0 : _a.isBetAccepted) &&
            ((_b = extraFreeBetData === null || extraFreeBetData === void 0 ? void 0 : extraFreeBetData[item]) === null || _b === void 0 ? void 0 : _b.cashOutAmount) >= ((_c = extraFreeBetData === null || extraFreeBetData === void 0 ? void 0 : extraFreeBetData[item]) === null || _c === void 0 ? void 0 : _c.maxPayout) &&
            (fromAutoCashOut ? extraFreeBetData === null || extraFreeBetData === void 0 ? void 0 : extraFreeBetData[item].isAutoCashOut : true);
    })) !== null && _b !== void 0 ? _b : []);
};
var hideFreeBetMaxPayoutPopUpAfterAutoCashOut = function (bets, currentUserId, extraFreeBetData, gameName, currentFreeBetSectionIndexes, gameTypeId) {
    var currentUserBets = bets === null || bets === void 0 ? void 0 : bets.filter(function (bet) {
        return +bet.userId === currentUserId;
    });
    if (currentUserBets === null || currentUserBets === void 0 ? void 0 : currentUserBets.length) {
        currentUserBets.forEach(function (item) {
            var _a;
            var _b, _c, _d;
            if (((_b = item === null || item === void 0 ? void 0 : item.additionalParams) === null || _b === void 0 ? void 0 : _b.index) || ((_c = item === null || item === void 0 ? void 0 : item.additionalParams) === null || _c === void 0 ? void 0 : _c.index) === 0 || gameName === BOG_GAME_NAMES.PASCAL) {
                freeBetStore.updateExtraFreeBetData({
                    sectionId: Number(gameName === BOG_GAME_NAMES.PASCAL
                        ? currentFreeBetSectionIndexes === null || currentFreeBetSectionIndexes === void 0 ? void 0 : currentFreeBetSectionIndexes[gameTypeId]
                        : ((_d = item === null || item === void 0 ? void 0 : item.additionalParams) === null || _d === void 0 ? void 0 : _d.index) || 0),
                    updatedDataByKeys: (_a = {},
                        _a[UpdatedFreeBetDataItemKeys.IS_SHOW_POP_UP] = false,
                        _a[UpdatedFreeBetDataItemKeys.IS_ALREADY_SEEN_POP_UP] = true,
                        _a[UpdatedFreeBetDataItemKeys.MAX_PAYOUT] = null,
                        _a[UpdatedFreeBetDataItemKeys.FREE_BET_ID] = null,
                        _a[UpdatedFreeBetDataItemKeys.FREE_BET_TYPE] = null,
                        _a[UpdatedFreeBetDataItemKeys.CURRENT_INDEX] = null,
                        _a[UpdatedFreeBetDataItemKeys.FREE_BET_MIN_ODD] = null,
                        _a[UpdatedFreeBetDataItemKeys.IS_BET_ACCEPTED] = false,
                        _a[UpdatedFreeBetDataItemKeys.BET_AMOUNT] = null,
                        _a[UpdatedFreeBetDataItemKeys.CASH_OUT_AMOUNT] = null,
                        _a[UpdatedFreeBetDataItemKeys.IS_AUTO_CASH_OUT] = false,
                        _a),
                });
            }
            else {
                freeBetStore.resetExtraFreeBetData();
            }
        });
    }
};
var hideFreeBetMaxPayoutPopUpAfterCashOut = function (cashOutResultListener, currentUserId, extraFreeBetData, currentFreeBetSectionIndexes, gameName) {
    var _a, _b;
    var userId = cashOutResultListener.userId, additionalParams = cashOutResultListener.additionalParams, _c = cashOutResultListener.gameTypeId, gameTypeId = _c === void 0 ? null : _c, cashOutHalf = cashOutResultListener.cashOutHalf, winAmount = cashOutResultListener.winAmount;
    var freeBetSectionIndexes = getFreeBetSectionIndexes(extraFreeBetData);
    if (+userId === +currentUserId) {
        if (!cashOutHalf) {
            if ((additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.index) ||
                (additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.index) === 0 ||
                (additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.isManual) ||
                (gameName === BOG_GAME_NAMES.PASCAL &&
                    (freeBetSectionIndexes === null || freeBetSectionIndexes === void 0 ? void 0 : freeBetSectionIndexes.find(function (item) { return +(currentFreeBetSectionIndexes === null || currentFreeBetSectionIndexes === void 0 ? void 0 : currentFreeBetSectionIndexes[gameTypeId]) === +item; })))) {
                freeBetStore.updateExtraFreeBetData({
                    sectionId: Number(gameName === BOG_GAME_NAMES.PASCAL
                        ? currentFreeBetSectionIndexes === null || currentFreeBetSectionIndexes === void 0 ? void 0 : currentFreeBetSectionIndexes[gameTypeId]
                        : (additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.index) || 0),
                    updatedDataByKeys: (_a = {},
                        _a[UpdatedFreeBetDataItemKeys.IS_SHOW_POP_UP] = false,
                        _a[UpdatedFreeBetDataItemKeys.IS_ALREADY_SEEN_POP_UP] = true,
                        _a[UpdatedFreeBetDataItemKeys.MAX_PAYOUT] = null,
                        _a[UpdatedFreeBetDataItemKeys.FREE_BET_ID] = null,
                        _a[UpdatedFreeBetDataItemKeys.FREE_BET_TYPE] = null,
                        _a[UpdatedFreeBetDataItemKeys.CURRENT_INDEX] = null,
                        _a[UpdatedFreeBetDataItemKeys.FREE_BET_MIN_ODD] = null,
                        _a[UpdatedFreeBetDataItemKeys.IS_BET_ACCEPTED] = false,
                        _a[UpdatedFreeBetDataItemKeys.BET_AMOUNT] = null,
                        _a[UpdatedFreeBetDataItemKeys.CASH_OUT_AMOUNT] = null,
                        _a[UpdatedFreeBetDataItemKeys.IS_AUTO_CASH_OUT] = false,
                        _a[UpdatedFreeBetDataItemKeys.IS_HALF_CASH_OUT] = false,
                        _a),
                });
            }
            else {
                freeBetStore.resetExtraFreeBetData(gameName === BOG_GAME_NAMES.PASCAL ? currentFreeBetSectionIndexes === null || currentFreeBetSectionIndexes === void 0 ? void 0 : currentFreeBetSectionIndexes[gameTypeId] : null);
            }
        }
        else {
            freeBetStore.updateExtraFreeBetData({
                sectionId: Number(gameName === BOG_GAME_NAMES.PASCAL ? currentFreeBetSectionIndexes === null || currentFreeBetSectionIndexes === void 0 ? void 0 : currentFreeBetSectionIndexes[gameTypeId] : (additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.index) || 0),
                updatedDataByKeys: (_b = {},
                    _b[UpdatedFreeBetDataItemKeys.IS_HALF_CASH_OUT] = true,
                    _b[UpdatedFreeBetDataItemKeys.HALF_CASH_OUTED_WIN_AMOUNT] = winAmount,
                    _b),
            });
        }
    }
};
var buildCurrentLiveBetsOnRoundFin = function (bets, bogLineGameType, callbackForFilterBets) {
    if (bogLineGameType === BOG_LINE_GAME_TYPES.ONLY_MARKET) {
        return bets;
    }
    if (bogLineGameType === BOG_LINE_GAME_TYPES.MARKET_AND_CRASH) {
        return bets === null || bets === void 0 ? void 0 : bets.filter(callbackForFilterBets);
    }
};

var BaseLiveConnection = /** @class */ (function () {
    // private isOnReconnectingState: boolean = false;
    function BaseLiveConnection(url) {
        this.url = url;
    }
    BaseLiveConnection.prototype.waitStarted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.connectionStartPromise instanceof Promise)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.connectionStartPromise];
                    case 1:
                        _a.sent();
                        this.connectionStartPromise = null;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BaseLiveConnection.prototype.waitStop = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.connectionStopPromise instanceof Promise)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.connectionStopPromise];
                    case 1:
                        _a.sent();
                        this.connectionStopPromise = null;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BaseLiveConnection.prototype.init = function (reconnectTimes, skipNegotiation) {
        if (reconnectTimes === void 0) { reconnectTimes = [300, 600]; }
        if (skipNegotiation === void 0) { skipNegotiation = false; }
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.waitStop()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.waitStarted()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.connectionInitMiddleware(reconnectTimes, skipNegotiation)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        e_1 = _a.sent();
                        this.connectionStartPromise = null;
                        // await this.init(reconnectTimes, skipNegotiation);
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BaseLiveConnection.prototype.connectionInitMiddleware = function (reconnectTimes, skipNegotiation) {
        var _a;
        if (reconnectTimes === void 0) { reconnectTimes = [300, 600]; }
        if (skipNegotiation === void 0) { skipNegotiation = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(((_a = this.connection) === null || _a === void 0 ? void 0 : _a.state) !== HubConnectionState.Connected)) return [3 /*break*/, 2];
                        this.connection = this.createConnection(reconnectTimes, skipNegotiation);
                        this.connectionStartPromise = this.connection.start();
                        return [4 /*yield*/, this.waitStarted()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.connection];
                }
            });
        });
    };
    BaseLiveConnection.prototype.createConnection = function (reconnectTimes, skipNegotiation) {
        if (reconnectTimes === void 0) { reconnectTimes = [300, 600]; }
        if (skipNegotiation === void 0) { skipNegotiation = false; }
        return new HubConnectionBuilder()
            .withUrl(this.url, {
            accessTokenFactory: function () {
                var accessToken = applicationStore.accessToken;
                return accessToken;
            },
            skipNegotiation: skipNegotiation,
        })
            .configureLogging(LogLevel.Information)
            .withAutomaticReconnect(reconnectTimes)
            .build();
    };
    BaseLiveConnection.prototype.invoke = function (methodName) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.waitStarted()];
                    case 1:
                        _c.sent();
                        if (((_a = this.connection) === null || _a === void 0 ? void 0 : _a.state) === HubConnectionState.Connected)
                            return [2 /*return*/, (_b = this.connection).invoke.apply(_b, __spreadArray([methodName], __read(args), false))];
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseLiveConnection.prototype.on = function (methodName, handler) {
        var _a;
        if (((_a = this.connection) === null || _a === void 0 ? void 0 : _a.state) === HubConnectionState.Connected)
            this.connection.on(methodName, handler);
        return this;
    };
    BaseLiveConnection.prototype.onReconnecting = function (callback) {
        if (this.connection) {
            this.connection.onreconnecting(function (data) {
                if (callback) {
                    callback(data);
                }
                // this.isOnReconnectingState = true;
                // this.callbackMiddleware({
                //   methodName: CommonConnectionsMethod.Reconnecting,
                // });
            });
        }
    };
    BaseLiveConnection.prototype.onClose = function (callback) {
        if (this.connection && this.connection.state === HubConnectionState.Connected) {
            return this.connection.onclose(function (data) {
                if (callback) {
                    callback(data);
                }
                // if (this.isOnReconnectingState) {
                //   this.callbackMiddleware({
                //     methodName: CommonConnectionsMethod.ConnectionClose,
                //   });
                // }
            });
        }
    };
    BaseLiveConnection.prototype.onReconnected = function (callback) {
        if (this.connection) {
            return this.connection.onreconnected(function (data) {
                if (callback) {
                    callback(data);
                }
                // this.isOnReconnectingState = false;
                // this.callbackMiddleware({
                //   methodName: CommonConnectionsMethod.Reconnected,
                // });
            });
        }
    };
    BaseLiveConnection.prototype.stop = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.waitStarted()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.waitStop()];
                    case 2:
                        _b.sent();
                        if (!(((_a = this.connection) === null || _a === void 0 ? void 0 : _a.state) === HubConnectionState.Connected)) return [3 /*break*/, 4];
                        this.connectionStopPromise = this.connection.stop().then(function () {
                            _this.connectionStartPromise = null;
                        });
                        return [4 /*yield*/, this.waitStop()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BaseLiveConnection.prototype.callbackMiddleware = function (_a) {
        var _b;
        var _this = this;
        var data = _a.data, methodName = _a.methodName;
        var isSentRoundStarted = platformMessageStore.isSentRoundStarted, bogLineGameTypeData = platformMessageStore.bogLineGameTypeData, totalAcceptedBetsAmount = platformMessageStore.totalAcceptedBetsAmount, isAllSectionWithCashOutButton = platformMessageStore.isAllSectionWithCashOutButton, isUsedGetBalanceBySocketInvoke = platformMessageStore.isUsedGetBalanceBySocketInvoke, isUsedRoundStartAndFinishedLogicAfterCashOut = platformMessageStore.isUsedRoundStartAndFinishedLogicAfterCashOut, isBetShop = platformMessageStore.isBetShop;
        var isUsedPlatformIntegrationLogic = bogLineGameTypeData.isUsedPlatformIntegrationLogic, gameType = bogLineGameTypeData.gameType, gameName = bogLineGameTypeData.gameName, isUsedStakeUpdateLogic = bogLineGameTypeData.isUsedStakeUpdateLogic, callbackForFilterFinishedBets = bogLineGameTypeData.callbackForFilterFinishedBets; bogLineGameTypeData.isAutoCashOutWithSeparateEvent;
        var liveBets = betStore.liveBets;
        var isBogLine = applicationStore.isBogLine;
        var methods = (_b = {},
            _b[CommonConnectionsMethod.UnderMaintenance] = function (arg) { return popupStore.startUnderMaintenanceFunctional(arg); },
            _b[GameLiveConnectionMethod.BalanceUpdate] = function (arg) {
                userInfoStore.setBalance(arg);
                iframeService.sendBalanceUpdated(arg);
                if (isUsedRoundStartAndFinishedLogicAfterCashOut && !isSentRoundStarted && isUsedPlatformIntegrationLogic) {
                    iframeService.sendRoundStarted(arg);
                }
            },
            _b[CommonConnectionsMethod.LobbyUsersCount] = function (arg) {
                var updatedGameTypes = lobbyStore.gameTypes.map(function (cur) {
                    var hasGameTypeId = Object.keys(arg).find(function (key) { return +key === +cur.gameTypeId; });
                    if (hasGameTypeId) {
                        return __assign(__assign({}, cur), { activeUsersCount: arg[hasGameTypeId] });
                    }
                    return cur;
                });
                lobbyStore.setGameTypes(updatedGameTypes);
            },
            _b[CommonConnectionsMethod.FreeBetAwarded] = function (arg) { return freeBetStore.handleAwardedFreeBets(arg); },
            _b[GameLiveConnectionMethod.FreeBetCountUpdate] = function (arg) {
                var gameId = arg.gameId, freeBetId = arg.freeBetId, currentCount = arg.currentCount;
                if (+gameId === +gameConfigStore.gameId) {
                    freeBetStore.handleFreeBetDoBetResult(freeBetId, currentCount);
                }
            },
            _b[GameLiveConnectionMethod.FreeBetEnded] = function (arg) { return freeBetStore.handleEndedFreeBets(arg); },
            _b[GameLiveConnectionMethod.RoundStarted] = function (arg) {
                var data = arg.data;
                var statistics = data.statistics, startedRound = data.startedRound; data.results;
                var notificationCode = notificationStore.notificationCode, setNotificationType = notificationStore.setNotificationType;
                var MaxWinNote = BetResponseCode.MaxWinNote;
                if (bogLineGameTypeData.isUseCoreDoBetStore) {
                    var roundId = startedRound.roundId;
                    gameStore.clearCashOutCounts();
                    gameStore.clearUserCounts();
                    oddStore.setIsCrash(false);
                    gameStore.setCurrentGameState(RoundStatus.Started);
                    oddStore.setIsFirstResultReport(true);
                    gameStore.setIsBetsClosed(false);
                    if (betDataStore.betButtonDisable) {
                        betDataStore.setBetButtonDisable(false);
                    }
                    oddStore.resetOddData();
                    roundInfoStore.setRoundId(roundId);
                    betDataStore.betsSectionsData.forEach(function (section) {
                        if (section.isAutoBet && section.autoBetCount) {
                            doBetStore.doBetSender(section.index);
                        }
                    });
                    betStore.setLiveBets([]);
                    doBetStore.handleOnRoundStart();
                }
                freeBetStore.handleFreeBetEndedData();
                if (statistics === null || statistics === void 0 ? void 0 : statistics.statistics) {
                    var buildStatisticsData = statisticsStore.buildStatisticsData, setStatistics = statisticsStore.setStatistics;
                    setStatistics(buildStatisticsData(statistics === null || statistics === void 0 ? void 0 : statistics.statistics));
                }
                platformMessageStore.updateTotalWinAmount(null);
                (statistics === null || statistics === void 0 ? void 0 : statistics.highestOdds) && statisticsStore.setHighestOddsData(statistics === null || statistics === void 0 ? void 0 : statistics.highestOdds);
                if (isBogLine && notificationCode && notificationCode === MaxWinNote) {
                    setNotificationType(null);
                }
                if (isUsedStakeUpdateLogic && !isUsedRoundStartAndFinishedLogicAfterCashOut) {
                    iframeService.sendWinUpdate(0);
                }
                if (!isBetShop) {
                    setTimeout(function () {
                        var _a;
                        if (isUsedGetBalanceBySocketInvoke && isUsedPlatformIntegrationLogic) {
                            (_a = userSettingsStore === null || userSettingsStore === void 0 ? void 0 : userSettingsStore.gameLiveConnection) === null || _a === void 0 ? void 0 : _a.getBalance();
                        }
                        else {
                            userInfoStore.getUserBalance();
                        }
                    }, 1000);
                }
            },
            _b["".concat(ConnectionPrefix.Game, "_").concat(GameLiveConnectionMethod.RoundFinished)] = function (arg) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                var totalWinAmount, totalAmount;
                if (isBogLine) {
                    if (gameName === BOG_GAME_NAMES.PASCAL) {
                        var indexForResetSectionData = ((_b = (_a = arg === null || arg === void 0 ? void 0 : arg.data) === null || _a === void 0 ? void 0 : _a.finishedRound) === null || _b === void 0 ? void 0 : _b.gameTypeId) || ((_d = (_c = arg === null || arg === void 0 ? void 0 : arg.data) === null || _c === void 0 ? void 0 : _c.finishedRound) === null || _d === void 0 ? void 0 : _d.gameTypeId) === 0
                            ? (_f = (_e = arg === null || arg === void 0 ? void 0 : arg.data) === null || _e === void 0 ? void 0 : _e.finishedRound) === null || _f === void 0 ? void 0 : _f.gameTypeId
                            : null;
                        freeBetStore.resetExtraFreeBetData((_g = freeBetStore === null || freeBetStore === void 0 ? void 0 : freeBetStore.freeBetSectionIndexes) === null || _g === void 0 ? void 0 : _g[indexForResetSectionData]);
                    }
                    else {
                        if ((_h = arg === null || arg === void 0 ? void 0 : arg.gameSpecificAdditionalParams) === null || _h === void 0 ? void 0 : _h.notificationDelay) {
                            var notificationDelay = arg.gameSpecificAdditionalParams.notificationDelay;
                            setTimeout(function () {
                                freeBetStore.resetExtraFreeBetData();
                            }, notificationDelay);
                        }
                        else {
                            freeBetStore.resetExtraFreeBetData();
                        }
                    }
                    if (gameType !== BOG_LINE_GAME_TYPES.ONLY_CRASH) {
                        totalWinAmount = checkShowMaxPayoutNotifications(arg, Number(gameConfigStore.limits.maxWin), freeBetStore.freeBets, callbackForFilterFinishedBets, gameType, (_j = arg === null || arg === void 0 ? void 0 : arg.gameSpecificAdditionalParams) === null || _j === void 0 ? void 0 : _j.notificationDelay);
                    }
                    if (bogLineGameTypeData.isUseCoreDoBetStore) {
                        gameStore.setCurrentGameState(RoundStatus.Finished);
                        var liveBets_1 = betStore.liveBets;
                        var resetMaxWinData = oddStore.resetMaxWinData;
                        resetMaxWinData();
                        var finishedLiveBets = liveBets_1.map(function (bet) {
                            if (!bet.winAmount) {
                                return __assign(__assign({}, bet), { isFinished: true, odd: 0, winAmount: 0, winCoinAmount: 0, status: BetStatus.Lose });
                            }
                            return __assign(__assign({}, bet), { isFinished: true, status: BetStatus.Win });
                        });
                        betStore.setLiveBets(finishedLiveBets);
                    }
                }
                else {
                    var userBets = (_k = arg.data.bets) === null || _k === void 0 ? void 0 : _k.filter(function (bet) { return (bet === null || bet === void 0 ? void 0 : bet.userId) === Number(userInfoStore.userId); });
                    if (userBets && userBets.length) {
                        userBets.forEach(function (userBet) {
                            totalWinAmount = totalWinAmount ? toFixed(totalWinAmount + userBet.winAmount) : userBet.winAmount;
                            totalAmount = totalAmount ? toFixed(totalAmount + userBet.amount) : userBet.amount;
                        });
                    }
                }
                if (platformMessageStore.isSentRoundStarted && isUsedPlatformIntegrationLogic) {
                    iframeService.sendRoundFinished(+(totalWinAmount !== null && totalWinAmount !== void 0 ? totalWinAmount : 0) + platformMessageStore.totalWinAmount, totalAmount, (_l = arg === null || arg === void 0 ? void 0 : arg.data) === null || _l === void 0 ? void 0 : _l.bets);
                    platformMessageStore.updateTotalWinAmount(null);
                }
            },
            _b[GameLiveConnectionMethod.GameOpen] = function (arg) { return applicationStore.checkGameIsOpen(arg, _this.connection); },
            _b["".concat(ConnectionPrefix.Lobby, "_").concat(LobbyLiveConnectionMethod.RoundFinished)] = function (arg) {
                betStore.updateCurrentWinnersWithDelay(arg.bets);
            },
            _b["".concat(ConnectionPrefix.Lobby, "_").concat(LobbyLiveConnectionMethod.GetInitialStateResult)] = function (arg) {
                var currentWinners = arg.currentWinners, sliderBanners = arg.sliderBanners, hasDemo = arg.hasDemo, animationDuration = arg.animationDuration, gameTypes = arg.gameTypes, userFreebets = arg.userFreebets;
                lobbyStore.setHasDemo(hasDemo);
                lobbyStore.setGameTypes(gameTypes.sort(function (a, b) { return a.minBet - b.minBet; }));
                lobbyStore.setRoundFinAnimationDuration(animationDuration);
                if (sliderBanners) {
                    lobbyStore.setSliderBanners(sliderBanners);
                }
                betStore.setCurrentWinners(currentWinners);
                freeBetStore.handleFreeBetsInitialData(userFreebets);
            },
            _b["".concat(ConnectionPrefix.Game, "_").concat(GameLiveConnectionMethod.GetInitialStateResult)] = function (arg) {
                var _a;
                var gameTypeId = arg.gameTypeId, avatarId = arg.avatarId, userFreebets = arg.userFreebets, gameTypes = arg.gameTypes, gameTypeInfos = arg.gameTypeInfos, partnerWageringOdd = arg.partnerWageringOdd, currentBets = arg.currentBets, additionalMillisecondsForRemoveLoading = arg.additionalMillisecondsForRemoveLoading, roundInfo = arg.roundInfo, limits = arg.limits;
                if (bogLineGameTypeData.isUseCoreDoBetStore) {
                    gameConfigStore.setLimits(limits);
                    betStore.setLiveBets([]);
                    var Started = RoundStatus.Started, OnFinish = RoundStatus.OnFinish, Finished = RoundStatus.Finished;
                    var status_1 = roundInfo.status, second = roundInfo.second, result = roundInfo.result; roundInfo.betsClosedDuration;
                    if (bogLineGameTypeData.sectionCount > 1) {
                        betDataStore.setDoubleSectionState(true);
                    }
                    oddStore.resetOddData();
                    if (!((_a = freeBetStore.activeFreeBet) === null || _a === void 0 ? void 0 : _a.id)) {
                        betDataStore.setDefaultBetsAmount(limits);
                    }
                    if (partnerWageringOdd) {
                        gameStore.setPartnerWageringOdd(partnerWageringOdd);
                        gameStore.setMinOdd(partnerWageringOdd);
                        if (partnerWageringOdd > defaultMinOdd) {
                            gameStore.setDefaultMinOdd(partnerWageringOdd);
                            betDataStore.setDefaultAutoCashOutOdd(partnerWageringOdd);
                        }
                    }
                    if (currentBets && currentBets.length) {
                        gameStore.increaseUserCounts(currentBets.length);
                        var userCurrentBets = currentBets.reduce(function (acc, item) {
                            if (item.status === 1) {
                                gameStore.increaseCashOutCounts();
                            }
                            if ((item === null || item === void 0 ? void 0 : item.playerExternalId) === userInfoStore.playerExternalId) {
                                acc.push(item);
                            }
                            return acc;
                        }, []);
                        doBetStore.setCurrentInitialAndRealModeData(userCurrentBets, userFreebets);
                        betStore.setLiveBets(currentBets);
                    }
                    if (status_1 === Started && second < 0) {
                        betDataStore.setBetButtonDisable(true);
                        gameStore.setIsBetsClosed(true);
                    }
                    if (status_1 === OnFinish || status_1 === Finished) {
                        oddStore.setIsCrash(true);
                        if (result >= 1) {
                            oddStore.setOddData(+result);
                        }
                    }
                }
                // todo end doBet
                if (isBogLine) {
                    profileAvatarStore.updateAvatarId(avatarId);
                    profileAvatarStore.updateInitialAvatarId(avatarId);
                }
                if (gameTypeInfos) {
                    freeBetStore.setFreeBetSectionIndexes(gameTypeInfos);
                }
                if (gameTypes && gameTypes.length <= 1) {
                    lobbyStore.setIsShowLobbySelectGameType(false);
                }
                if (gameTypes) {
                    lobbyStore.setGameTypes(gameTypes);
                }
                if (freeChipsStore.freeChipInLobby) {
                    freeChipsStore.setActiveFreeChip(freeChipsStore.freeChipInLobby);
                }
                if (!gameConfigStore.gameTypeId && gameTypeId) {
                    gameConfigStore.setGameTypeId(gameTypeId);
                }
                freeBetStore.handleFreeBetsInitialData(userFreebets, true);
                if (partnerWageringOdd) {
                    wageringStore.setPartnerWageringOdd(partnerWageringOdd);
                }
                if (roundInfo) {
                    if (additionalMillisecondsForRemoveLoading) {
                        setTimeout(function () {
                            lobbyStore.setIsShowGameTypeLoading(false);
                        }, additionalMillisecondsForRemoveLoading);
                    }
                    else {
                        lobbyStore.setIsShowGameTypeLoading(false);
                    }
                }
                if (currentBets === null || currentBets === void 0 ? void 0 : currentBets.length) {
                    if (isUsedPlatformIntegrationLogic) {
                        if ((currentBets === null || currentBets === void 0 ? void 0 : currentBets.find(function (item) { return +(item === null || item === void 0 ? void 0 : item.userId) === +(userInfoStore === null || userInfoStore === void 0 ? void 0 : userInfoStore.userId); })) && !isSentRoundStarted) {
                            iframeService.sendRoundStarted();
                        }
                    }
                    if (isBogLine) {
                        var totalBetAmount_1 = 0;
                        var currentUserBets = currentBets === null || currentBets === void 0 ? void 0 : currentBets.filter(function (item) { return +(item === null || item === void 0 ? void 0 : item.userId) === +(userInfoStore === null || userInfoStore === void 0 ? void 0 : userInfoStore.userId); });
                        currentUserBets.forEach(function (currentUserBet) {
                            totalBetAmount_1 += +calculateTotalBetAmount(currentUserBet);
                            if (gameType !== BOG_LINE_GAME_TYPES.ONLY_MARKET) {
                                setExtraFreeBetData(__assign(__assign({}, currentUserBet), { betData: currentUserBet.additionalParams || currentUserBet.betData }), Number(userInfoStore.userId), freeBetStore.freeBetSectionIndexes, freeBetStore === null || freeBetStore === void 0 ? void 0 : freeBetStore.freeBets, gameName, bogLineGameTypeData);
                            }
                        });
                        if (totalBetAmount_1) {
                            iframeService.sendStakeUpdate(+totalBetAmount_1);
                            platformMessageStore.setTotalAcceptedBetsAmount(+totalBetAmount_1);
                        }
                    }
                }
            },
            _b[GameLiveConnectionMethod.DoBetResult] = function (arg) {
                var _a, _b, _c, _d, _e;
                var freeBetId = arg.freeBetId;
                if (isBogLine) {
                    if (bogLineGameTypeData.isUseCoreDoBetStore) {
                        var _f = arg.betData, index = _f.index, autoCashOutOdd = _f.autoCashOutOdd;
                        gameStore.increaseUserCounts();
                        betStore.updateLiveBets(data);
                        if (Number(+userInfoStore.userId) === Number(+(arg === null || arg === void 0 ? void 0 : arg.userId))) {
                            userSettingsStore.isSoundOn;
                            betDataStore.setIsLoaderActive(index, false);
                            if (freeBetId) {
                                betDataStore.setCurrentFreeBetAmount(index, freeBetId);
                                if (((_a = freeBetStore.activeFreeBet) === null || _a === void 0 ? void 0 : _a.winType) === FreeBetWinningType.Win) {
                                    doBetStore.setFreeBetType(index, FreeBetWinningType.Win);
                                }
                                else {
                                    doBetStore.setFreeBetByCoreData(index, freeBetId);
                                }
                                doBetStore.setFreeBeetDefaultOdd(freeBetId);
                                doBetStore.setCurrentFreeBetId(index, freeBetId);
                                if (autoCashOutOdd) {
                                    betDataStore.setFreeBetCurrentOdd(index, autoCashOutOdd);
                                }
                                if (doBetStore.doBetSectionsData[index].freeBetId) {
                                    doBetStore.setFreeBetDisableState(true);
                                }
                            }
                            var _g = betDataStore.betsSectionsData[index], isAutoBet = _g.isAutoBet, autoBetCount = _g.autoBetCount;
                            if (isAutoBet && autoBetCount) {
                                betDataStore.decreaseAutoBetCount(index);
                            }
                            if (gameStore.partnerWageringOdd) {
                                gameStore.setPartnerWageringDisabled(true);
                            }
                            doBetStore.setDoBetResult(data);
                            doBetStore.changeBetIsDisabled(index, false);
                        }
                    }
                    if (Number(userInfoStore.userId) === Number(arg === null || arg === void 0 ? void 0 : arg.userId)) {
                        if (applicationStore.isDemo) {
                            popupStore.updateDemoBetsCount();
                        }
                        if (gameType !== BOG_LINE_GAME_TYPES.ONLY_MARKET) {
                            setExtraFreeBetData(arg, Number(userInfoStore.userId), freeBetStore.freeBetSectionIndexes, freeBetStore === null || freeBetStore === void 0 ? void 0 : freeBetStore.freeBets, gameName, bogLineGameTypeData);
                        }
                        checkDoBetResultAndUpdateSectionData(arg, gameType, platformMessageStore.updateGameSectionData, platformMessageStore.setTotalAcceptedBetsAmount, isAllSectionWithCashOutButton, totalAcceptedBetsAmount, isUsedStakeUpdateLogic);
                    }
                }
                else {
                    if (+(arg === null || arg === void 0 ? void 0 : arg.userId) === userInfoStore.userId) {
                        iframeService.sendStakeUpdate(platformMessageStore.totalAcceptedBetsAmount + Number(arg === null || arg === void 0 ? void 0 : arg.amount));
                        platformMessageStore === null || platformMessageStore === void 0 ? void 0 : platformMessageStore.setTotalAcceptedBetsAmount(+platformMessageStore.totalAcceptedBetsAmount + Number(arg === null || arg === void 0 ? void 0 : arg.amount));
                    }
                }
                if (isUsedPlatformIntegrationLogic &&
                    !isSentRoundStarted &&
                    +((arg === null || arg === void 0 ? void 0 : arg.userId) || ((_b = arg === null || arg === void 0 ? void 0 : arg.betResult) === null || _b === void 0 ? void 0 : _b.userId)) === +userInfoStore.userId &&
                    !isUsedRoundStartAndFinishedLogicAfterCashOut) {
                    iframeService.sendRoundStarted();
                    if (arg === null || arg === void 0 ? void 0 : arg.betResult) {
                        platformMessageStore.setTotalAcceptedBetsAmount(0);
                        iframeService.sendWinUpdate((_c = arg === null || arg === void 0 ? void 0 : arg.betResult) === null || _c === void 0 ? void 0 : _c.winAmount);
                        iframeService === null || iframeService === void 0 ? void 0 : iframeService.sendRoundFinished((_d = arg === null || arg === void 0 ? void 0 : arg.betResult) === null || _d === void 0 ? void 0 : _d.winAmount, (_e = arg === null || arg === void 0 ? void 0 : arg.betResult) === null || _e === void 0 ? void 0 : _e.amount);
                    }
                }
                if (platformMessageStore.isAutoPlayOnInGame) {
                    iframeService.checkAndSendAutoPlayState(true);
                }
            },
            _b[GameLiveConnectionMethod.CashOutResult] = function (arg) {
                if (isBogLine && gameType !== BOG_LINE_GAME_TYPES.ONLY_MARKET) {
                    hideFreeBetMaxPayoutPopUpAfterCashOut(arg, Number(userInfoStore.userId), freeBetStore.extraFreeBetData, freeBetStore.freeBetSectionIndexes, gameName);
                }
                if (bogLineGameTypeData.isUseCoreDoBetStore && arg) {
                    gameStore.increaseCashOutCounts();
                    var bets = betStore.liveBets;
                    var cashOutLivBets = null;
                    cashOutLivBets = bets.map(function (bet) {
                        if (bet.id === arg.id) {
                            if (arg.freeBetId) {
                                freeBetStore.freeBetTotalWinCalculator(arg);
                            }
                            return arg;
                        }
                        return bet;
                    });
                    betStore.setLiveBets(cashOutLivBets);
                    if (arg.userId === +userInfoStore.userId) {
                        doBetStore.setWinData(arg);
                    }
                }
                if (Number(arg.userId) === Number(userInfoStore.userId)) {
                    freeBetStore.freeBetTotalWinCalculator(arg);
                }
                if (isBogLine && isUsedPlatformIntegrationLogic) {
                    checkCashOutResultAndUpdateGameSectionData(arg, platformMessageStore.updateGameSectionData, Number(userInfoStore.userId), gameType, isAllSectionWithCashOutButton, platformMessageStore.gameSectionsData, isUsedRoundStartAndFinishedLogicAfterCashOut, liveBets, platformMessageStore.updateTotalWinAmount, totalAcceptedBetsAmount, isUsedStakeUpdateLogic, platformMessageStore.setTotalAcceptedBetsAmount);
                }
                else {
                    if ((arg === null || arg === void 0 ? void 0 : arg.userId) === Number(userInfoStore.userId) && isSentRoundStarted && isUsedPlatformIntegrationLogic) {
                        iframeService.sendRoundFinished(arg === null || arg === void 0 ? void 0 : arg.winAmount);
                    }
                }
            },
            _b[GameLiveConnectionMethod.ResultReport] = function (arg) {
                var _a;
                if (isBogLine) {
                    /** for free bet max pay out pop up **/
                    var freeBetSectionIndexes = freeBetStore.freeBetSectionIndexes, extraFreeBetData = freeBetStore.extraFreeBetData;
                    if (bogLineGameTypeData.isUseCoreDoBetStore) {
                        var _b = arg.data, _c = _b.resultReportData, odd_1 = _c.odd, bets_1 = _c.bets, isCrash = _b.isCrash, gameTypeId = _b.gameTypeId;
                        if (gameConfigStore.gameTypeId !== gameTypeId) {
                            return;
                        }
                        if (!gameStore.isBetsClosed) {
                            gameStore.setIsBetsClosed(true);
                        }
                        var activeFreeBet = freeBetStore.activeFreeBet;
                        var doBetSectionsData = doBetStore.doBetSectionsData, freeBetDisable_1 = doBetStore.freeBetDisable, freeBetMinOdd_1 = doBetStore.freeBetMinOdd;
                        var partnerWageringDisabled = gameStore.partnerWageringDisabled, partnerWageringOdd = gameStore.partnerWageringOdd;
                        if (isCrash) {
                            oddStore.setIsCrash(isCrash);
                            oddStore.setOddData(odd_1);
                            doBetStore.handleClearRoundFin();
                        }
                        if (oddStore.isFirstResultReport) {
                            betDataStore.setBetButtonDisable(false);
                            oddStore.setIsFirstResultReport(false);
                        }
                        else {
                            oddStore.setOddData(odd_1);
                            if (betDataStore.betButtonDisable) {
                                betDataStore.setBetButtonDisable(false);
                            }
                        }
                        if (activeFreeBet.id || doBetSectionsData[0].freeBetId || doBetSectionsData[1].freeBetId) {
                            doBetSectionsData.forEach(function (item) {
                                if (freeBetDisable_1 && item.freeBetId && odd_1 >= freeBetMinOdd_1) {
                                    doBetStore.setFreeBetDisableState(false);
                                }
                            });
                        }
                        if (partnerWageringOdd && partnerWageringDisabled) {
                            if (odd_1 >= partnerWageringOdd) {
                                gameStore.setPartnerWageringDisabled(false);
                            }
                        }
                        if (bets_1 === null || bets_1 === void 0 ? void 0 : bets_1.length) {
                            var currentBets = betStore.liveBets;
                            var winData = bets_1.filter(function (item) {
                                gameStore.increaseCashOutCounts();
                                return +userInfoStore.userId === +item.userId;
                            });
                            winData.forEach(function (itemWinData) {
                                freeBetStore.freeBetTotalWinCalculator(itemWinData);
                                doBetStore.setWinData(itemWinData);
                            });
                            var sortWiningPendingLivBets = currentBets.map(function (bet) {
                                var res = bets_1.find(function (item) { return item.id === bet.id; });
                                return res ? __assign({ playerExternalId: bet.playerExternalId }, res) : bet;
                            });
                            betStore.setLiveBets(sortWiningPendingLivBets);
                        }
                    }
                    if (gameType !== BOG_LINE_GAME_TYPES.ONLY_MARKET) {
                        checkShowMaxPayoutPopUpByGame(arg, freeBetSectionIndexes, extraFreeBetData, gameName
                        // isUsedRoundStartAndFinishedLogicAfterCashOut,
                        // platformMessageStore.updateGameSectionData,
                        // isAllSectionWithCashOutButton
                        );
                    }
                    if ((_a = arg.data.bets) === null || _a === void 0 ? void 0 : _a.length) {
                        arg.data.bets.forEach(function (bet) {
                            if (bet.userId === Number(userInfoStore.userId)) {
                                freeBetStore.freeBetTotalWinCalculator(bet);
                            }
                        });
                    }
                    // freeBetStore.handleFreeBetEndedData();
                    if (isUsedPlatformIntegrationLogic) {
                        checkResultReportDataAndUpdateGameSectionData(arg, platformMessageStore.updateGameSectionData, Number(userInfoStore.userId), gameType, isAllSectionWithCashOutButton, platformMessageStore.gameSectionsData, isUsedRoundStartAndFinishedLogicAfterCashOut, liveBets, platformMessageStore.updateTotalWinAmount, totalAcceptedBetsAmount, isUsedStakeUpdateLogic, platformMessageStore.setTotalAcceptedBetsAmount);
                    }
                }
            },
            _b[GameLiveConnectionMethod.BetsClosed] = function () {
                if (bogLineGameTypeData.isUseCoreDoBetStore) {
                    gameStore.setIsBetsClosed(true);
                    betDataStore.setBetButtonDisable(true);
                    gameStore.setCurrentGameState(RoundStatus.OnHold);
                }
            },
            _b[GameLiveConnectionMethod.DoBetResultValidation] = function (arg) {
                var _a, _b, _c;
                var responseCode = arg.responseCode, _d = arg.operatorError, operatorError = _d === void 0 ? null : _d, betResult = arg.betResult;
                if (isUsedPlatformIntegrationLogic && ((betResult && betResult.operatorError) || operatorError)) {
                    notificationStore.setNotificationType(null);
                    notificationStore.setOperatorErrorMessage(betResult ? (_a = betResult === null || betResult === void 0 ? void 0 : betResult.operatorError) === null || _a === void 0 ? void 0 : _a.errorDescription : operatorError === null || operatorError === void 0 ? void 0 : operatorError.errorDescription);
                    iframeService.sendErrorReceived({
                        errorCode: (operatorError === null || operatorError === void 0 ? void 0 : operatorError.errorId) || responseCode || ((_b = arg === null || arg === void 0 ? void 0 : arg.betResult) === null || _b === void 0 ? void 0 : _b.responseCode),
                        // ...(operatorError ? { errorMessage: operatorError.errorDescription } : {}),
                    });
                }
                if (!operatorError &&
                    !platformMessageStore.isShowAllNotification &&
                    isUsedPlatformIntegrationLogic &&
                    BetResponseCodeForHideNotification.includes(responseCode || ((_c = arg === null || arg === void 0 ? void 0 : arg.betResult) === null || _c === void 0 ? void 0 : _c.responseCode))) {
                    platformMessageStore.setIsDoBetResultValidated(true);
                }
                if (responseCode === BetResponseCode.UnAuthorizedUser) {
                    iframeService.sendLoginCheck();
                }
                if (bogLineGameTypeData.isUseCoreDoBetStore) {
                    var index = arg.betData.index;
                    var InsufficientFunds = BetResponseCode.InsufficientFunds, PlayerLimitExceeded = BetResponseCode.PlayerLimitExceeded, GeneralError = BetResponseCode.GeneralError, UnAuthorizedUser = BetResponseCode.UnAuthorizedUser;
                    var isResetAutoBet = [
                        InsufficientFunds,
                        PlayerLimitExceeded,
                        GeneralError,
                        UnAuthorizedUser,
                        // MoneyTransactionError,
                    ].includes(responseCode);
                    var isAutoBet = betDataStore.betsSectionsData[index].isAutoBet;
                    betDataStore.setIsLoaderActive(index, false);
                    if (isAutoBet && isResetAutoBet) {
                        betDataStore.setIsAutoBet(false, index);
                        // doBetStore.setIsDisabledSection(false, index);
                    }
                    doBetStore.resetDoBetStoreBySection(index);
                    doBetStore.changeBetIsDisabled(index, false);
                }
            },
            _b[GameLiveConnectionMethod.GetBalanceResult] = function (arg) {
                if (arg || arg === 0) {
                    // const { balance } = arg;
                    userInfoStore.setBalance(arg);
                    iframeService.sendBalanceUpdated(arg);
                }
                else {
                    iframeService.sendLoginCheck();
                }
            },
            _b[GameLiveConnectionMethod.GetUserBetsHistoryResult] = function (arg) {
                betStore.getBetHistoryDataParser({ data: { result: arg } });
            },
            _b[GameLiveConnectionMethod.AutoCashOutResultReport] = function (arg) {
                var _a;
                if (isBogLine) {
                    arg.data.resultReportData.bets;
                    var extraFreeBetData = freeBetStore.extraFreeBetData;
                    if (gameType !== BOG_LINE_GAME_TYPES.ONLY_MARKET) {
                        autoCashOutResultReportEventMaxPayout(arg, extraFreeBetData, gameName);
                    }
                    if ((_a = arg.data.bets) === null || _a === void 0 ? void 0 : _a.length) {
                        arg.data.bets.forEach(function (bet) {
                            if (bet.userId === Number(userInfoStore.userId)) {
                                freeBetStore.freeBetTotalWinCalculator(bet);
                            }
                        });
                    }
                    if (isUsedPlatformIntegrationLogic) {
                        checkResultReportDataAndUpdateGameSectionData(arg, platformMessageStore.updateGameSectionData, Number(userInfoStore.userId), gameType, isAllSectionWithCashOutButton, platformMessageStore.gameSectionsData, isUsedRoundStartAndFinishedLogicAfterCashOut, liveBets, platformMessageStore.updateTotalWinAmount, totalAcceptedBetsAmount, isUsedStakeUpdateLogic, platformMessageStore.setTotalAcceptedBetsAmount);
                    }
                }
            },
            _b);
        methods[methodName](data);
    };
    return BaseLiveConnection;
}());

var GameLiveConnection = /** @class */ (function (_super) {
    __extends$1(GameLiveConnection, _super);
    function GameLiveConnection(_a) {
        var url = _a.url;
        return _super.call(this, url) || this;
    }
    GameLiveConnection.prototype.sendGetInitialState = function (getInitialParams, additionalLiveConnectionMethod) {
        var _this = this;
        var gameId = +getInitialParams.gameId || +gameConfigStore.gameId;
        var isDemo = getInitialParams.isDemo !== undefined ? getInitialParams.isDemo : applicationStore.isDemo;
        var tournamentId = getInitialParams.tournamentId ? getInitialParams.tournamentId : betStore.tournamentId;
        var params = __assign(__assign({}, getInitialParams), { gameId: gameId, isDemo: isDemo, tournamentId: tournamentId });
        return new Promise(function (resolve, reject) {
            _this.connection
                .invoke(additionalLiveConnectionMethod ? additionalLiveConnectionMethod : GameLiveConnectionMethod.GetInitialState, params)
                .then(function (data) {
                resolve(data);
            })
                .catch(function (err) {
                reject(err);
                console.log('unauthorized user');
                iframeService.sendLoginCheck();
            });
        });
    };
    GameLiveConnection.prototype.ping = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.connection) {
            return (_a = this.connection).invoke.apply(_a, __spreadArray([GameLiveConnectionMethod.Ping], __read(args), false));
        }
    };
    GameLiveConnection.prototype.getBalance = function (isNeedSendGameId, getBalanceParams) {
        var _this = this;
        if (isNeedSendGameId === void 0) { isNeedSendGameId = true; }
        if (getBalanceParams === void 0) { getBalanceParams = {}; }
        if (this.connection) {
            var gameId = gameConfigStore.gameId;
            if (isNeedSendGameId) {
                getBalanceParams.gameId = gameId;
            }
            return new Promise(function (resolve) {
                if (isNeedSendGameId) {
                    _this.connection
                        .invoke(GameLiveConnectionMethod.GetBalance, getBalanceParams)
                        .then(function (data) { return resolve(data); })
                        .catch(function (err) {
                        // reject(err);
                        // console.log('unauthorized user GetBalance');
                        // iframeService.sendLoginCheck();
                        // if (platformMessageStore.isUsedGetBalanceBySocketInvoke) {
                        //   platformMessageStore.setIsUsedGetBalanceBySocketInvoke(false);
                        // }
                        // userInfoStore.getUserBalance();
                    });
                }
                else {
                    _this.connection
                        .invoke(GameLiveConnectionMethod.GetBalance)
                        .then(function (data) { return resolve(data); })
                        .catch(function (err) {
                        // reject(err);
                        // console.log('unauthorized user GetBalance');
                        // iframeService.sendLoginCheck();
                        // if (platformMessageStore.isUsedGetBalanceBySocketInvoke) {
                        //   platformMessageStore.setIsUsedGetBalanceBySocketInvoke(false);
                        // }
                        // userInfoStore.getUserBalance();
                    });
                }
            });
        }
    };
    GameLiveConnection.prototype.doBet = function (args) {
        var _this = this;
        if (this.connection && !(popupStore.reloadFrameForUnderMaintenanceOnRoundStart && popupStore.underMaintenance)) {
            var _a = parseQuery(window.location.search), _b = DefaultQueryParams.CheckBalanceOnBet, checkBalanceOnBet = _a[_b];
            var isDemo = applicationStore.isDemo;
            var gameId = args.gameId || gameConfigStore.gameId;
            var partnerId = args.partnerId || gameConfigStore.partnerId;
            var demoUserId = args.demoUserId || userInfoStore.demoUserId || null;
            var tournamentId = args.tournamentId ? args.tournamentId : betStore.tournamentId;
            var params_1 = __assign(__assign({}, args), { gameId: gameId, partnerId: partnerId, demoUserId: demoUserId, tournamentId: tournamentId });
            if (!isDemo &&
                Boolean(Number(checkBalanceOnBet)) &&
                !params_1.freeBetId &&
                !params_1.tournamentId &&
                !validateBalanceOnBet(params_1)) {
                if (userSettingsStore.gameService) {
                    var playerExternalId_1 = userInfoStore.playerExternalId, userId_1 = userInfoStore.userId;
                    var gameService = userSettingsStore.gameService;
                    var handleDoBetResultValidation_1 = gameService.handleDoBetResultValidation.bind(gameService);
                    setTimeout(function () {
                        // BACK END DELAY IMITATION GAME
                        handleDoBetResultValidation_1(__assign(__assign({}, params_1), { playerExternalId: playerExternalId_1, userId: userId_1, responseCode: BetResponseCode.InsufficientFunds }));
                    }, 0);
                }
                else {
                    console.error('please add gameService in INIT');
                }
                return;
            }
            return new Promise(function (resolve, reject) {
                _this.connection
                    .invoke(GameLiveConnectionMethod.DoBet, params_1)
                    .then(function (data) {
                    resolve(data);
                })
                    .catch(function (err) {
                    reject(err);
                    console.log('unauthorized user');
                    iframeService.sendLoginCheck();
                });
            });
        }
    };
    GameLiveConnection.prototype.onGetInitialStateResult = function (callback, additionalMillisecondsForRemoveLoading) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.GetInitialStateResult, function (data) {
            var gameTypeId = data.gameTypeId, demoUserId = data.demoUserId, avatarId = data.avatarId, userFreebets = data.userFreebets, gameTypes = data.gameTypes, underMaintenance = data.underMaintenance, _a = data.gameTypeInfos, gameTypeInfos = _a === void 0 ? null : _a, currentBets = data.currentBets, rate = data.rate, balance = data.balance, precision = data.precision, currencyCode = data.currencyCode, roundInfo = data.roundInfo, limits = data.limits, partnerWageringOdd = data.partnerWageringOdd;
            userInfoStore.setUserInfo({
                rate: rate,
                balance: balance,
                precision: precision,
                currencyCode: currencyCode,
                userId: demoUserId,
            });
            if (callback) {
                callback(data);
            }
            if (underMaintenance) {
                _this.callbackMiddleware({
                    methodName: CommonConnectionsMethod.UnderMaintenance,
                    data: underMaintenance,
                });
            }
            _this.callbackMiddleware({
                methodName: "".concat(ConnectionPrefix.Game, "_").concat(GameLiveConnectionMethod.GetInitialStateResult),
                data: {
                    gameTypeId: gameTypeId,
                    avatarId: avatarId,
                    userFreebets: userFreebets,
                    gameTypes: gameTypes,
                    gameTypeInfos: gameTypeInfos,
                    partnerWageringOdd: partnerWageringOdd,
                    currentBets: currentBets,
                    additionalMillisecondsForRemoveLoading: additionalMillisecondsForRemoveLoading,
                    roundInfo: roundInfo,
                    limits: limits,
                },
            });
        });
    };
    GameLiveConnection.prototype.onDoBetResult = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.DoBetResult, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: GameLiveConnectionMethod.DoBetResult,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onCashOutResult = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.CashOutResult, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: GameLiveConnectionMethod.CashOutResult,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onFreeBetAwarded = function (callback) {
        var _this = this;
        return this.on(CommonConnectionsMethod.FreeBetAwarded, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: CommonConnectionsMethod.FreeBetAwarded,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onFreeBetCountUpdate = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.FreeBetCountUpdate, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: GameLiveConnectionMethod.FreeBetCountUpdate,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onFreeBetEnded = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.FreeBetEnded, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: GameLiveConnectionMethod.FreeBetEnded,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onDoBetResultValidation = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.DoBetResultValidation, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: GameLiveConnectionMethod.DoBetResultValidation,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onRoundFinished = function (callback, gameSpecificAdditionalParams) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.RoundFinished, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: "".concat(ConnectionPrefix.Game, "_").concat(GameLiveConnectionMethod.RoundFinished),
                data: __assign(__assign({}, data), { gameSpecificAdditionalParams: gameSpecificAdditionalParams }),
            });
        });
    };
    GameLiveConnection.prototype.onRoundStarted = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.RoundStarted, function (data) {
            var underMaintenance = data.data.underMaintenance;
            if (underMaintenance) {
                popupStore.setReloadFrameForUnderMaintenanceOnRoundStart(true);
            }
            else {
                if (popupStore.underMaintenance && popupStore.reloadFrameForUnderMaintenanceOnCountDown) {
                    popupStore.resetUnderMaintenanceData();
                }
            }
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: GameLiveConnectionMethod.RoundStarted,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onResultReport = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.ResultReport, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: GameLiveConnectionMethod.ResultReport,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onMaintenanceNotify = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.MaintenanceNotify, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                data: data,
                methodName: CommonConnectionsMethod.UnderMaintenance,
            });
        });
    };
    GameLiveConnection.prototype.onBalanceUpdate = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.BalanceUpdate, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                data: data,
                methodName: GameLiveConnectionMethod.BalanceUpdate,
            });
        });
    };
    GameLiveConnection.prototype.onPing = function (callback) {
        return this.on(GameLiveConnectionMethod.Ping, callback);
    };
    GameLiveConnection.prototype.onBetsClosed = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.BetsClosed, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                data: data,
                methodName: GameLiveConnectionMethod.BetsClosed,
            });
        });
    };
    GameLiveConnection.prototype.onLobbyUsersCount = function (callback) {
        var _this = this;
        return this.on(CommonConnectionsMethod.LobbyUsersCount, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: CommonConnectionsMethod.LobbyUsersCount,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onUserTournamentInfo = function (callback) {
        return this.on(GameLiveConnectionMethod.UserTournamentInfo, callback);
    };
    GameLiveConnection.prototype.onGameOpen = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.GameOpen, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: GameLiveConnectionMethod.GameOpen,
                data: data,
            });
        });
    };
    GameLiveConnection.prototype.onGetBalanceResult = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.GetBalanceResult, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                data: data,
                methodName: GameLiveConnectionMethod.GetBalanceResult,
            });
        });
    };
    GameLiveConnection.prototype.getUserBetsHistory = function (userBetsHistoryParams) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.connection
                .invoke(GameLiveConnectionMethod.GetUserBetsHistory, userBetsHistoryParams)
                .then(function (data) {
                resolve(data);
            })
                .catch(function (err) {
                reject(err);
                console.log('unauthorized user');
                iframeService.sendLoginCheck();
            });
        });
    };
    GameLiveConnection.prototype.onGetUserBetsHistoryResult = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.GetUserBetsHistoryResult, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                data: data,
                methodName: GameLiveConnectionMethod.GetUserBetsHistoryResult,
            });
        });
    };
    GameLiveConnection.prototype.onAutoCashOutResultReport = function (callback) {
        var _this = this;
        return this.on(GameLiveConnectionMethod.AutoCashOutResultReport, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                data: data,
                methodName: GameLiveConnectionMethod.AutoCashOutResultReport,
            });
        });
    };
    return GameLiveConnection;
}(BaseLiveConnection));

var LobbyLiveConnection = /** @class */ (function (_super) {
    __extends$1(LobbyLiveConnection, _super);
    function LobbyLiveConnection(_a) {
        var url = _a.url;
        return _super.call(this, url) || this;
    }
    LobbyLiveConnection.prototype.sendGetInitialState = function (partnerId, gameId) {
        return this.invoke(LobbyLiveConnectionMethod.GetInitialState, {
            partnerId: partnerId,
            gameId: gameId || gameConfigStore.gameId,
        });
    };
    LobbyLiveConnection.prototype.onGetInitialStateResult = function (callback) {
        var _this = this;
        return this.on(LobbyLiveConnectionMethod.GetInitialStateResult, function (data) {
            if (callback) {
                callback(data);
            }
            var underMaintenance = data.underMaintenance, currentWinners = data.currentWinners, sliderBanners = data.sliderBanners, hasDemo = data.hasDemo, animationDuration = data.animationDuration, gameTypes = data.gameTypes, userFreebets = data.userFreebets;
            if (underMaintenance) {
                _this.callbackMiddleware({
                    methodName: CommonConnectionsMethod.UnderMaintenance,
                    data: underMaintenance,
                });
            }
            _this.callbackMiddleware({
                methodName: "".concat(ConnectionPrefix.Lobby, "_").concat(LobbyLiveConnectionMethod.GetInitialStateResult),
                data: {
                    hasDemo: hasDemo,
                    gameTypes: gameTypes,
                    userFreebets: userFreebets,
                    sliderBanners: sliderBanners,
                    currentWinners: currentWinners,
                    underMaintenance: underMaintenance,
                    animationDuration: animationDuration,
                },
            });
        });
    };
    LobbyLiveConnection.prototype.onRoundFinished = function (callback) {
        var _this = this;
        return this.on(LobbyLiveConnectionMethod.RoundFinished, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: "".concat(ConnectionPrefix.Lobby, "_").concat(LobbyLiveConnectionMethod.RoundFinished),
                data: data,
            });
        });
    };
    LobbyLiveConnection.prototype.onFreeBetAwarded = function (callback) {
        var _this = this;
        return this.on(CommonConnectionsMethod.FreeBetAwarded, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: CommonConnectionsMethod.FreeBetAwarded,
                data: data,
            });
        });
    };
    LobbyLiveConnection.prototype.onLobbyUsersCount = function (callback) {
        var _this = this;
        return this.on(CommonConnectionsMethod.LobbyUsersCount, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: CommonConnectionsMethod.LobbyUsersCount,
                data: data,
            });
        });
    };
    LobbyLiveConnection.prototype.onMaintenanceNotify = function (callback) {
        var _this = this;
        return this.on(LobbyLiveConnectionMethod.MaintenanceNotify, function (data) {
            if (callback) {
                callback(data);
            }
            _this.callbackMiddleware({
                methodName: CommonConnectionsMethod.UnderMaintenance,
                data: data,
            });
        });
    };
    return LobbyLiveConnection;
}(BaseLiveConnection));

var TranslationService = /** @class */ (function () {
    function TranslationService(_a) {
        var url = _a.url;
        this.url = url;
    }
    TranslationService.prototype.getTranslations = function (request) {
        var applicationId = request.applicationId, params = __rest(request, ["applicationId"]);
        return httpClient.get(this.url, {
            params: params,
            headers: { applicationId: applicationId },
        });
    };
    return TranslationService;
}());

var bannerImageTypeList = ['jpg', 'png', 'gif', 'svg'];
var gameTypeIntervalIds = {};
var gameTypeTimeByIds = {};
var LobbyStore = /** @class */ (function () {
    function LobbyStore() {
        this.gameTypes = [];
        this.hasDemo = true;
        this.roomName = '';
        this.lobbyDurationsByGameTypeId = {};
        this.sliderBanners = [];
        this.roundFinAnimationDuration = 0;
        this.isShowLobbySelectGameType = true;
        this.isShowGameTypeLoading = false;
        makeObservable(this, {
            roundFinAnimationDuration: observable,
            isShowLobbySelectGameType: observable,
            isShowGameTypeLoading: observable,
            lobbyDurationsByGameTypeId: observable.deep,
            roomName: observable.deep,
            gameTypes: observable.deep,
            hasDemo: observable.deep,
            sliderBanners: observable.deep,
            setGameTypes: action.bound,
            setHasDemo: action.bound,
            setRoomName: action.bound,
            setSliderBanners: action.bound,
            setRoundFinAnimationDuration: action.bound,
            setLobbyDurationsByGameTypeId: action.bound,
            setRoundTimeByGameTypes: action.bound,
            setIsShowLobbySelectGameType: action.bound,
            setIsShowGameTypeLoading: action.bound,
        });
    }
    LobbyStore.prototype.setLobbyDurationsByGameTypeId = function (arg) {
        this.lobbyDurationsByGameTypeId = arg;
    };
    LobbyStore.prototype.setGameTypes = function (gameTypes) {
        this.gameTypes = gameTypes;
    };
    LobbyStore.prototype.setHasDemo = function (hasDemo) {
        this.hasDemo = hasDemo;
    };
    LobbyStore.prototype.setRoomName = function (name) {
        this.roomName = name;
    };
    LobbyStore.prototype.setRoundFinAnimationDuration = function (animationDuration) {
        this.roundFinAnimationDuration = animationDuration ? animationDuration * 1000 : this.roundFinAnimationDuration;
    };
    LobbyStore.prototype.setSliderBanners = function (banners) {
        var httpFilesUrl = environmentBuilder().httpFilesUrl;
        this.sliderBanners = banners
            .sort(function (a, b) { return a.priority - b.priority; })
            .map(function (banner, index) {
            var _a;
            var bannerType = (_a = banner === null || banner === void 0 ? void 0 : banner.url) === null || _a === void 0 ? void 0 : _a.split('.').pop();
            var isVideo = banner.isVideo || !bannerImageTypeList.includes(bannerType);
            return __assign(__assign({}, banner), { url: "".concat(httpFilesUrl, "/").concat(banner.url), id: index + 1, isVideo: isVideo, isActive: !index, isPrev: false });
        });
    };
    LobbyStore.prototype.setRoundTimeByGameTypes = function (gameTypeId, time) {
        var _this = this;
        if (gameTypeIntervalIds[gameTypeId]) {
            clearInterval(gameTypeIntervalIds[gameTypeId]);
            gameTypeIntervalIds[gameTypeId] = null;
        }
        gameTypeTimeByIds[gameTypeId] = Math.floor(time) <= 0 ? 0 : Math.floor(time);
        this.setLobbyDurationsByGameTypeId(__assign(__assign({}, this.lobbyDurationsByGameTypeId), { gameTypeId: gameTypeTimeByIds[gameTypeId] }));
        gameTypeIntervalIds[gameTypeId] = setInterval(function () {
            var _a;
            gameTypeTimeByIds[gameTypeId] = gameTypeTimeByIds[gameTypeId] - 1 <= 0 ? 0 : gameTypeTimeByIds[gameTypeId] - 1;
            _this.setLobbyDurationsByGameTypeId(__assign(__assign({}, _this.lobbyDurationsByGameTypeId), (_a = {}, _a[gameTypeId] = gameTypeTimeByIds[gameTypeId], _a)));
            if (gameTypeTimeByIds[gameTypeId] === 0) {
                clearInterval(gameTypeIntervalIds[gameTypeId]);
                gameTypeIntervalIds[gameTypeId] = null;
            }
        }, 1000);
    };
    LobbyStore.prototype.setIsShowLobbySelectGameType = function (bool) {
        this.isShowLobbySelectGameType = bool;
    };
    LobbyStore.prototype.setIsShowGameTypeLoading = function (bool) {
        if (this.isShowGameTypeLoading && !bool) {
            userSettingsStore.setIsMusicOnAndIsSoundOn(userSettingsStore.isSilentMode);
        }
        this.isShowGameTypeLoading = bool;
    };
    return LobbyStore;
}());
var lobbyStore = new LobbyStore();

var UserInfoStore = /** @class */ (function () {
    function UserInfoStore() {
        this.rate = 1;
        this.precision = 2;
        this.playerExternalId = '';
        this.userId = '';
        this.demoUserId = '';
        this._currencyCode = '';
        this._demoCurrencyCode = 'Fun';
        this._currencySymbol = '';
        this._balance = 0;
        this._demoInitialBalance = 500000;
        this._demoBalance = this._demoInitialBalance;
        makeObservable(this, {
            rate: observable,
            precision: observable,
            currencyCode: computed,
            currencySymbolOrCode: computed,
            realCurrencySymbolOrCode: computed,
            realCurrencyCode: computed,
            balance: computed,
            playerExternalId: observable,
            userId: observable,
            demoUserId: observable,
            _demoBalance: observable,
            _balance: observable,
            _demoCurrencyCode: observable,
            _currencyCode: observable,
            usersService: computed,
            setRate: action.bound,
            setUserId: action.bound,
            setBalance: action.bound,
            setUserInfo: action.bound,
            setPrecision: action.bound,
            getUserBalance: flow.bound,
            setDemoBalance: action.bound,
            setDemoUserId: action.bound,
            setCurrencyCode: action.bound,
            setCurrencySymbol: action.bound,
            setPlayerExternalId: action.bound,
            setDemoInitialBalance: action.bound,
        });
    }
    UserInfoStore.prototype.setUserInfo = function (userInfo) {
        var rate = userInfo.rate, precision = userInfo.precision, currencyCode = userInfo.currencyCode, currencySymbol = userInfo.currencySymbol, balance = userInfo.balance, playerExternalId = userInfo.playerExternalId, demoBalance = userInfo.demoBalance, userId = userInfo.userId;
        this.setRate(rate);
        this.setPrecision(precision);
        this.setCurrencyCode(currencyCode);
        this.setCurrencySymbol(currencySymbol);
        this.setBalance(balance);
        this.setPlayerExternalId(playerExternalId);
        if (!this.userId) {
            this.setUserId(userId);
        }
        if (demoBalance) {
            this.setDemoBalance(demoBalance);
        }
    };
    UserInfoStore.prototype.setRate = function (rate) {
        this.rate = rate;
    };
    UserInfoStore.prototype.setUserId = function (userId) {
        if (userId) {
            this.userId = userId;
        }
        else {
            var _a = parseQuery(window.location.search), _b = DefaultQueryParams.UserId, userIdFromQuery = _a[_b];
            this.userId = +userIdFromQuery;
        }
    };
    UserInfoStore.prototype.setPrecision = function (precision) {
        this.precision = precision;
    };
    UserInfoStore.prototype.setCurrencyCode = function (currencyCode) {
        this._currencyCode = currencyCode;
    };
    UserInfoStore.prototype.setCurrencySymbol = function (currencySymbol) {
        if (currencySymbol) {
            this._currencySymbol = currencySymbol;
        }
        else {
            var _a = parseQuery(window.location.search), _b = DefaultQueryParams.CurrencySymbol, currencySymbolFromQuery = _a[_b];
            this._currencySymbol = currencySymbolFromQuery;
        }
    };
    UserInfoStore.prototype.setBalance = function (balance) {
        this._balance = balance;
    };
    UserInfoStore.prototype.setPlayerExternalId = function (playerExternalId) {
        if (playerExternalId) {
            this.playerExternalId = playerExternalId;
        }
        else {
            var _a = parseQuery(window.location.search), _b = DefaultQueryParams.PlayerExternalId, playerExternalIdFromQuery = _a[_b];
            this.playerExternalId = playerExternalIdFromQuery;
        }
    };
    UserInfoStore.prototype.setDemoInitialBalance = function () {
        this._demoBalance = this._demoInitialBalance;
    };
    UserInfoStore.prototype.setDemoBalance = function (demoBalance) {
        this._demoBalance = parseNumberByPrecision(demoBalance, 1);
    };
    UserInfoStore.prototype.setDemoUserId = function (demoUserId) {
        this.demoUserId = demoUserId;
    };
    UserInfoStore.prototype.getUserBalance = function () {
        var isAuthenticated, isDemo, isRepliedGame, result, balance;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isAuthenticated = applicationStore.isAuthenticated, isDemo = applicationStore.isDemo;
                    isRepliedGame = platformMessageStore.isRepliedGame;
                    if (!(isAuthenticated && !isDemo && !isRepliedGame)) return [3 /*break*/, 6];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    if (!this.usersService) return [3 /*break*/, 3];
                    return [4 /*yield*/, this.usersService.getBalance()];
                case 2:
                    result = (_a.sent()).data.result;
                    if (result) {
                        balance = result.balance;
                        this.setBalance(balance);
                        iframeService.sendBalanceUpdated(balance);
                    }
                    else {
                        iframeService.sendLoginCheck();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    console.error('please integrate users service');
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    _a.sent();
                    iframeService.sendLoginCheck();
                    console.error('get balance error');
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    };
    Object.defineProperty(UserInfoStore.prototype, "usersService", {
        get: function () {
            return ApiServices.get(ApiServiceTypes.UsersService);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserInfoStore.prototype, "balance", {
        get: function () {
            var isDemo = applicationStore.isDemo, useDemoByBackendLogic = applicationStore.useDemoByBackendLogic;
            if (useDemoByBackendLogic) {
                return this._balance;
            }
            return isDemo ? this._demoBalance : this._balance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserInfoStore.prototype, "currencyCode", {
        get: function () {
            var isDemo = applicationStore.isDemo;
            return isDemo ? this._demoCurrencyCode : this._currencyCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserInfoStore.prototype, "currencySymbolOrCode", {
        get: function () {
            var isDemo = applicationStore.isDemo;
            var repliedBetData = betStore.repliedBetData;
            return isDemo
                ? this._demoCurrencyCode
                : repliedBetData
                    ? repliedBetData === null || repliedBetData === void 0 ? void 0 : repliedBetData.currencyCode
                    : this._currencySymbol || this.currencyCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserInfoStore.prototype, "realCurrencySymbolOrCode", {
        get: function () {
            return this._currencySymbol || this._currencyCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserInfoStore.prototype, "realCurrencyCode", {
        get: function () {
            return this._currencyCode;
        },
        enumerable: false,
        configurable: true
    });
    return UserInfoStore;
}());
var userInfoStore = new UserInfoStore();

var FreeBetStore = /** @class */ (function () {
    function FreeBetStore() {
        this.isAllowChangeFreeBet = true;
        this.freeBets = [];
        this.activeFreeBet = {};
        this.endedFreeBets = [];
        this.freeBetEnded = null;
        this.awardedFreeBet = null;
        this.expireDayCount = null;
        this.firstExpireFreeBetTimeOutId = null;
        this.firstExpireFreeBetsData = [];
        this.freeBetSectionIndexes = null;
        this.extraFreeBetData = FreeBetInitialData;
        this.isFreeChip = false;
        makeObservable(this, {
            freeBetEnded: observable,
            awardedFreeBet: observable,
            expireDayCount: observable,
            isAllowChangeFreeBet: observable,
            isFreeChip: observable,
            freeBets: observable.deep,
            activeFreeBet: observable.deep,
            endedFreeBets: observable.deep,
            extraFreeBetData: observable.deep,
            freeBetSectionIndexes: observable.deep,
            firstExpireFreeBetTimeOutId: observable,
            firstExpireFreeBetsData: observable.deep,
            unUseFreeBetCount: computed,
            setFreeBets: action.bound,
            selectFreeBet: action.bound,
            handleUseLater: action.bound,
            updatedFreeBets: action.bound,
            setFreeBetEnded: action.bound,
            setEndedFreeBets: action.bound,
            createExpireDate: action.bound,
            setAwardedFreeBet: action.bound,
            setExpireDayCount: action.bound,
            setIsFreeChip: action.bound,
            resetExtraFreeBetData: action.bound,
            updateExtraFreeBetData: action.bound,
            setActivateFreeBet: action.bound,
            resetActiveFreeBet: action.bound,
            handleEndedFreeBets: action.bound,
            setIsAllowChangeFreeBet: action.bound,
            resetFreeBetDependOnRemainingCount: action.bound,
            handleExpireFreeBets: action.bound,
            selectFreeBetInStatus: action.bound,
            handleAwardedFreeBets: action.bound,
            freeBetsSortFunctional: action.bound,
            setFreeBetSectionIndexes: action.bound,
            resetFreeBetSectionIndexes: action.bound,
            handleFreeBetDoBetResult: action.bound,
            checkFirstExpireFreeBets: action.bound,
            handleFreeBetsInitialData: action.bound,
            freeBetTotalWinCalculator: action.bound,
            changeExpireFreeBetsStatus: action.bound,
            setFirstExpireFreeBetsData: action.bound,
            resetOldAndGenerateNewExpireData: action.bound,
            freeBetsStatusChanger: flow.bound,
        });
    }
    FreeBetStore.prototype.setFreeBets = function (freeBetsList) {
        this.freeBets = freeBetsList;
    };
    FreeBetStore.prototype.updatedFreeBets = function (freeBet) {
        this.freeBets = __spreadArray(__spreadArray([], __read(freeBet), false), __read(this.freeBets), false);
    };
    FreeBetStore.prototype.setActivateFreeBet = function (freeBet, isUpdate) {
        this.activeFreeBet = freeBet;
        if (!isUpdate) {
            var onFreeBetActivateCallback = gameConfigStore.gameConfigs.onFreeBetActivateCallback;
            if (onFreeBetActivateCallback) {
                onFreeBetActivateCallback();
            }
        }
    };
    FreeBetStore.prototype.setFreeBetEnded = function (freeBet) {
        this.freeBetEnded = freeBet;
    };
    FreeBetStore.prototype.setAwardedFreeBet = function (freeBet) {
        this.awardedFreeBet = freeBet;
    };
    FreeBetStore.prototype.resetActiveFreeBet = function () {
        var _a;
        if ((_a = this.activeFreeBet) === null || _a === void 0 ? void 0 : _a.id) {
            this.activeFreeBet = {};
            var onFreeBetDeactivateCallback = gameConfigStore.gameConfigs.onFreeBetDeactivateCallback;
            if (onFreeBetDeactivateCallback) {
                onFreeBetDeactivateCallback();
            }
        }
    };
    FreeBetStore.prototype.setEndedFreeBets = function (freeBetList) {
        this.endedFreeBets = freeBetList;
    };
    FreeBetStore.prototype.selectFreeBet = function (freeBet) {
        if (this.isAllowChangeFreeBet) {
            if (this.activeFreeBet.id === freeBet.id) {
                this.resetActiveFreeBet();
            }
            else {
                this.setActivateFreeBet(freeBet);
            }
        }
    };
    FreeBetStore.prototype.selectFreeBetInStatus = function (freeBetId) {
        if (this.isAllowChangeFreeBet) {
            var useFreeBetItem = this.freeBets.find(function (freeBet) { return freeBet.id === freeBetId; });
            if ((useFreeBetItem === null || useFreeBetItem === void 0 ? void 0 : useFreeBetItem.remainingCount) === 0) {
                this.setAwardedFreeBet(null);
                this.resetActiveFreeBet();
            }
            else {
                this.freeBetsStatusChanger(freeBetId);
                this.setActivateFreeBet(useFreeBetItem);
                if (applicationStore.isBogLine) {
                    lobbyStore.setIsShowLobbySelectGameType(false);
                }
            }
        }
    };
    FreeBetStore.prototype.setFreeBetSectionIndexes = function (gameTypeInfos) {
        this.freeBetSectionIndexes = gameTypeInfos.reduce(function (acc, curr, currentIndex) {
            var _a;
            return __assign(__assign({}, acc), (_a = {}, _a[curr === null || curr === void 0 ? void 0 : curr.gameTypeId] = currentIndex, _a));
        }, {});
    };
    FreeBetStore.prototype.resetFreeBetSectionIndexes = function () {
        this.freeBetSectionIndexes = null;
    };
    FreeBetStore.prototype.updateExtraFreeBetData = function (freeBetParams) {
        var _a, _b;
        var _c;
        var sectionId = freeBetParams.sectionId, _d = freeBetParams.updatedDataByKeys, updatedDataByKeys = _d === void 0 ? null : _d, _e = freeBetParams.updatedDataKey, updatedDataKey = _e === void 0 ? null : _e, _f = freeBetParams.newData, newData = _f === void 0 ? null : _f;
        if (sectionId || sectionId === 0) {
            this.extraFreeBetData = __assign(__assign({}, this.extraFreeBetData), (_a = {}, _a[sectionId] = __assign(__assign({}, (((_c = this.extraFreeBetData) === null || _c === void 0 ? void 0 : _c[sectionId]) || {})), (updatedDataKey && newData ? (_b = {}, _b[updatedDataKey] = newData, _b) : updatedDataByKeys)), _a));
        }
    };
    FreeBetStore.prototype.resetExtraFreeBetData = function (sectionIndex) {
        var _a;
        if (sectionIndex || sectionIndex === 0) {
            this.extraFreeBetData = __assign(__assign({}, this.extraFreeBetData), (_a = {}, _a[sectionIndex] = FreeBetInitialData === null || FreeBetInitialData === void 0 ? void 0 : FreeBetInitialData[sectionIndex], _a));
        }
        else {
            this.extraFreeBetData = FreeBetInitialData;
        }
    };
    FreeBetStore.prototype.handleUseLater = function (freeBetId) {
        var _this = this;
        var useFreeBetItem = this.freeBets.find(function (freeBet) { return freeBet.id === freeBetId; });
        if (useFreeBetItem === null || useFreeBetItem === void 0 ? void 0 : useFreeBetItem.remainingCount) {
            setTimeout(function () { return _this.freeBetsStatusChanger(freeBetId); }, 0);
        }
        else {
            this.setAwardedFreeBet(null);
        }
    };
    Object.defineProperty(FreeBetStore.prototype, "unUseFreeBetCount", {
        get: function () {
            return this.freeBets.reduce(function (acc, freeBet) {
                return (freeBet === null || freeBet === void 0 ? void 0 : freeBet.status) !== FreeBetsStatus.Expired && (freeBet === null || freeBet === void 0 ? void 0 : freeBet.status) !== FreeBetsStatus.Finished
                    ? acc + freeBet.remainingCount
                    : acc;
            }, 0);
        },
        enumerable: false,
        configurable: true
    });
    FreeBetStore.prototype.setExpireDayCount = function (count) {
        this.expireDayCount = count;
    };
    FreeBetStore.prototype.handleExpireFreeBets = function (freeBetId) {
        var updatedExpireFreeBetsData = this.freeBets.map(function (item) {
            return item.id === freeBetId ? __assign(__assign({}, item), { status: FreeBetsStatus.Expired }) : item;
        });
        this.setFreeBets(updatedExpireFreeBetsData);
    };
    FreeBetStore.prototype.createExpireDate = function () {
        var checkDateNow = +new Date();
        var dayCount = +new Date(this.firstExpireFreeBetsData[0].expireDate) - checkDateNow;
        this.setExpireDayCount(dayCount);
    };
    FreeBetStore.prototype.checkFirstExpireFreeBets = function () {
        var inProcessFreeBets = this.freeBets
            .filter(function (item) { return item.status === FreeBetsStatus.Accepted || item.status === FreeBetsStatus.Pending; })
            .sort(function (a, b) { return +new Date(b.receiveDateForSort) - +new Date(a.receiveDateForSort); });
        if (inProcessFreeBets.length) {
            var firstExpireFreeBet_1 = inProcessFreeBets[0];
            var currentExpireFreeBets = inProcessFreeBets.filter(function (item) { return item.expireDate === firstExpireFreeBet_1.expireDate; });
            if (currentExpireFreeBets.length) {
                var firstExpireFreeBets = currentExpireFreeBets.map(function (item) { return ({
                    freeBetId: item.id,
                    expireDate: item.expireDate,
                    isExpire: false,
                }); });
                this.setFirstExpireFreeBetsData(firstExpireFreeBets);
                this.createExpireDate();
                this.changeExpireFreeBetsStatus();
            }
        }
    };
    FreeBetStore.prototype.setFirstExpireFreeBetsData = function (freeBetsList) {
        this.firstExpireFreeBetsData = freeBetsList;
    };
    FreeBetStore.prototype.changeExpireFreeBetsStatus = function () {
        var _this = this;
        if (this.expireDayCount <= TimeoutMaxValue.maximumDelay) {
            if (this.firstExpireFreeBetTimeOutId || this.firstExpireFreeBetTimeOutId === 0) {
                clearTimeout(this.firstExpireFreeBetTimeOutId);
            }
            this.firstExpireFreeBetTimeOutId = setTimeout(function () {
                var updatedExpireFreeBetsData = _this.firstExpireFreeBetsData.map(function (item) { return (__assign(__assign({}, item), { isExpire: true })); });
                _this.setFirstExpireFreeBetsData(updatedExpireFreeBetsData);
                _this.firstExpireFreeBetsData.forEach(function (item) {
                    _this.handleExpireFreeBets(item.freeBetId);
                    if (item.freeBetId === _this.activeFreeBet.id) {
                        _this.resetActiveFreeBet();
                    }
                });
                _this.resetOldAndGenerateNewExpireData();
                _this.setFreeBets(_this.freeBetsSortFunctional(_this.freeBets));
            }, this.expireDayCount);
        }
    };
    FreeBetStore.prototype.resetOldAndGenerateNewExpireData = function () {
        this.setFirstExpireFreeBetsData([]);
        this.setExpireDayCount(null);
        this.checkFirstExpireFreeBets();
    };
    FreeBetStore.prototype.freeBetsStatusChanger = function (freeBetId) {
        var updateFreeBetsData, remainingAwardedFreeBets_1, error_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiServices.get(ApiServiceTypes.BetsService).updateFreeBetStatus({ freeBetId: freeBetId })];
                case 1:
                    _a.sent();
                    updateFreeBetsData = this.freeBets.map(function (freeBet) {
                        if (freeBet.id === freeBetId) {
                            return __assign(__assign({}, freeBet), { status: FreeBetsStatus.Accepted });
                        }
                        return freeBet;
                    });
                    this.setFreeBets(updateFreeBetsData);
                    remainingAwardedFreeBets_1 = updateFreeBetsData.find(function (item) { return item.id !== freeBetId && item.status === FreeBetsStatus.Pending; });
                    this.setAwardedFreeBet(null);
                    if (remainingAwardedFreeBets_1) {
                        setTimeout(function () { return _this.setAwardedFreeBet(remainingAwardedFreeBets_1); }, 500);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    iframeService.sendLoginCheck();
                    console.log('claim error', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    };
    FreeBetStore.prototype.handleAwardedFreeBets = function (data) {
        var userId = userInfoStore.userId;
        var gameId = data.gameId, freeBets = data.freeBets, thumbnails = data.thumbnails;
        if (+gameId !== +gameConfigStore.gameId) {
            return;
        }
        var awardedFreeBets = freeBets.filter(function (freeBet) { return freeBet.userId === +userId; });
        if (awardedFreeBets && awardedFreeBets.length) {
            awardedFreeBets = awardedFreeBets.map(function (freeBet) { return (__assign(__assign({}, freeBet), { minOdd: freeBet.minOdd || bogLineMinOdd, isMinOddNull: !freeBet.minOdd, thumbnails: (thumbnails === null || thumbnails === void 0 ? void 0 : thumbnails.filter(function (item) { return item.thumbnail && +item.gameId !== +gameConfigStore.gameId; })) || [], expireDateFreeBet: formatDate(new Date(freeBet.expireDate), 'DD.MM.YY'), expiredTime: formatDate(new Date(freeBet.expireDate), 'hh:mm'), receiveDate: formatDate(new Date(freeBet.receiveDate), 'DD.MM.YY'), freeBetReceiveDate: formatDate(new Date(freeBet.receiveDate), 'DD.MM.YY') })); });
            this.updatedFreeBets(awardedFreeBets);
            this.resetOldAndGenerateNewExpireData();
        }
        if (!this.awardedFreeBet) {
            var findResult = awardedFreeBets.find(function (pendingFreeBet) { return pendingFreeBet.status === FreeBetsStatus.Pending; });
            if (findResult) {
                this.setAwardedFreeBet(findResult);
            }
        }
    };
    FreeBetStore.prototype.handleEndedFreeBets = function (data) {
        var userId = userInfoStore.userId;
        var userEndedFreeBets = data.filter(function (freeBet) { return +freeBet.userId === +userId && freeBet.gameIds.includes(+gameConfigStore.gameId); });
        if (userEndedFreeBets === null || userEndedFreeBets === void 0 ? void 0 : userEndedFreeBets.length) {
            this.setEndedFreeBets(userEndedFreeBets);
            var onFreeBetEndedCallback = gameConfigStore.gameConfigs.onFreeBetEndedCallback;
            if (onFreeBetEndedCallback) {
                onFreeBetEndedCallback();
            }
        }
        this.resetOldAndGenerateNewExpireData();
    };
    FreeBetStore.prototype.handleFreeBetsInitialData = function (userFreeBets, isGameInitial) {
        var _this = this;
        if (isGameInitial === void 0) { isGameInitial = false; }
        var freeBetIsUsed = false;
        if (userFreeBets) {
            var userId_1 = userInfoStore.userId;
            var convertFreeBetData = userFreeBets.map(function (freeBet) {
                var _a;
                var expireDateFreeBet = formatDate(new Date(freeBet.expireDate), 'DD.MM.YY');
                var expiredTime = formatDate(new Date(freeBet.expireDate), 'hh:mm');
                var freeBetReceiveDate = formatDate(new Date(freeBet.receiveDate), 'DD.MM.YY');
                var thumbnails = ((_a = freeBet === null || freeBet === void 0 ? void 0 : freeBet.thumbnails) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.thumbnail && +item.gameId !== +gameConfigStore.gameId; })) || [];
                if (_this.activeFreeBet.id &&
                    freeBet.id === _this.activeFreeBet.id &&
                    freeBet.remainingCount === 0 &&
                    isGameInitial) {
                    freeBetIsUsed = true;
                }
                return __assign(__assign({}, freeBet), { thumbnails: thumbnails, expireDateFreeBet: expireDateFreeBet, expiredTime: expiredTime, minOdd: freeBet.minOdd || bogLineMinOdd, isMinOddNull: !freeBet.minOdd, receiveDate: freeBetReceiveDate, receiveDateForSort: freeBet.receiveDate });
            });
            if (freeBetIsUsed) {
                this.resetActiveFreeBet();
            }
            if (this.freeBetEnded) {
                this.setFreeBetEnded(null);
            }
            convertFreeBetData = this.freeBetsSortFunctional(convertFreeBetData);
            var awardedFreeBet = convertFreeBetData.find(function (freeBet) { return freeBet.userId === +userId_1 && freeBet.status === FreeBetsStatus.Pending; });
            this.setFreeBets(convertFreeBetData);
            this.setAwardedFreeBet(awardedFreeBet);
            if (isGameInitial) {
                this.checkFirstExpireFreeBets();
            }
            else {
                this.resetOldAndGenerateNewExpireData();
            }
        }
    };
    FreeBetStore.prototype.handleFreeBetDoBetResult = function (freeBetId, currentCount) {
        var _this = this;
        if (freeBetId && (currentCount || currentCount === 0)) {
            var disableActiveFreeBet_1 = false;
            var updatedFreeBets = this.freeBets.map(function (freeBet) {
                if (+freeBet.id === +freeBetId) {
                    if (!currentCount) {
                        disableActiveFreeBet_1 = true;
                    }
                    return __assign(__assign({}, freeBet), { remainingCount: currentCount, status: disableActiveFreeBet_1 ? FreeBetsStatus.Finished : FreeBetsStatus.Accepted });
                }
                return freeBet;
            });
            var updatedActiveFreeBet = updatedFreeBets.find(function (freeBet) { return freeBet.id === _this.activeFreeBet.id; });
            if (updatedActiveFreeBet) {
                this.setActivateFreeBet(updatedActiveFreeBet, true);
            }
            if (disableActiveFreeBet_1 && this.isAllowChangeFreeBet) {
                this.resetActiveFreeBet();
            }
            this.setFreeBets(updatedFreeBets);
        }
    };
    FreeBetStore.prototype.handleFreeBetEndedData = function () {
        var _this = this;
        var _a, _b;
        var _loop_1 = function () {
            var finishedFreeBet = this_1.endedFreeBets.shift();
            var endedFreeBet = this_1.freeBets.find(function (freeBet) { return freeBet.id === finishedFreeBet.freeBetId; });
            if (endedFreeBet) {
                endedFreeBet.totalWin = finishedFreeBet.totalAmount;
                var updatedFreeBets = this_1.freeBets.map(function (freeBet) {
                    return freeBet.id === endedFreeBet.id
                        ? __assign(__assign({}, freeBet), { totalWin: endedFreeBet.totalWin, status: FreeBetsStatus.Finished }) : freeBet;
                });
                if (((_b = this_1.awardedFreeBet) === null || _b === void 0 ? void 0 : _b.id) === finishedFreeBet.freeBetId) {
                    this_1.setAwardedFreeBet(null);
                }
                this_1.setFreeBets(this_1.freeBetsSortFunctional(updatedFreeBets));
                this_1.setFreeBetEnded(endedFreeBet);
                setTimeout(function () { return _this.setFreeBetEnded(null); }, 3500);
            }
        };
        var this_1 = this;
        while ((_a = this.endedFreeBets) === null || _a === void 0 ? void 0 : _a.length) {
            _loop_1();
        }
    };
    FreeBetStore.prototype.freeBetTotalWinCalculator = function (winData) {
        if (winData.freeBetId && !applicationStore.isDemo) {
            this.freeBets.forEach(function (freeBet) {
                if (freeBet.id === winData.freeBetId) {
                    freeBet.totalWin = parseNumberByPrecision(freeBet.totalWin + winData.winAmount, 1, 2);
                }
            });
        }
    };
    FreeBetStore.prototype.freeBetsSortFunctional = function (freeBets) {
        freeBets.sort(function (a, b) { return +new Date(b.receiveDateForSort) - +new Date(a.receiveDateForSort); });
        var filteredFreeBetsByPendingOrAccepted = freeBets.filter(function (item) { return item.status === FreeBetsStatus.Accepted || item.status === FreeBetsStatus.Pending; });
        var filteredFreeBetsByFinishedOrExpired = freeBets.filter(function (item) { return item.status !== FreeBetsStatus.Accepted && item.status !== FreeBetsStatus.Pending; });
        return __spreadArray(__spreadArray([], __read(filteredFreeBetsByPendingOrAccepted), false), __read(filteredFreeBetsByFinishedOrExpired), false);
    };
    FreeBetStore.prototype.setIsAllowChangeFreeBet = function (bool) {
        if (bool) {
            this.resetFreeBetDependOnRemainingCount();
        }
        this.isAllowChangeFreeBet = bool;
    };
    FreeBetStore.prototype.resetFreeBetDependOnRemainingCount = function () {
        if (!this.activeFreeBet.remainingCount) {
            this.resetActiveFreeBet();
        }
    };
    FreeBetStore.prototype.setIsFreeChip = function (bool) {
        this.isFreeChip = bool;
    };
    return FreeBetStore;
}());
var freeBetStore = new FreeBetStore();

var BetDataStore = /** @class */ (function () {
    function BetDataStore() {
        this.betsSectionsInitialData = [
            {
                index: betSectionIndex.firstIndex,
                autoCashOutOdd: defaultMinOdd,
                isAutoCashOut: false,
                isOpenMobileAutoCashOut: false,
                betAmount: '',
                isOpen: true,
                isAutoBet: false,
                isAutoBetOpen: false,
                autoBetCount: null,
                isLoaderActive: false,
                freeBetAmount: null,
                freeBetCurrentOdd: null,
                isAmountChangeCustom: false,
            },
        ];
        this.betButtonDisable = false;
        this.isDoubleSectionsOpen = false;
        this.betsSectionsData = deepCopy(this.betsSectionsInitialData);
        makeObservable(this, {
            betsSectionsInitialData: observable.deep,
            betsSectionsData: observable.deep,
            isDoubleSectionsOpen: observable,
            betButtonDisable: observable,
            setBetAmount: action.bound,
            setIsAutoCashOutOpen: action.bound,
            setAutoCashOutOdd: action.bound,
            setDefaultAutoCashOutOdd: action.bound,
            setAutoBetChosenCount: action.bound,
            setIsAutoBet: action.bound,
            setIsAutoBetOpen: action.bound,
            setIsOpenMobileAutoCashOut: action.bound,
            setBetButtonDisable: action,
            setDoubleSectionState: action.bound,
            openBetSection: action.bound,
            removeBetSection: action.bound,
            decreaseAutoBetCount: action.bound,
            resetBetSectionData: action.bound,
            setDefaultBetsAmount: action.bound,
            setFreeBetCurrentOdd: action.bound,
            setCurrentFreeBetAmount: action.bound,
            setInitialUserCurrentBetData: action.bound,
            setIsLoaderActive: action.bound,
            resetBetsSectionsData: action.bound,
            resetAutoBet: action.bound,
            setIsAmountChangeCustom: action.bound,
        });
    }
    BetDataStore.prototype.setInitialBetDataWithCount = function (count) {
        var _this = this;
        var size = typeof count === 'number' && count > 1 ? count : 1;
        this.betsSectionsInitialData = Array.from({ length: size }, function (_, idx) {
            var item = deepCopy(_this.betsSectionsInitialData[0]);
            item.index = idx;
            return item;
        });
        this.betsSectionsData = deepCopy(this.betsSectionsInitialData);
    };
    BetDataStore.prototype.setIsAmountChangeCustom = function (bool, index) {
        this.betsSectionsData[index].isAmountChangeCustom = bool;
    };
    BetDataStore.prototype.resetBetsSectionsData = function () {
        this.betsSectionsData = deepCopy(this.betsSectionsInitialData);
        this.betButtonDisable = false;
        this.isDoubleSectionsOpen = false;
    };
    BetDataStore.prototype.setIsLoaderActive = function (index, bool) {
        this.betsSectionsData[index].isLoaderActive = bool;
    };
    BetDataStore.prototype.setBetButtonDisable = function (bool) {
        this.betButtonDisable = bool;
    };
    BetDataStore.prototype.setFreeBetCurrentOdd = function (index, value) {
        this.betsSectionsData[index].freeBetCurrentOdd = value;
    };
    BetDataStore.prototype.setCurrentFreeBetAmount = function (index, freeBetId, userFreebets) {
        var _a, _b, _c;
        this.betsSectionsData[index].freeBetAmount =
            ((_a = userFreebets === null || userFreebets === void 0 ? void 0 : userFreebets.find(function (item) { return item.id === freeBetId; })) === null || _a === void 0 ? void 0 : _a.amount) ||
                ((_b = freeBetStore.activeFreeBet) === null || _b === void 0 ? void 0 : _b.amount) ||
                ((_c = freeBetStore.freeBets.find(function (item) { return item.id === freeBetId; })) === null || _c === void 0 ? void 0 : _c.amount) ||
                null;
    };
    BetDataStore.prototype.setDefaultBetsAmount = function (_a) {
        var _this = this;
        var defaultBetAmount = _a.defaultBetAmount, minBet = _a.minBet;
        this.betsSectionsData.forEach(function (section, index) {
            section.betAmount = defaultBetAmount || minBet;
            _this.betsSectionsInitialData[index].betAmount = defaultBetAmount || minBet;
        });
    };
    BetDataStore.prototype.openBetSection = function (index) {
        var _this = this;
        if (index === 0 || index) {
            this.betsSectionsData[betSectionIndex.secondIndex].isOpen = true;
            this.setDoubleSectionState(true);
        }
        else {
            this.betsSectionsData.forEach(function (item) {
                if (!item.isOpen) {
                    item.isOpen = true;
                }
                _this.setDoubleSectionState(true);
            });
        }
    };
    BetDataStore.prototype.removeBetSection = function (index) {
        this.betsSectionsData.forEach(function (item) {
            if (index === item.index) {
                item.isOpen = false;
            }
        });
        this.resetBetSectionData(index);
        this.setDoubleSectionState(false);
    };
    BetDataStore.prototype.setDoubleSectionState = function (bool) {
        this.isDoubleSectionsOpen = bool;
    };
    BetDataStore.prototype.decreaseAutoBetCount = function (index) {
        this.betsSectionsData[index].autoBetCount -= 1;
        if (this.betsSectionsData[index].autoBetCount === 0) {
            this.betsSectionsData[index].autoBetCount = null;
            this.setIsAutoBet(false, index);
            this.betsSectionsData[index].isAutoBetOpen = false;
        }
    };
    BetDataStore.prototype.setAutoBetChosenCount = function (count, index) {
        this.betsSectionsData[index].autoBetCount = count;
    };
    BetDataStore.prototype.setIsAutoBet = function (bool, index) {
        this.betsSectionsData[index].isAutoBet = bool;
    };
    BetDataStore.prototype.setIsAutoBetOpen = function (bool, index, isMobileAndDoubleSectonOpen) {
        // if (isMobileAndDoubleSectonOpen) {
        //   this.setIsOpenMobileAutoCashOut(false, index);
        // }
        // if (!bool) {
        //   this.setAutoBetChosenCount(null, index);
        //   this.setIsAutoBet(false, index);
        // }
        this.betsSectionsData[index].isAutoBetOpen = bool;
    };
    BetDataStore.prototype.resetAutoBet = function (itemIndex) {
        if (itemIndex === 0 || itemIndex) {
            this.betsSectionsData.forEach(function (item, index) {
                if (itemIndex === index) {
                    item.isAutoBet = false;
                    item.isAutoBetOpen = false;
                    item.autoBetCount = null;
                }
            });
        }
        else {
            this.betsSectionsData.forEach(function (item) {
                item.isAutoBet = false;
                item.isAutoBetOpen = false;
                item.autoBetCount = null;
            });
        }
    };
    BetDataStore.prototype.setDefaultAutoCashOutOdd = function (value) {
        this.betsSectionsData.forEach(function (item) {
            item.autoCashOutOdd = value;
        });
    };
    BetDataStore.prototype.setIsAutoCashOutOpen = function (bool, index) {
        this.betsSectionsData[index].isAutoCashOut = bool;
    };
    BetDataStore.prototype.setIsOpenMobileAutoCashOut = function (bool, index, isMobileAndDoubleSectonOpen) {
        if (bool && isMobileAndDoubleSectonOpen) {
            this.setIsAutoBetOpen(false, index);
        }
        this.betsSectionsData[index].isOpenMobileAutoCashOut = bool;
    };
    BetDataStore.prototype.setAutoCashOutOdd = function (odd, index) {
        this.betsSectionsData[index].autoCashOutOdd = odd;
    };
    BetDataStore.prototype.setBetAmount = function (betAmount, index) {
        if (index === undefined) {
            this.betsSectionsData.forEach(function (section) {
                section.betAmount = betAmount;
            });
        }
        else {
            this.betsSectionsData.forEach(function (section) {
                if (section.index === index) {
                    section.betAmount = betAmount;
                }
            });
        }
    };
    BetDataStore.prototype.setInitialUserCurrentBetData = function (currentBetData) {
        this.betsSectionsData.forEach(function (item) {
            if (item.index === currentBetData.betData.index) {
                if (currentBetData.betData.autoCashoutOdd) {
                    item.autoCashOutOdd = currentBetData.betData.autoCashoutOdd;
                    item.isAutoCashOut = true;
                }
                item.betAmount = currentBetData.amount;
            }
        });
    };
    BetDataStore.prototype.resetBetSectionData = function (index) {
        var _this = this;
        var _a, _b, _c;
        var freeBetInitialData = ((_a = freeBetStore.activeFreeBet) === null || _a === void 0 ? void 0 : _a.id)
            ? {
                betAmount: (_b = freeBetStore.activeFreeBet) === null || _b === void 0 ? void 0 : _b.amount,
                autoCashOutOdd: (_c = freeBetStore.activeFreeBet) === null || _c === void 0 ? void 0 : _c.minOdd,
            }
            : {};
        if (!arguments.length) {
            this.betsSectionsData = deepCopy(this.betsSectionsInitialData);
            this.setDoubleSectionState(false);
        }
        else {
            this.betsSectionsData.forEach(function (section, i) {
                if (section.index === index) {
                    Object.assign(_this.betsSectionsData[i], _this.betsSectionsInitialData[i], {
                        isOpen: _this.betsSectionsData[i].isOpen,
                    }, freeBetInitialData);
                }
            });
        }
    };
    return BetDataStore;
}());
var betDataStore = new BetDataStore();

var DoBetStore = /** @class */ (function () {
    function DoBetStore() {
        this.doBetSectionsInitialData = [
            {
                index: 0,
                betId: null,
                isNextRoundBet: false,
                isBetAccepted: false,
                isFreeBetAccepted: false,
                winAmount: null,
                isDisabled: false,
                freeBetId: null,
                isHalfCashOuted: false,
                currentMaxWin: null,
                currentFreeBetMaxPayout: null,
                freeBetType: null,
            },
        ];
        this.doBetSectionsData = deepCopy(this.doBetSectionsInitialData);
        this.freeBetDisable = false;
        this.freeBetMinOdd = null;
        this.disabled = false;
        this.winPopUpsData = [];
        this.winPopUpTmp = null;
        // @ts-ignore
        makeObservable(this, {
            doBetSectionsInitialData: observable,
            doBetSectionsData: observable.deep,
            freeBetDisable: observable,
            freeBetMinOdd: observable,
            disabled: observable,
            winPopUpsData: observable.deep,
            winPopUpTmp: observable,
            // actions
            doBetSender: action.bound,
            sendCashOut: action.bound,
            setBetAccepted: action.bound,
            setDoBetResult: action.bound,
            handleBetForNextRound: action.bound,
            setWinData: action.bound,
            setWinPopUpsData: action.bound,
            clearWinPopUpTimer: action.bound,
            changeBetIsDisabled: action.bound,
            handleClearRoundFin: action.bound,
            handleOnRoundStart: action.bound,
            resetDoBetStore: action.bound,
            resetDoBetStoreBySection: action.bound,
            setCurrentInitialAndRealModeData: action.bound,
            increaseDemoBalance: action.bound,
            decreaseDemoBalance: action.bound,
            setDisabledState: action.bound,
            setFreeBetType: action.bound,
            setFreeBetByCoreData: action.bound,
            setInitialCurrentFreeBetMaxPayout: action.bound,
            setFreeBeetDefaultOdd: action.bound,
            setCurrentFreeBetMaxPayout: action.bound,
            setCurrentMaxWin: action.bound,
            setFreeBetDisableState: action.bound,
            switchFreeBetMode: action.bound,
            setCurrentFreeBetId: action.bound,
            setIsHalfCashOuted: action.bound,
            setInitialDoBetDataWithCount: action.bound,
            setIsFreeBetAccepted: action.bound,
        });
    }
    // Section data modifiers
    DoBetStore.prototype.setIsFreeBetAccepted = function (bool, index) {
        this.doBetSectionsData[index].isFreeBetAccepted = bool;
    };
    DoBetStore.prototype.setInitialDoBetDataWithCount = function (count) {
        var _this = this;
        var size = typeof count === 'number' && count > 1 ? count : 1;
        this.doBetSectionsInitialData = Array.from({ length: size }, function (_, idx) {
            var item = deepCopy(_this.doBetSectionsInitialData[0]);
            item.index = idx;
            return item;
        });
        this.doBetSectionsData = deepCopy(this.doBetSectionsInitialData);
    };
    DoBetStore.prototype.resetDoBetStore = function () {
        this.doBetSectionsData = deepCopy(this.doBetSectionsInitialData);
        this.freeBetDisable = false;
        this.freeBetMinOdd = null;
        this.winPopUpsData = [];
        this.disabled = false;
    };
    DoBetStore.prototype.resetDoBetStoreBySection = function (index) {
        this.doBetSectionsData[index] = deepCopy(this.doBetSectionsInitialData[index]);
        this.setDisabledState();
    };
    DoBetStore.prototype.setFreeBetType = function (index, type) {
        this.doBetSectionsData[index].freeBetType = type;
    };
    DoBetStore.prototype.setFreeBetByCoreData = function (index, freeBetId) {
        var _a;
        this.doBetSectionsData[index].freeBetType = (_a = freeBetStore.freeBets.find(function (item) { return item.id === freeBetId; })) === null || _a === void 0 ? void 0 : _a.winType;
    };
    DoBetStore.prototype.setInitialCurrentFreeBetMaxPayout = function (index, freeBetId, userFreebets) {
        var _a, _b;
        this.doBetSectionsData[index].currentFreeBetMaxPayout =
            ((_a = userFreebets === null || userFreebets === void 0 ? void 0 : userFreebets.find(function (item) { return item.id === freeBetId; })) === null || _a === void 0 ? void 0 : _a.maxPayout) ||
                ((_b = freeBetStore.freeBets.find(function (item) { return item.id === freeBetId; })) === null || _b === void 0 ? void 0 : _b.maxPayout) ||
                null;
    };
    DoBetStore.prototype.setFreeBeetDefaultOdd = function (freeBetId, userFreebets) {
        var _a, _b, _c;
        this.freeBetMinOdd =
            ((_a = userFreebets === null || userFreebets === void 0 ? void 0 : userFreebets.find(function (item) { return item.id === freeBetId; })) === null || _a === void 0 ? void 0 : _a.minOdd) ||
                ((_b = freeBetStore.activeFreeBet) === null || _b === void 0 ? void 0 : _b.minOdd) ||
                ((_c = freeBetStore.freeBets.find(function (item) { return item.id === freeBetId; })) === null || _c === void 0 ? void 0 : _c.minOdd) ||
                null;
    };
    DoBetStore.prototype.setCurrentFreeBetMaxPayout = function (index, value) {
        var _a;
        this.doBetSectionsData[index].currentFreeBetMaxPayout =
            value === null ? null : (_a = freeBetStore.activeFreeBet) === null || _a === void 0 ? void 0 : _a.maxPayout;
    };
    DoBetStore.prototype.setCurrentFreeBetId = function (index, id) {
        this.doBetSectionsData[index].freeBetId = id;
    };
    // todo  remove
    DoBetStore.prototype.setCurrentMaxWin = function (index, winAmount) {
        if (winAmount === null) {
            this.doBetSectionsData[index].currentMaxWin = null;
        }
        else {
            var maxWin = this.doBetSectionsData[index].currentFreeBetMaxPayout || gameConfigStore.limits.maxWin;
            this.doBetSectionsData[index].currentMaxWin = maxWin - winAmount;
        }
    };
    DoBetStore.prototype.setIsHalfCashOuted = function (index, bool) {
        this.doBetSectionsData[index].isHalfCashOuted = bool;
    };
    DoBetStore.prototype.setFreeBetDisableState = function (bool) {
        this.freeBetDisable = bool;
    };
    DoBetStore.prototype.changeBetIsDisabled = function (index, bool) {
        if (index === null) {
            this.doBetSectionsData.forEach(function (section) { return (section.isDisabled = bool); });
        }
        else {
            this.doBetSectionsData[index].isDisabled = bool;
        }
    };
    DoBetStore.prototype.setDisabledState = function () {
        this.disabled = this.doBetSectionsData.some(function (item) { return item.isNextRoundBet || item.isBetAccepted; });
    };
    DoBetStore.prototype.setBetAccepted = function (index, betId, boolean) {
        this.doBetSectionsData[index].isNextRoundBet = false;
        this.doBetSectionsData[index].betId = betId;
        this.doBetSectionsData[index].isBetAccepted = boolean;
        this.setDisabledState();
    };
    DoBetStore.prototype.setDoBetResult = function (doBetData) {
        var index = doBetData.betData.index, responseCode = doBetData.responseCode, id = doBetData.id;
        this.setBetAccepted(index, id, true);
        notificationStore.setNotificationType({ responseCode: responseCode });
        userSettingsStore.soundService.playBetAccepted();
    };
    // Bet actions
    DoBetStore.prototype.handleBetForNextRound = function (index) {
        if (index === undefined) {
            this.doBetSectionsData.forEach(function (item) { return (item.isNextRoundBet = false); });
        }
        else {
            var item = this.doBetSectionsData.find(function (s) { return s.index === index; });
            if (item)
                item.isNextRoundBet = !item.isNextRoundBet;
        }
        this.setDisabledState();
    };
    DoBetStore.prototype.sendCashOut = function (index, betId, halfCashOut) {
        if (halfCashOut === void 0) { halfCashOut = false; }
        if (halfCashOut) {
            this.setIsHalfCashOuted(index, true);
            userSettingsStore.gameLiveConnection.cashOut({
                betId: betId,
                roundId: roundInfoStore.roundId,
                cashoutDate: new Date(),
                cashOutHalf: true,
            });
        }
        else {
            userSettingsStore.gameLiveConnection.cashOut({ betId: betId, roundId: roundInfoStore.roundId });
        }
        if (!halfCashOut) {
            this.setCurrentFreeBetId(index, null);
            this.setBetAccepted(index, betId, false);
        }
    };
    DoBetStore.prototype.switchFreeBetMode = function (section) {
        this.setCurrentFreeBetId(section.index, null);
        var activeFreeBet = freeBetStore.activeFreeBet;
        if (activeFreeBet.id) {
            var currentBetAmount = activeFreeBet.amount || betDataStore.betsSectionsData[section.index].freeBetAmount;
            var currentOdd = betDataStore.betsSectionsData[section.index].autoCashOutOdd ||
                betDataStore.betsSectionsData[section.index].freeBetCurrentOdd ||
                activeFreeBet.minOdd ||
                this.freeBetMinOdd;
            betDataStore.setBetAmount(currentBetAmount, section.index);
            betDataStore.setAutoCashOutOdd(currentOdd, section.index);
            // if (betDataStore.betsSectionsData[section.index].isAutoCashOut && !activeFreeBet.id) {
            //   betDataStore.autoCashOutToggle(section.index);
            // }
        }
    };
    DoBetStore.prototype.doBetSender = function (index) {
        var gameTypeId = gameConfigStore.gameTypeId, gameId = gameConfigStore.gameId, limits = gameConfigStore.limits;
        var roundId = roundInfoStore.roundId;
        var activeFreeBet = freeBetStore.activeFreeBet;
        // const { balance } = userInfoStore;
        var _a = betDataStore.betsSectionsData[index], betAmount = _a.betAmount, autoCashOutOdd = _a.autoCashOutOdd, isAutoCashOut = _a.isAutoCashOut;
        this.changeBetIsDisabled(index, true);
        if (+betAmount < limits.minBet) {
            notificationStore.setNotificationType({
                responseCode: BetResponseCode.InValidMinBet,
            });
            this.changeBetIsDisabled(index, false);
            this.resetDoBetStoreBySection(index);
        }
        else if (+betAmount > limits.maxBet) {
            betDataStore.setBetAmount(limits.maxBet, index);
            notificationStore.setNotificationType({
                responseCode: BetResponseCode.InValidMaxBet,
            });
            this.changeBetIsDisabled(index, false);
            this.resetDoBetStoreBySection(index); // todo nael
        }
        else {
            betDataStore.setIsLoaderActive(index, true);
            if (activeFreeBet.id) {
                this.setCurrentFreeBetMaxPayout(index);
            }
            var doBetModel = {
                amount: betAmount,
                roundId: roundId,
                gameTypeId: gameTypeId,
                gameId: +gameId,
                freeBetId: activeFreeBet === null || activeFreeBet === void 0 ? void 0 : activeFreeBet.id,
                betData: {
                    index: index,
                    autoCashOutOdd: isAutoCashOut ? autoCashOutOdd : 0,
                },
            };
            userSettingsStore.gameLiveConnection.doBet(doBetModel);
        }
    };
    DoBetStore.prototype.handleOnRoundStart = function () {
        var _this = this;
        userSettingsStore.gameLiveConnection.getBalance();
        this.doBetSectionsData.forEach(function (section) {
            section.isDisabled = false;
            section.isBetAccepted = false;
            if (section.isNextRoundBet)
                _this.doBetSender(section.index);
        });
        this.setDisabledState();
    };
    DoBetStore.prototype.handleClearRoundFin = function () {
        var _this = this;
        this.doBetSectionsData.forEach(function (section, index) {
            _this.switchFreeBetMode(section);
            section.betId = null;
            section.freeBetId = null;
            section.winAmount = null;
            section.isBetAccepted = false;
            section.freeBetType = null;
            section.isDisabled = true;
            _this.setCurrentMaxWin(index, null);
            _this.setCurrentFreeBetMaxPayout(index, null);
        });
        this.freeBetMinOdd = null;
        // this.demoTwoSectionAmounts = 0;
    };
    // todo  this code will be used  whit halfcashout
    // setWinData(data: any, isAutoCashOut?: boolean, halfCashOut?: boolean) {
    //    console.log('setWinData' ,data, isAutoCashOut ,halfCashOut )
    //   this.clearWinPopUpTimer();
    //   const { isMaxWin, setIsMaxWin } = oddStore;
    //   const sectionIndex = data.additionalParams.index;
    //   userSettingsStore.soundService.playWin();
    //   if (!this.doBetSectionsData[sectionIndex].isHalfCashOuted) {
    //     this.setIsHalfCashOuted(sectionIndex, true);
    //   }
    //   if (isMaxWin[sectionIndex]) {
    //     setIsMaxWin(false, sectionIndex);
    //   }
    //
    //   const halfCashOutData = data.additionalParams?.cashOutInfos;
    //   if (!halfCashOut) {
    //     setTimeout(() => userSettingsStore.gameLiveConnection.getBalance(), 500);
    //   }
    //
    //   if (halfCashOut) {
    //     this.doBetSectionsData.forEach((item) => {
    //       if (item.index === data.additionalParams.index) {
    //         item.winAmount = parseNumberByPrecision(data.winAmount, 1, 1);
    //         this.setCurrentMaxWin(item.index, item.winAmount);
    //         if (gameConfigStore.gameConfigs?.popUpsIndex.winPopUp) {
    //           gameStore.setShowPopUpsWhitIndex(gameConfigStore.gameConfigs?.popUpsIndex.winPopUp, data.winAmount);
    //         }
    //         totalBetStore.setTotalWinAmount(data.winAmount);
    //       }
    //     });
    //   } else if (halfCashOutData?.length > 1) {
    //     this.doBetSectionsData.forEach((item) => {
    //       if (item.index === data.additionalParams.index) {
    //         item.winAmount = parseNumberByPrecision(data.winAmount, 1, 1);
    //         if (gameConfigStore.gameConfigs?.popUpsIndex.winPopUp) {
    //           gameStore.setShowPopUpsWhitIndex(gameConfigStore.gameConfigs?.popUpsIndex.winPopUp, data.winAmount);
    //         }
    //
    //         totalBetStore.setTotalWinAmount(data.winAmount);
    //         item.isBetAccepted = false;
    //         this.switchFreeBetMode(item);
    //       }
    //     });
    //   } else {
    //     const { activeFreeBet } = freeBetStore;
    //     this.doBetSectionsData.forEach((item) => {
    //       if (item.index === data.additionalParams.index) {
    //         item.winAmount = parseNumberByPrecision(data.winAmount, 1, 1);
    //         if (gameConfigStore.gameConfigs?.popUpsIndex.winPopUp) {
    //           gameStore.setShowPopUpsWhitIndex(gameConfigStore.gameConfigs?.popUpsIndex.winPopUp, data.winAmount);
    //         }
    //         this.setWinPopUpsData(data);
    //         totalBetStore.setTotalWinAmount(data.winAmount);
    //         item.isBetAccepted = false;
    //         this.switchFreeBetMode(item);
    //       }
    //     });
    //     betDataStore.betsSectionsData.forEach((section) => {
    //       if (!activeFreeBet.id) {
    //         section.freeBetCurrentOdd = null;
    //       }
    //     });
    //   }
    //
    //   this.winPopUpTmp = setTimeout(() => {
    //     gameStore.setShowPopUpsWhitIndex(null, null);
    //     if (isMaxWin[sectionIndex] && !isAutoCashOut) {
    //       if (gameConfigStore.gameConfigs?.popUpsIndex.maxWinPopUp) {
    //         gameStore.setShowPopUpsWhitIndex(
    //           gameConfigStore.gameConfigs?.popUpsIndex.maxWinPopUp,
    //           gameConfigStore.limits.maxWin
    //         );
    //       }
    //     }
    //     clearTimeout(this.winPopUpTmp);
    //   }, 2000);
    // }
    DoBetStore.prototype.setWinData = function (data) {
        var _this = this;
        this.clearWinPopUpTimer();
        var isMaxWin = oddStore.isMaxWin, setIsMaxWin = oddStore.setIsMaxWin;
        var sectionIndex = data.additionalParams.index;
        setTimeout(function () {
            userSettingsStore.gameLiveConnection.getBalance();
        }, 500);
        userSettingsStore.soundService.playWin();
        if (isMaxWin[sectionIndex]) {
            setIsMaxWin(false, sectionIndex);
        }
        var activeFreeBet = freeBetStore.activeFreeBet;
        this.doBetSectionsData.forEach(function (item) {
            if (item.index === data.additionalParams.index) {
                item.winAmount = parseNumberByPrecision(data.winAmount, 1, 1);
                // gameStore.setShowPopUpsWhitIndex(popUpsIndex.win, data.winAmount);
                _this.setWinPopUpsData(data);
                item.isBetAccepted = false;
                _this.switchFreeBetMode(item);
            }
        });
        betDataStore.betsSectionsData.forEach(function (section) {
            if (!activeFreeBet.id) {
                section.freeBetCurrentOdd = null;
            }
        });
    };
    DoBetStore.prototype.setWinPopUpsData = function (_a) {
        var _this = this;
        var winAmount = _a.winAmount, odd = _a.odd, id = _a.id, index = _a.additionalParams.index, _b = _a.demoOdd, demoOdd = _b === void 0 ? null : _b;
        this.winPopUpsData.unshift({ winAmount: winAmount, odd: odd, id: id, index: index, demoOdd: demoOdd });
        var tmp = setTimeout(function () {
            runInAction(function () {
                _this.winPopUpsData.pop();
                clearTimeout(tmp);
            });
        }, 2500);
    };
    DoBetStore.prototype.clearWinPopUpTimer = function () {
        if (this.winPopUpTmp)
            clearTimeout(this.winPopUpTmp);
    };
    // Demo balance handlers
    DoBetStore.prototype.increaseDemoBalance = function (winAmount) {
        var balance = +(userInfoStore.balance + winAmount).toFixed(2);
        userInfoStore.setDemoBalance(balance);
    };
    DoBetStore.prototype.decreaseDemoBalance = function (betAmount) {
        var balance = +(userInfoStore.balance - betAmount).toFixed(2);
        userInfoStore.setDemoBalance(balance);
    };
    // Initialize store with existing bets
    DoBetStore.prototype.setCurrentInitialAndRealModeData = function (data, userFreebets) {
        var _this = this;
        data.forEach(function (bet) {
            var _a = bet.betData, index = _a.index, cashOutInfos = _a.cashOutInfos, autoCashoutOdd = _a.autoCashoutOdd, id = bet.id, freeBetId = bet.freeBetId, amount = bet.amount, winAmount = bet.winAmount;
            totalBetStore.setTotalWinAmount(winAmount);
            totalBetStore.setTotalBet(amount);
            betDataStore.openBetSection(index);
            if (bet.status === BetStatus.Pending) {
                betDataStore.setInitialUserCurrentBetData(bet);
                _this.setBetAccepted(index, id, true);
                // this.setDisabledState();
                if (cashOutInfos.length) {
                    _this.setIsHalfCashOuted(index, true);
                }
            }
            if (freeBetId) {
                _this.setFreeBeetDefaultOdd(bet.freeBetId, userFreebets);
                if (autoCashoutOdd) {
                    betDataStore.setFreeBetCurrentOdd(index, autoCashoutOdd);
                }
                _this.setInitialCurrentFreeBetMaxPayout(index, freeBetId, userFreebets);
                betDataStore.setCurrentFreeBetAmount(index, freeBetId, userFreebets);
                _this.setCurrentFreeBetId(index, freeBetId);
            }
            if (index === betSectionIndex.secondIndex) {
                betDataStore.setDoubleSectionState(true);
            }
        });
    };
    return DoBetStore;
}());
var doBetStore = new DoBetStore();

var initialGameSectionData = {
    index: 0,
    amount: null,
    isBetAccepted: false,
};
var PlatformMessageStore = /** @class */ (function () {
    function PlatformMessageStore() {
        /* for crash game with cash out and half cash out */
        this.totalWinAmount = 0;
        /* for save bet section isBetAccepted in core and send roundFinished after cash out */
        this.isAllSectionWithCashOutButton = false;
        /* for games look like fishing */
        this.isUsedRoundStartAndFinishedLogicAfterCashOut = false;
        /* bet sections data */
        this.gameSectionsData = new Array(1).fill(null).map(function (_, index) {
            var _a, _b;
            return (__assign(__assign({}, initialGameSectionData), { amount: ((_a = gameConfigStore === null || gameConfigStore === void 0 ? void 0 : gameConfigStore.limits) === null || _a === void 0 ? void 0 : _a.defaultBetAmount) || ((_b = gameConfigStore === null || gameConfigStore === void 0 ? void 0 : gameConfigStore.limits) === null || _b === void 0 ? void 0 : _b.minBet), index: index }));
        });
        this.isRepliedGame = false;
        this.isGameLoading = true;
        this.isUsedBogLineComponents = false;
        this.totalAcceptedBetsAmount = 0;
        this.isGamePaused = false;
        this.isSentRoundStarted = false;
        this.isOpenOddsSection = false;
        this.isOpenGameHelpSection = false;
        this.isOpenBetHistorySection = false;
        this.isDoBetResultValidated = false;
        this.betIdForReply = null;
        this.isShowAllNotification = true;
        /* for iframeService */
        this.sentSoundValue = null;
        /* for send platform when isShowAllNotification false*/
        this.operatorCode = null;
        // stopAutoBet: (() => void) | null = null;
        this.bogLineGameTypeData = {
            gameName: '',
            isUseCoreDoBetStore: false,
            sectionCount: 1,
            isUsedStakeUpdateLogic: false,
            /* for check  do bet result without market, game example odd-ball, fast-flip */
            checkIsBetAcceptedDependOnIsCashOutBet: null,
            gameType: BOG_LINE_GAME_TYPES.ONLY_CRASH,
            isUsedPlatformIntegrationLogic: false,
            /* for filter live bets if game type crash and market, game example odd-ball, fast-flip */
            callbackForFilterFinishedBets: null,
            /* for checker if backend updated with new autoCashOut bets socket event */
            isAutoCashOutWithSeparateEvent: false,
        };
        this.isUsedGetBalanceBySocketInvoke = true;
        this.isUsedInputValidationFunctionality = false;
        this.isBetShop = false;
        this.isAutoPlayedStarted = false;
        this.isAutoPlayOnInGame = false;
        this.delayForPostMessageRoundFinished = 0;
        makeObservable(this, {
            // stopAutoBet: observable,
            delayForPostMessageRoundFinished: observable,
            isGamePaused: observable,
            operatorCode: observable,
            isRepliedGame: observable,
            isGameLoading: observable,
            betIdForReply: observable,
            sentSoundValue: observable,
            totalWinAmount: observable,
            isOpenOddsSection: observable,
            isOpenGameHelpSection: observable,
            isSentRoundStarted: observable,
            gameSectionsData: observable.deep,
            isShowAllNotification: observable,
            bogLineGameTypeData: observable.deep,
            isDoBetResultValidated: observable,
            isUsedBogLineComponents: observable,
            isOpenBetHistorySection: observable,
            totalAcceptedBetsAmount: observable,
            isAllSectionWithCashOutButton: observable,
            isUsedGetBalanceBySocketInvoke: observable,
            isUsedInputValidationFunctionality: observable,
            isUsedRoundStartAndFinishedLogicAfterCashOut: observable,
            isBetShop: observable,
            isAutoPlayedStarted: observable,
            isAutoPlayOnInGame: observable,
            setOperatorCode: action.bound,
            setIsGamePaused: action.bound,
            setIsRepliedGame: action.bound,
            setBetIdForReply: action.bound,
            setIsGameLoading: action.bound,
            setIsOpenOddsSection: action.bound,
            setIsOpenGameHelpSection: action.bound,
            updateSentSoundValue: action.bound,
            setGameSectionData: action.bound,
            initGameSectionData: action.bound,
            updateTotalWinAmount: action.bound,
            setIsSentRoundStarted: action.bound,
            updateGameSectionData: action.bound,
            setBogLineGameTypeData: action.bound,
            // setStopAutoBetCallback: action.bound,
            setIsShowAllNotification: action.bound,
            setIsDoBetResultValidated: action.bound,
            setTotalAcceptedBetsAmount: action.bound,
            setIsUsedBogLineComponents: action.bound,
            initPlatformMessageConfigs: action.bound,
            setIsOpenBetHistorySection: action.bound,
            setIsAllSectionWithCashOutButton: action.bound,
            setIsUsedGetBalanceBySocketInvoke: action.bound,
            setIsUsedInputValidationFunctionality: action.bound,
            setIsUsedRoundStartAndFinishedLogicAfterCashOut: action.bound,
            setIsBetShop: action.bound,
            setIsAutoPlayedStarted: action.bound,
            setIsAutoPlayOnInGame: action.bound,
            setDelayForPostMessageRoundFinished: action.bound,
        });
    }
    PlatformMessageStore.prototype.setDelayForPostMessageRoundFinished = function (delay) {
        this.delayForPostMessageRoundFinished = delay;
    };
    PlatformMessageStore.prototype.setIsGamePaused = function (isGamePaused) {
        this.isGamePaused = isGamePaused;
    };
    PlatformMessageStore.prototype.setIsRepliedGame = function (isRepliedGame) {
        this.isRepliedGame = isRepliedGame;
    };
    PlatformMessageStore.prototype.setTotalAcceptedBetsAmount = function (totalAcceptedBetsAmount) {
        this.totalAcceptedBetsAmount = totalAcceptedBetsAmount;
    };
    PlatformMessageStore.prototype.setIsGameLoading = function (isGameLoading) {
        this.isGameLoading = isGameLoading;
    };
    PlatformMessageStore.prototype.setIsOpenBetHistorySection = function (isOpenBetHistorySection) {
        this.isOpenBetHistorySection = isOpenBetHistorySection;
    };
    PlatformMessageStore.prototype.setIsUsedGetBalanceBySocketInvoke = function (isUsedGetBalanceBySocketInvoke) {
        this.isUsedGetBalanceBySocketInvoke = isUsedGetBalanceBySocketInvoke;
    };
    PlatformMessageStore.prototype.setIsDoBetResultValidated = function (isDoBetResultValidated) {
        this.isDoBetResultValidated = isDoBetResultValidated;
    };
    PlatformMessageStore.prototype.setBetIdForReply = function (betIdForReply) {
        this.betIdForReply = betIdForReply;
    };
    PlatformMessageStore.prototype.setIsUsedBogLineComponents = function (isUsedBogLineComponents) {
        this.isUsedBogLineComponents = isUsedBogLineComponents;
    };
    PlatformMessageStore.prototype.setIsShowAllNotification = function (isShowAllNotification) {
        this.isShowAllNotification = isShowAllNotification;
    };
    PlatformMessageStore.prototype.setIsOpenOddsSection = function (isOpenOddsSection) {
        this.isOpenOddsSection = isOpenOddsSection;
    };
    PlatformMessageStore.prototype.setIsOpenGameHelpSection = function (isOpenGameHelpSection) {
        this.isOpenGameHelpSection = isOpenGameHelpSection;
    };
    PlatformMessageStore.prototype.setIsSentRoundStarted = function (isSentRoundStarted) {
        this.isSentRoundStarted = isSentRoundStarted;
    };
    PlatformMessageStore.prototype.setIsAllSectionWithCashOutButton = function (isAllSectionWithCashOutButton) {
        this.isAllSectionWithCashOutButton = isAllSectionWithCashOutButton;
    };
    PlatformMessageStore.prototype.updateSentSoundValue = function (sentSoundValue) {
        this.sentSoundValue = sentSoundValue;
    };
    PlatformMessageStore.prototype.setOperatorCode = function (operatorCode) {
        this.operatorCode = operatorCode;
    };
    PlatformMessageStore.prototype.setIsUsedRoundStartAndFinishedLogicAfterCashOut = function (isUsedRoundStartAndFinishedLogicAfterCashOut) {
        this.isUsedRoundStartAndFinishedLogicAfterCashOut = isUsedRoundStartAndFinishedLogicAfterCashOut;
    };
    // setStopAutoBetCallback(stopAutoSpinCallback: () => void) {
    //   this.stopAutoBet = stopAutoSpinCallback;
    // }
    /* call in game(App.js)
     * @sectionCount for pascal-core bet sections data and get sections count
     * for Odd-ball sectionCount = 2
     */
    PlatformMessageStore.prototype.initGameSectionData = function (sectionCount) {
        this.gameSectionsData = new Array(sectionCount)
            .fill(null)
            .map(function (_, index) { return (__assign(__assign({}, initialGameSectionData), { index: index })); });
        doBetStore.setInitialDoBetDataWithCount(sectionCount);
        betDataStore.setInitialBetDataWithCount(sectionCount);
    };
    PlatformMessageStore.prototype.setGameSectionData = function (data) {
        this.gameSectionsData = data;
    };
    PlatformMessageStore.prototype.updateGameSectionData = function (newSectionData, sectionIndex) {
        var updatedSectionsData = this.gameSectionsData.map(function (section) {
            if (section.index === sectionIndex) {
                return __assign(__assign({}, section), newSectionData);
            }
            return section;
        });
        this.setGameSectionData(updatedSectionsData);
    };
    PlatformMessageStore.prototype.setBogLineGameTypeData = function (bogLineGameTypeData) {
        this.bogLineGameTypeData = __assign(__assign({}, this.bogLineGameTypeData), bogLineGameTypeData);
    };
    PlatformMessageStore.prototype.setIsUsedInputValidationFunctionality = function (isUsedInputValidationFunctionality) {
        this.isUsedInputValidationFunctionality = isUsedInputValidationFunctionality;
    };
    PlatformMessageStore.prototype.setIsBetShop = function (value) {
        this.isBetShop = value;
    };
    PlatformMessageStore.prototype.setIsAutoPlayedStarted = function (value) {
        this.isAutoPlayedStarted = value;
    };
    PlatformMessageStore.prototype.setIsAutoPlayOnInGame = function (value) {
        this.isAutoPlayOnInGame = value;
    };
    PlatformMessageStore.prototype.updateTotalWinAmount = function (winAmount) {
        if (winAmount) {
            this.totalWinAmount += winAmount;
        }
        else {
            this.totalWinAmount = 0;
        }
    };
    PlatformMessageStore.prototype.initPlatformMessageConfigs = function (platformMessageConfig) {
        var sectionCount = platformMessageConfig.sectionCount, isGameReplied = platformMessageConfig.isGameReplied, bogLineGameTypeData = platformMessageConfig.bogLineGameTypeData, isUsedBogLineComponents = platformMessageConfig.isUsedBogLineComponents, isAllSectionWithCashOutButton = platformMessageConfig.isAllSectionWithCashOutButton, isUsedInputValidationFunctionality = platformMessageConfig.isUsedInputValidationFunctionality, isUsedRoundStartAndFinishedLogicAfterCashOut = platformMessageConfig.isUsedRoundStartAndFinishedLogicAfterCashOut, isBetShop = platformMessageConfig.isBetShop;
        this.setIsRepliedGame(isGameReplied);
        this.initGameSectionData(sectionCount);
        this.setBogLineGameTypeData(__assign(__assign({}, bogLineGameTypeData), { sectionCount: sectionCount }));
        this.setIsUsedBogLineComponents(isUsedBogLineComponents);
        this.setIsAllSectionWithCashOutButton(isAllSectionWithCashOutButton);
        this.setIsUsedInputValidationFunctionality(isUsedInputValidationFunctionality);
        this.setIsUsedRoundStartAndFinishedLogicAfterCashOut(isUsedRoundStartAndFinishedLogicAfterCashOut);
        this.setIsBetShop(isBetShop);
    };
    return PlatformMessageStore;
}());
var platformMessageStore = new PlatformMessageStore();

var defaultSoundAndMusicVolume = 0.5;
var UserSettingsStore = /** @class */ (function () {
    function UserSettingsStore() {
        this.localStorageSuffix = 'userSettings';
        this.soundService = null;
        this.liveConnection = null;
        this.gameLiveConnection = null;
        this.gameService = null;
        this.localStorageKey = '';
        this.isAnimationOn = true;
        this.isMusicOn = true;
        this.musicVolume = defaultSoundAndMusicVolume;
        this.isSoundOn = true;
        this.soundVolume = defaultSoundAndMusicVolume;
        this.gameThemeConfigs = {
            themeType: GameTheme.Standart,
            isEnabled: true,
        };
        this.isDarkModeOn = false;
        this.isWinterModeOn = false;
        this.isFullScreen = false;
        this.allowFullScreen = false;
        this.isHalfCashOutOn = true;
        this.selectedGameTypeId = null;
        this.isSilentMode = true;
        this.gameSpecificLocalStorageData = {};
        makeObservable(this, {
            isMusicOn: observable,
            isSoundOn: observable,
            soundVolume: observable,
            musicVolume: observable,
            isDarkModeOn: observable,
            isFullScreen: observable,
            isAnimationOn: observable,
            gameThemeConfigs: observable.deep,
            isWinterModeOn: observable,
            allowFullScreen: observable,
            isHalfCashOutOn: observable,
            selectedGameTypeId: observable,
            isSilentMode: observable,
            gameSpecificLocalStorageData: observable.deep,
            setIsMusicOn: action.bound,
            setIsMusicOnValue: action.bound,
            setMusicVolume: action.bound,
            setIsSoundOn: action.bound,
            setSoundVolume: action.bound,
            setIsDarkModeOn: action.bound,
            setGameThemeTypeEnabledState: action.bound,
            setGameThemeConfigs: action.bound,
            setIsWinterModeOn: action.bound,
            setIsMusicOnAndIsSoundOn: action.bound,
            toggleIsSilentMode: action.bound,
            setIsAnimationOn: action.bound,
            setSelectedGameTypeId: action.bound,
            localStorageAndUserSettingsInit: action.bound,
            setIsFullScreen: action.bound,
            toggleFullscreen: action.bound,
            openFullScreen: action.bound,
            closeFullScreen: action.bound,
            setAllowFullScreen: action.bound,
            setIsHalfCashOutOn: action.bound,
            setGameTypeIdInLocalStorage: action.bound,
            setGameSpecificLocalStorageDataByKey: action.bound,
        });
    }
    UserSettingsStore.prototype.localStorageAndUserSettingsInit = function (_a) {
        var gamePrefix = _a.gameName, soundService = _a.soundService, updatedDefaultSettings = _a.updatedDefaultSettings, _b = _a.gameSpecificData, gameSpecificData = _b === void 0 ? {} : _b, gameService = _a.gameService, liveConnection = _a.liveConnection, gameLiveConnection = _a.gameLiveConnection;
        try {
            var _c = parseQuery(window.location.search), _d = DefaultQueryParams.Theme, themeName = _c[_d], _e = DefaultQueryParams.GameId, gameId = _c[_e];
            this.localStorageKey = "".concat(gamePrefix, "_").concat(gameId, "_").concat(this.localStorageSuffix);
            this.gameService = gameService;
            this.soundService = soundService;
            this.liveConnection = liveConnection;
            this.gameLiveConnection = gameLiveConnection;
            var localStorageUserSettings_1 = this.localStorageData;
            this.gameSpecificLocalStorageData = gameSpecificData;
            var defSettings = __assign(__assign({ isMusicOn: this.isMusicOn, musicVolume: this.musicVolume, isSoundOn: this.isSoundOn, soundVolume: this.soundVolume, isDarkModeOn: this.isDarkModeOn, isWinterModeOn: this.isWinterModeOn, isAnimationOn: this.isAnimationOn, gameThemeConfigs: this.gameThemeConfigs, isHalfCashOutOn: this.isHalfCashOutOn, selectedGameTypeId: this.selectedGameTypeId }, updatedDefaultSettings), gameSpecificData);
            var isReplaceLocalStorageData_1 = false;
            if (localStorageUserSettings_1 !== null) {
                Object.keys(defSettings).forEach(function (key) {
                    if (!localStorageUserSettings_1.hasOwnProperty(key)) {
                        isReplaceLocalStorageData_1 = true;
                    }
                });
            }
            else {
                isReplaceLocalStorageData_1 = true;
            }
            if (isReplaceLocalStorageData_1) {
                localStorage.setItem(this.localStorageKey, JSON.stringify(defSettings));
            }
            else {
                var isMusicOn = localStorageUserSettings_1.isMusicOn, musicVolume = localStorageUserSettings_1.musicVolume, isSoundOn = localStorageUserSettings_1.isSoundOn, soundVolume = localStorageUserSettings_1.soundVolume, isDarkModeOn = localStorageUserSettings_1.isDarkModeOn, isWinterModeOn = localStorageUserSettings_1.isWinterModeOn, isAnimationOn = localStorageUserSettings_1.isAnimationOn, gameThemeConfigs = localStorageUserSettings_1.gameThemeConfigs, isHalfCashOutOn = localStorageUserSettings_1.isHalfCashOutOn, selectedGameTypeId = localStorageUserSettings_1.selectedGameTypeId, rest = __rest(localStorageUserSettings_1, ["isMusicOn", "musicVolume", "isSoundOn", "soundVolume", "isDarkModeOn", "isWinterModeOn", "isAnimationOn", "gameThemeConfigs", "isHalfCashOutOn", "selectedGameTypeId"]);
                this.isMusicOn = isMusicOn;
                this.musicVolume = musicVolume;
                this.isSoundOn = isSoundOn;
                this.soundVolume = soundVolume;
                this.isDarkModeOn = isDarkModeOn;
                this.isWinterModeOn = isWinterModeOn;
                this.isAnimationOn = isAnimationOn;
                this.gameThemeConfigs = gameThemeConfigs;
                this.isHalfCashOutOn = isHalfCashOutOn;
                this.selectedGameTypeId = selectedGameTypeId;
                this.gameSpecificLocalStorageData = rest;
            }
            this.setGameThemeConfigs();
        }
        catch (e) { }
    };
    UserSettingsStore.prototype.updateLocalStorage = function (updatedSettings) {
        try {
            if (localStorage.getItem(this.localStorageKey)) {
                var updatedUserSettings = __assign(__assign({}, this.localStorageData), updatedSettings);
                localStorage.setItem(this.localStorageKey, JSON.stringify(updatedUserSettings));
            }
            else {
                console.error('PLEASE INIT YOUR LOCAL STORAGE');
            }
        }
        catch (e) { }
    };
    Object.defineProperty(UserSettingsStore.prototype, "localStorageData", {
        get: function () {
            try {
                return JSON.parse(localStorage.getItem(this.localStorageKey));
            }
            catch (e) {
                return {};
            }
        },
        enumerable: false,
        configurable: true
    });
    UserSettingsStore.prototype.setIsAnimationOn = function () {
        this.updateLocalStorage({
            isAnimationOn: !this.isAnimationOn,
        });
        this.isAnimationOn = !this.isAnimationOn;
    };
    UserSettingsStore.prototype.setIsMusicOnAndIsSoundOn = function (isMuteAll, isPostMessage) {
        if (isMuteAll === void 0) { isMuteAll = false; }
        if (isPostMessage === void 0) { isPostMessage = false; }
        var isOverrideMusicAndSoundOn = isPostMessage ? isMuteAll : this.isMusicOn || this.isSoundOn || isMuteAll;
        if (isOverrideMusicAndSoundOn) {
            this.setMusicVolume(0);
            this.setSoundVolume(0);
            iframeService.checkSoundAndSendUpdateSettings({ isMusicOn: false, isSoundOn: false, prevValue: platformMessageStore.sentSoundValue });
            // this.isMusicOn = false;
            // this.isSoundOn = false;
            // this.soundService.muteMusic(true);
            // this.soundService.muteSounds(true);
        }
        else {
            this.setMusicVolume(defaultSoundAndMusicVolume);
            this.setSoundVolume(defaultSoundAndMusicVolume);
            iframeService.checkSoundAndSendUpdateSettings({ isMusicOn: true, isSoundOn: true, prevValue: platformMessageStore.sentSoundValue });
            // this.isMusicOn = true;
            // this.isSoundOn = true;
            // this.soundService.muteMusic(false);
            // this.soundService.muteSounds(false);
        }
        this.updateLocalStorage({
            isMusicOn: this.isMusicOn,
            isSoundOn: this.isSoundOn,
        });
    };
    UserSettingsStore.prototype.setMusicVolume = function (musicVolume) {
        this.soundService.changeMusicVolume(musicVolume);
        var isMusicOn = +musicVolume === 0 ? false : !this.isMusicOn ? true : this.isMusicOn;
        this.updateLocalStorage({
            musicVolume: musicVolume,
            isMusicOn: isMusicOn,
        });
        this.musicVolume = musicVolume;
        this.setIsMusicOn(isMusicOn);
        this.soundService.muteMusic(!isMusicOn);
    };
    UserSettingsStore.prototype.setIsSoundOn = function (bool) {
        var hasValidArgument = typeof bool === 'boolean';
        this.soundService.muteSounds(hasValidArgument ? bool : this.isSoundOn);
        this.isSoundOn = hasValidArgument ? bool : !this.isSoundOn;
        // this.soundVolume = this.isSoundOn ? 0.5 : 0;
        iframeService.checkSoundAndSendUpdateSettings({
            isSoundOn: this.isSoundOn,
            isMusicOn: userSettingsStore.isMusicOn,
            prevValue: platformMessageStore.sentSoundValue,
        });
        this.updateLocalStorage({
            isSoundOn: this.isSoundOn,
            // soundVolume: this.soundVolume,
        });
    };
    UserSettingsStore.prototype.setIsMusicOn = function (bool) {
        var hasValidArgument = typeof bool === 'boolean';
        this.soundService.muteMusic(hasValidArgument ? bool : this.isMusicOn);
        this.isMusicOn = hasValidArgument ? bool : !this.isMusicOn;
        // this.musicVolume = this.isMusicOn  ? 0.5 : 0;
        iframeService.checkSoundAndSendUpdateSettings({
            isMusicOn: this.isMusicOn,
            isSoundOn: userSettingsStore.isSoundOn,
            prevValue: platformMessageStore.sentSoundValue,
        });
        this.updateLocalStorage({
            isMusicOn: this.isMusicOn,
            // musicVolume: this.musicVolume,
        });
    };
    UserSettingsStore.prototype.setSoundVolume = function (soundVolume) {
        this.soundService.changeSoundsVolume(soundVolume);
        var isSoundOn = +soundVolume === 0 ? false : !this.isSoundOn ? true : this.isSoundOn;
        this.updateLocalStorage({
            soundVolume: soundVolume,
            isSoundOn: isSoundOn,
        });
        this.soundVolume = soundVolume;
        this.setIsSoundOn(isSoundOn);
        this.soundService.muteSounds(!isSoundOn);
    };
    UserSettingsStore.prototype.setIsDarkModeOn = function (defaultValue) {
        if (defaultValue === undefined) {
            this.updateLocalStorage({
                isDarkModeOn: !this.isDarkModeOn,
            });
        }
        this.isDarkModeOn = defaultValue !== undefined ? defaultValue : !this.isDarkModeOn;
    };
    UserSettingsStore.prototype.setIsWinterModeOn = function () {
        this.updateLocalStorage({
            isWinterModeOn: !this.isWinterModeOn,
        });
        this.isWinterModeOn = !this.isWinterModeOn;
    };
    UserSettingsStore.prototype.setGameThemeConfigs = function () {
        var _a = parseQuery(window.location.search), _b = DefaultQueryParams.Theme, themeName = _a[_b];
        var themeType = +GameTheme[themeName];
        if (this.gameThemeConfigs.themeType !== themeType) {
            this.gameThemeConfigs = {
                themeType: themeType,
                isEnabled: true,
            };
        }
        this.setGameThemeTypeEnabledState(true);
    };
    UserSettingsStore.prototype.setGameThemeTypeEnabledState = function (isInit) {
        if (!isInit) {
            this.gameThemeConfigs = __assign(__assign({}, this.gameThemeConfigs), { isEnabled: !this.gameThemeConfigs.isEnabled });
        }
        var themeClassName = GameTheme[this.gameThemeConfigs.themeType].toLowerCase();
        if (themeClassName) {
            if (this.gameThemeConfigs.isEnabled) {
                document.documentElement.classList.add(themeClassName);
            }
            else {
                document.documentElement.classList.remove(themeClassName);
            }
        }
        this.updateLocalStorage({
            gameThemeConfigs: this.gameThemeConfigs,
        });
        // const { [DefaultQueryParams.Theme]: themeName } = parseQuery(window.location.search);
        // if (!!this.gameThemeType || !GameTheme[themeName]) {
        //   const themeClassName = GameTheme[this.gameThemeType].toLowerCase();
        //   document.documentElement.classList.remove(themeClassName);
        //   this.gameThemeType = GameTheme[GameThemeNames.Standart];
        // } else {
        //   this.gameThemeType = +GameTheme[themeName];
        //   const themeClassName = themeName.toLowerCase();
        //   document.documentElement.classList.add(themeClassName);
        // }
        // this.updateLocalStorage({
        //   gameThemeType: this.gameThemeType,
        // });
    };
    UserSettingsStore.prototype.setIsMusicOnValue = function (state) {
        this.isMusicOn = state;
    };
    Object.defineProperty(UserSettingsStore.prototype, "document", {
        get: function () {
            return window.document;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSettingsStore.prototype, "htmlElement", {
        get: function () {
            return document.documentElement;
        },
        enumerable: false,
        configurable: true
    });
    UserSettingsStore.prototype.setIsFullScreen = function (bool) {
        this.isFullScreen = bool;
    };
    UserSettingsStore.prototype.setAllowFullScreen = function (bool) {
        this.allowFullScreen = bool;
    };
    UserSettingsStore.prototype.setIsHalfCashOutOn = function () {
        this.updateLocalStorage({
            isHalfCashOutOn: !this.isHalfCashOutOn,
        });
        this.isHalfCashOutOn = !this.isHalfCashOutOn;
    };
    UserSettingsStore.prototype.toggleFullscreen = function () {
        !this.isFullScreen ? this.openFullScreen() : this.closeFullScreen();
    };
    UserSettingsStore.prototype.setGameTypeIdInLocalStorage = function (selectedGameTypeId) {
        this.updateLocalStorage({
            selectedGameTypeId: selectedGameTypeId,
        });
        this.setSelectedGameTypeId(selectedGameTypeId);
        if (selectedGameTypeId !== gameConfigStore.gameTypeId) {
            lobbyStore.setIsShowGameTypeLoading(true);
        }
    };
    UserSettingsStore.prototype.setSelectedGameTypeId = function (selectedGameTypeId) {
        this.selectedGameTypeId = selectedGameTypeId;
    };
    UserSettingsStore.prototype.toggleIsSilentMode = function (isSilentMode) {
        if (isSilentMode !== undefined) {
            this.isSilentMode = isSilentMode;
        }
        else {
            this.isSilentMode = !this.isSilentMode;
        }
    };
    UserSettingsStore.prototype.openFullScreen = function () {
        switch (true) {
            case !!this.htmlElement.requestFullscreen:
                this.htmlElement.requestFullscreen().catch(function (err) { return console.log(err); });
                break;
            case !!this.htmlElement.mozRequestFullScreen /* Firefox */:
                this.htmlElement.mozRequestFullScreen();
                break;
            case !!this.htmlElement.webkitRequestFullscreen /* Chrome, Safari and Opera */:
                this.htmlElement.webkitRequestFullscreen();
                break;
            case !!this.htmlElement.msRequestFullscreen /* IE/Edge */:
                this.htmlElement.msRequestFullscreen();
                break;
        }
    };
    UserSettingsStore.prototype.closeFullScreen = function () {
        switch (true) {
            case !!this.document.exitFullscreen:
                this.document.exitFullscreen().catch(function (err) { return console.log(err); });
                break;
            case !!this.document.mozCancelFullScreen /* Firefox */:
                this.document.mozCancelFullScreen();
                break;
            case !!this.document.webkitExitFullscreen /* Chrome, Safari and Opera */:
                this.document.webkitExitFullscreen();
                break;
            case !!this.document.msExitFullscreen /* IE/Edge */:
                this.document.msExitFullscreen();
                break;
        }
    };
    UserSettingsStore.prototype.setGameSpecificLocalStorageDataByKey = function (gameSpecificLocalStorageDataKey, gameSpecificLocalStorageDataValue) {
        this.gameSpecificLocalStorageData[gameSpecificLocalStorageDataKey] = gameSpecificLocalStorageDataValue;
        this.updateLocalStorage(this.gameSpecificLocalStorageData);
    };
    return UserSettingsStore;
}());
var userSettingsStore = new UserSettingsStore();

var GameConfigStore = /** @class */ (function () {
    function GameConfigStore() {
        this.limits = {};
        this.gameConfiguration = {};
        this.maxAutoCashOutOdd = null;
        this.isSkipLobby = false;
        this._gameTypeId = null;
        this._gameId = null;
        this._partnerId = null;
        this.gameConfigs = {};
        this.isGameHasHalfCashOut = false;
        this.isShowSideBarButton = false;
        this.sideBarButtonNotificationCount = 0;
        makeObservable(this, {
            limits: observable.deep,
            _gameTypeId: observable,
            gameTypeId: computed,
            _gameId: observable,
            gameId: computed,
            _partnerId: observable,
            partnerId: computed,
            gameConfigs: observable.deep,
            maxAutoCashOutOdd: observable,
            isShowSideBarButton: observable,
            sideBarButtonNotificationCount: observable,
            gameConfiguration: observable.deep,
            isSkipLobby: observable,
            setLimits: action.bound,
            setMaxAutoCashOutOdd: action.bound,
            setGameConfiguration: action.bound,
            setGameTypeId: action.bound,
            setGameId: action.bound,
            setPartnerId: action.bound,
            setIsSkipLobby: action.bound,
            initGameConfigs: action.bound,
            setGameConfigs: action.bound,
            setIsShowSideBarButton: action.bound,
            setSideBarButtonNotificationCount: action.bound,
        });
    }
    GameConfigStore.prototype.setLimits = function (limits) {
        this.limits = limits;
    };
    GameConfigStore.prototype.setMaxAutoCashOutOdd = function (maxAutoCashOutOdd) {
        this.maxAutoCashOutOdd = maxAutoCashOutOdd;
    };
    GameConfigStore.prototype.setGameConfiguration = function (gameConfiguration) {
        this.gameConfiguration = gameConfiguration;
    };
    GameConfigStore.prototype.setGameTypeId = function (id) {
        this._gameTypeId = id;
    };
    GameConfigStore.prototype.setIsSkipLobby = function (bool) {
        this.isSkipLobby = bool;
    };
    GameConfigStore.prototype.initGameConfigs = function (platformMessageConfig, gameConfigs) {
        var _a = parseQuery(window.location.search), _b = DefaultQueryParams.GameTypeId, gameTypeId = _a[_b];
        if (checkGameIsReplied(window.location.pathname)) {
            platformMessageStore.setIsRepliedGame(true);
        }
        if (gameConfigs) {
            this.setGameConfigs(gameConfigs);
        }
        var selectedGameTypeId = userSettingsStore.selectedGameTypeId;
        if (gameTypeId) {
            this.setIsSkipLobby(true);
            this.setGameTypeId(+gameTypeId);
        }
        if (gameTypeId && selectedGameTypeId) {
            this.setGameTypeId(+selectedGameTypeId);
            lobbyStore.setIsShowLobbySelectGameType(false);
            applicationStore.setAlreadyRedirectedToGame(true);
        }
        if (platformMessageConfig) {
            platformMessageStore.initPlatformMessageConfigs(platformMessageConfig);
        }
    };
    Object.defineProperty(GameConfigStore.prototype, "gameTypeId", {
        get: function () {
            return this._gameTypeId || parseQuery(window.location.search)[DefaultQueryParams.GameTypeId];
        },
        enumerable: false,
        configurable: true
    });
    GameConfigStore.prototype.setGameId = function (id) {
        this._gameId = id;
    };
    GameConfigStore.prototype.setPartnerId = function (partnerId) {
        this._partnerId = partnerId;
    };
    Object.defineProperty(GameConfigStore.prototype, "gameId", {
        get: function () {
            return this._gameId || parseQuery(window.location.search)[DefaultQueryParams.GameId];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameConfigStore.prototype, "partnerId", {
        get: function () {
            return this._partnerId || parseQuery(window.location.search)[DefaultQueryParams.PartnerId];
        },
        enumerable: false,
        configurable: true
    });
    GameConfigStore.prototype.setGameConfigs = function (gameConfigs) {
        this.gameConfigs = gameConfigs;
    };
    GameConfigStore.prototype.setIsGameHasHalfCashOut = function (bool) {
        this.isGameHasHalfCashOut = bool;
    };
    GameConfigStore.prototype.setIsShowSideBarButton = function (bool) {
        this.isShowSideBarButton = bool;
    };
    GameConfigStore.prototype.setSideBarButtonNotificationCount = function (value) {
        this.sideBarButtonNotificationCount = value;
    };
    return GameConfigStore;
}());
var gameConfigStore = new GameConfigStore();

var StatisticsStore = /** @class */ (function () {
    function StatisticsStore() {
        this.statistics = {
            100: [],
            200: [],
            500: [],
        };
        this.highestOddsData = [];
        this.statisticsRoundValue = 100;
        makeObservable(this, {
            statisticsRoundValue: observable.deep,
            statistics: observable.deep,
            highestOddsData: observable.deep,
            setStatistics: action.bound,
            resetStatistics: action.bound,
            setHighestOddsData: action.bound,
            resetHighestOddsData: action.bound,
            getHttpStatistics: flow.bound,
            sortStatisticsDataBySortType: action.bound,
        });
    }
    StatisticsStore.prototype.buildStatisticsData = function (statistics) {
        var currentStatisticsData = {};
        var convertObjToArray = function (obj) { var _a; return (_a = Object.keys(obj)) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, curr) { return __spreadArray(__spreadArray([], __read(acc), false), [{ num: curr, count: obj[curr] }], false); }, []); };
        for (var key in statistics) {
            currentStatisticsData[key] = convertObjToArray(statistics[key]);
        }
        return currentStatisticsData;
    };
    StatisticsStore.prototype.setHighestOddsData = function (highestOddsData) {
        this.highestOddsData = highestOddsData;
    };
    StatisticsStore.prototype.resetHighestOddsData = function () {
        this.highestOddsData = [];
    };
    StatisticsStore.prototype.getHttpStatistics = function (params) {
        var gameTypeId, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    gameTypeId = gameConfigStore.gameTypeId;
                    return [4 /*yield*/, ApiServices.get(ApiServiceTypes.StatisticsService).getStatistics(__assign({ gameTypeId: gameTypeId }, (params && params.take ? { take: params.take } : {})))];
                case 1:
                    result = (_a.sent()).data.result;
                    (result === null || result === void 0 ? void 0 : result.statistics) && this.setStatistics(this.buildStatisticsData(result === null || result === void 0 ? void 0 : result.statistics));
                    (result === null || result === void 0 ? void 0 : result.highestOdds) && this.setHighestOddsData(result === null || result === void 0 ? void 0 : result.highestOdds);
                    if (params === null || params === void 0 ? void 0 : params.isReturnStatistics) {
                        return [2 /*return*/, result];
                    }
                    return [2 /*return*/];
            }
        });
    };
    StatisticsStore.prototype.setStatistics = function (statistics) {
        this.statistics = statistics;
    };
    StatisticsStore.prototype.resetStatistics = function () {
        this.statistics = {
            100: [],
            200: [],
            500: [],
        };
    };
    StatisticsStore.prototype.sortStatisticsDataBySortType = function (sortType, lastRoundValue) {
        var _a, _b, _c;
        var Default = StatisticsSortingTypes.Default, Ascending = StatisticsSortingTypes.Ascending, Descending = StatisticsSortingTypes.Descending;
        this.statisticsRoundValue = lastRoundValue;
        var sortDataByType = (_a = {},
            _a[Default] = this.statistics,
            _a[Ascending] = __assign(__assign({}, this.statistics), (_b = {}, _b[lastRoundValue] = this.statistics[lastRoundValue].slice().sort(function (a, b) { return a.count - b.count; }), _b)),
            _a[Descending] = __assign(__assign({}, this.statistics), (_c = {}, _c[lastRoundValue] = this.statistics[lastRoundValue].slice().sort(function (a, b) { return b.count - a.count; }), _c)),
            _a);
        return __assign({}, sortDataByType[sortType]);
    };
    return StatisticsStore;
}());
var statisticsStore = new StatisticsStore();

var PopupStore = /** @class */ (function () {
    function PopupStore() {
        this.popupName = null;
        this.popupToggle = false;
        this.currentData = null;
        this.underMaintenance = false;
        this.maxWinToastState = false;
        this.reloadFrameForUnderMaintenanceOnCountDown = false;
        this.reloadFrameForUnderMaintenanceOnRoundStart = false;
        this.underMaintenanceSeconds = null;
        this.reconnect = false;
        this.connectionError = false;
        this.slowConnection = false;
        this.isFromBetHistory = false;
        this.isFromHighestRounds = false;
        this.hashResult = null;
        this.demoBetsCount = 0;
        makeObservable(this, {
            popupName: observable,
            popupToggle: observable,
            currentData: observable,
            underMaintenance: observable,
            maxWinToastState: observable,
            reloadFrameForUnderMaintenanceOnCountDown: observable,
            reloadFrameForUnderMaintenanceOnRoundStart: observable,
            underMaintenanceSeconds: observable,
            reconnect: observable,
            connectionError: observable,
            slowConnection: observable,
            isFromBetHistory: observable,
            hashResult: observable,
            demoBetsCount: observable,
            open: action.bound,
            close: action.bound,
            detectAndOpenCheckHashPopup: action.bound,
            onUnderMaintenanceCountdown: action.bound,
            toggleUnderMaintenance: action.bound,
            toggleReconnect: action.bound,
            onConnectionError: action.bound,
            toggleSlowConnection: action.bound,
            setReloadFrameForUnderMaintenanceOnCountDown: action.bound,
            setReloadFrameForUnderMaintenanceOnRoundStart: action.bound,
            maxWinToggle: action.bound,
            setHashResult: action.bound,
            getHashResult: action.bound,
            setDemoBetsCount: action.bound,
            resetUnderMaintenanceData: action.bound,
            updateDemoBetsCount: action.bound,
        });
    }
    PopupStore.prototype.setDemoBetsCount = function (count) {
        this.demoBetsCount = count;
    };
    PopupStore.prototype.updateDemoBetsCount = function () {
        this.demoBetsCount += 1;
    };
    PopupStore.prototype.open = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.data, data = _c === void 0 ? null : _c, _d = _b.name, name = _d === void 0 ? null : _d, _e = _b.isFromBetHistory, isFromBetHistory = _e === void 0 ? false : _e, _f = _b.isFromHighestRounds, isFromHighestRounds = _f === void 0 ? false : _f;
        if (name !== PopUps.ConnectionError) {
            // CONNECTION POPUP HANDLE IN PLATFORM
            this.popupToggle = true;
            this.currentData = data;
            this.popupName = name;
            this.isFromBetHistory = isFromBetHistory;
            this.isFromHighestRounds = isFromHighestRounds;
        }
    };
    PopupStore.prototype.close = function (e) {
        if (e === void 0) { e = null; }
        if (this.popupToggle && !isMobile()) {
            if (platformMessageStore.isOpenOddsSection) {
                platformMessageStore.setIsOpenOddsSection(false);
            }
            if (platformMessageStore.isOpenGameHelpSection) {
                platformMessageStore.setIsOpenGameHelpSection(false);
            }
        }
        e && e.stopPropagation();
        this.popupToggle = false;
        this.currentData = null;
        this.popupName = null;
    };
    PopupStore.prototype.startUnderMaintenanceFunctional = function (_a) {
        var _this = this;
        var startDate = _a.startDate, notifySeconds = _a.notifySeconds;
        if (startDate) {
            var seconds_1 = Math.floor((+new Date("".concat(startDate).concat(startDate.includes('Z') ? '' : 'Z')) - +new Date()) / 1000);
            if (!notifySeconds || (notifySeconds > seconds_1 && seconds_1 >= 0)) {
                this.toggleUnderMaintenance(true);
                this.onUnderMaintenanceCountdown(seconds_1);
            }
            var interval_1 = setInterval(function () {
                if (seconds_1 >= 0) {
                    if (notifySeconds === seconds_1) {
                        _this.toggleUnderMaintenance(true);
                    }
                    if (!notifySeconds || notifySeconds >= seconds_1) {
                        _this.onUnderMaintenanceCountdown(seconds_1);
                    }
                    seconds_1 -= 1;
                }
                else {
                    clearInterval(interval_1);
                    _this.setReloadFrameForUnderMaintenanceOnCountDown(true);
                }
            }, 1000);
        }
    };
    PopupStore.prototype.resetUnderMaintenanceData = function () {
        this.toggleUnderMaintenance(false);
        this.setReloadFrameForUnderMaintenanceOnCountDown(false);
        this.onUnderMaintenanceCountdown(null);
    };
    PopupStore.prototype.onUnderMaintenanceCountdown = function (seconds) {
        this.underMaintenanceSeconds = seconds;
    };
    PopupStore.prototype.toggleUnderMaintenance = function (state) {
        if (state !== undefined) {
            this.underMaintenance = state;
        }
        else {
            this.underMaintenance = !this.underMaintenance;
        }
    };
    PopupStore.prototype.toggleReconnect = function (state) {
        if (state !== undefined) {
            this.reconnect = state;
        }
        else {
            this.reconnect = !this.reconnect;
        }
        if (this.reconnect) {
            iframeService.sendErrorReceived({
                errorCode: BetResponseCode.Reconnect,
                errorMessage: applicationStore.translator(TranslationKeys.Reconnect),
            });
        }
    };
    PopupStore.prototype.onConnectionError = function (state) {
        this.connectionError = state;
        if (state) {
            iframeService.sendErrorReceived({
                errorCode: BetResponseCode.ConnectionError,
                errorMessage: applicationStore.translator(TranslationKeys.PleaseRefreshPage),
            });
        }
    };
    PopupStore.prototype.toggleSlowConnection = function (state) {
        if (state !== undefined) {
            this.slowConnection = state;
        }
        else {
            this.slowConnection = !this.slowConnection;
        }
    };
    PopupStore.prototype.setReloadFrameForUnderMaintenanceOnCountDown = function (state) {
        if (state !== undefined) {
            this.reloadFrameForUnderMaintenanceOnCountDown = state;
        }
        else {
            this.reloadFrameForUnderMaintenanceOnCountDown = !this.reloadFrameForUnderMaintenanceOnCountDown;
        }
    };
    PopupStore.prototype.setReloadFrameForUnderMaintenanceOnRoundStart = function (state) {
        if (state !== undefined) {
            this.reloadFrameForUnderMaintenanceOnRoundStart = state;
        }
        else {
            this.reloadFrameForUnderMaintenanceOnRoundStart = !this.reloadFrameForUnderMaintenanceOnRoundStart;
        }
    };
    PopupStore.prototype.maxWinToggle = function (state) {
        if (state !== undefined) {
            this.maxWinToastState = state;
        }
        else {
            this.maxWinToastState = !this.maxWinToastState;
        }
    };
    PopupStore.prototype.detectAndOpenCheckHashPopup = function (_a) {
        var selectedId = _a.selectedId, name = _a.name, _b = _a.isFromBetHistory, isFromBetHistory = _b === void 0 ? false : _b, _c = _a.isFromHighestRounds, isFromHighestRounds = _c === void 0 ? false : _c;
        var data;
        if (isFromBetHistory) {
            var betHistoryData = betStore.betHistory.data;
            data = betHistoryData.find(function (_a) {
                var id = _a.id;
                return id === selectedId;
            });
        }
        else {
            var gameResults = gameResultStore.gameResults;
            var highestOddsData = statisticsStore.highestOddsData;
            data = (isFromHighestRounds ? highestOddsData : gameResults).find(function (_a) {
                var roundId = _a.roundId;
                return roundId === selectedId;
            });
            if (isFromHighestRounds) {
                data = data.roundData;
            }
        }
        this.open({ data: data, name: name, isFromBetHistory: isFromBetHistory, isFromHighestRounds: isFromHighestRounds });
    };
    PopupStore.prototype.getHashResult = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var fetchedData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiServices.get(ApiServiceTypes.RoundsService).checkResultHash(data)];
                    case 1:
                        fetchedData = _a.sent();
                        if (fetchedData && fetchedData.data.result) {
                            this.setHashResult(fetchedData.data.result);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PopupStore.prototype.setHashResult = function (hashResult) {
        if (hashResult === void 0) { hashResult = null; }
        this.hashResult = hashResult;
    };
    return PopupStore;
}());
var popupStore = new PopupStore();

var ProfileAvatarStore = /** @class */ (function () {
    function ProfileAvatarStore() {
        this.isMobileAvatarsBlockOpened = false;
        this.availableAvatarsType = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];
        this.avatarId = this.availableAvatarsType[0];
        this.initialAvatarId = null;
        makeObservable(this, {
            avatarId: observable,
            initialAvatarId: observable,
            updateInitialAvatarId: action.bound,
            isMobileAvatarsBlockOpened: observable,
            updateAvatarId: action.bound,
            sendAvatarIdToBackend: action.bound,
        });
    }
    ProfileAvatarStore.prototype.updateAvatarId = function (id) {
        this.avatarId = id;
    };
    ProfileAvatarStore.prototype.updateInitialAvatarId = function (initialAvatarId) {
        this.initialAvatarId = initialAvatarId;
    };
    ProfileAvatarStore.prototype.sendAvatarIdToBackend = function (userId) {
        var _this = this;
        var gameTypeId = gameConfigStore.gameTypeId;
        ApiServices.get(ApiServiceTypes.UsersService)
            .updateUserAvatar(this.avatarId)
            .then(function () {
            if (chatStore.isShowChat) {
                var chatMessageData = chatStore.chatMessageData;
                var updatedChatMessageData = chatMessageData === null || chatMessageData === void 0 ? void 0 : chatMessageData.map(function (item) {
                    if ((item === null || item === void 0 ? void 0 : item.userId) === userId) {
                        return __assign(__assign({}, item), { avatarId: _this.avatarId });
                    }
                    return item;
                });
                chatService.updateAdditionalData(+gameTypeId, _this.avatarId);
                chatStore.setChatMessageHistory(updatedChatMessageData);
            }
        })
            .catch(function (error) {
            console.error(error);
        });
    };
    return ProfileAvatarStore;
}());
var profileAvatarStore = new ProfileAvatarStore();

var ApplicationStore = /** @class */ (function () {
    function ApplicationStore() {
        this.isDemo = false;
        this.accessToken = '';
        this.isGuest = false;
        this.isBogLine = false;
        this.gameIsOpen = false;
        this.isTestPlatform = false;
        this.isISOStandard = false;
        this.isAuthenticated = false;
        this.isAuthDataReceived = false;
        this.alreadyRedirectedToGame = false;
        this.useDemoByBackendLogic = true;
        this.translator = function (value) { return value; };
        makeObservable(this, {
            isDemo: observable,
            isGuest: observable,
            translator: observable,
            gameIsOpen: observable,
            isTestPlatform: observable,
            isISOStandard: observable,
            accessToken: observable,
            isAuthenticated: observable,
            isAuthDataReceived: observable,
            useDemoByBackendLogic: observable,
            isBogLine: observable,
            setIsDemo: action.bound,
            setIsGuest: action.bound,
            setGameIsOpen: action.bound,
            checkGameIsOpen: action.bound,
            setIsTestPlatform: action.bound,
            setIsISOStandard: action.bound,
            setAccessToken: action.bound,
            setIsAuthenticated: action.bound,
            setIsAuthDataReceived: action.bound,
            setIsBogLine: action.bound,
            setTranslator: action.bound,
            setAlreadyRedirectedToGame: action.bound,
            setUseDemoByBackendLogic: action.bound,
        });
    }
    ApplicationStore.prototype.setTranslator = function (translator) {
        if (translator === void 0) { translator = function (value) { return value; }; }
        this.translator = translator;
    };
    ApplicationStore.prototype.setIsDemo = function (isDemo) {
        this.isDemo = isDemo;
    };
    ApplicationStore.prototype.setGameIsOpen = function (gameIsOpen) {
        this.gameIsOpen = gameIsOpen;
        if (gameIsOpen) {
            iframeService.sendErrorReceived({
                errorCode: BetResponseCode.GameIsOpen,
                errorMessage: applicationStore.translator(TranslationKeys.YourSessionWasInterrupted),
            });
        }
    };
    ApplicationStore.prototype.setIsTestPlatform = function (isTestPlatform) {
        this.isTestPlatform = isTestPlatform;
    };
    ApplicationStore.prototype.checkGameIsOpen = function (data, connection) {
        var gameTypeId = gameConfigStore.gameTypeId, gameId = gameConfigStore.gameId;
        if (connection &&
            connection.connectionId !== data.connectionId &&
            (data.gameId === +gameId || data.gameTypeId === +gameTypeId)) {
            this.setGameIsOpen(true);
            // if ((this.isBogLine && !platformMessageStore.isUsedBogLineComponents) || !this.isBogLine) { HANDLE IN PLATFORM
            //   popupStore.open({ name: PopUps.GameOpen });
            // }
            connection.stop();
        }
    };
    ApplicationStore.prototype.setIsGuest = function (isGuest) {
        this.isGuest = isGuest;
    };
    ApplicationStore.prototype.setIsISOStandard = function (isISOStandard) {
        this.isISOStandard = isISOStandard;
    };
    ApplicationStore.prototype.demoSwitcher = function (demoSwitcherAdditionalFunction) {
        var isAuthenticated = applicationStore.isAuthenticated, isBogLine = applicationStore.isBogLine;
        isBogLine && profileAvatarStore.updateAvatarId(profileAvatarStore.initialAvatarId);
        if (isAuthenticated) {
            applicationStore.setIsDemo(false);
            if (popupStore.demoBetsCount) {
                popupStore.setDemoBetsCount(0);
            }
            if (demoSwitcherAdditionalFunction) {
                demoSwitcherAdditionalFunction();
            }
        }
        else {
            iframeService.sendLoginCheck();
        }
    };
    ApplicationStore.prototype.setAccessToken = function (accessToken) {
        this.accessToken = accessToken;
    };
    ApplicationStore.prototype.setIsAuthenticated = function (isAuthenticated) {
        this.isAuthenticated = isAuthenticated;
    };
    ApplicationStore.prototype.setIsAuthDataReceived = function (isAuthDataReceived) {
        this.isAuthDataReceived = isAuthDataReceived;
    };
    ApplicationStore.prototype.setIsBogLine = function (isBogLine) {
        this.isBogLine = isBogLine;
    };
    ApplicationStore.prototype.setAlreadyRedirectedToGame = function (value) {
        this.alreadyRedirectedToGame = value;
    };
    ApplicationStore.prototype.setUseDemoByBackendLogic = function (value) {
        this.useDemoByBackendLogic = value;
    };
    return ApplicationStore;
}());
var applicationStore = new ApplicationStore();

var BetsStore = /** @class */ (function () {
    function BetsStore() {
        this.liveBets = []; // GAME BETS
        this.pendingBets = [];
        this.renderTimeout = null;
        this.currentWinners = []; // LOBBY BETS
        this._betHistory = new HttpResponse([], RequestStatus.Done);
        this._betHistorySkip = 0;
        this._demoBetHistory = [];
        this.repliedBetData = null;
        this.isAllowToGetBetsHistory = true;
        this.topWinners = new HttpResponse([]);
        this.topWinnersTotalCount = 0;
        this.betHistoryFilter = BetHistoryFilterTypes.All;
        this.topWinnersDefaultTake = 20;
        this.betsDefaultTake = 20;
        this.currentWinnersTimeOutId = null;
        this.maxCurrentWinnersCount = 50;
        this.betHistoryRequestAdditionalParams = null;
        this._tournamentId = null;
        this.customBetHistoryParser = function (data) { return data; };
        makeObservable(this, {
            betHistory: computed,
            topWinners: observable.deep,
            _betHistory: observable.deep,
            _demoBetHistory: observable.deep,
            betHistoryFilter: observable,
            currentWinners: observable,
            betsService: computed,
            liveBets: observable.shallow,
            repliedBetData: observable.deep,
            betHistoryRequestAdditionalParams: observable.deep,
            tournamentId: computed,
            _tournamentId: observable,
            setTopWinners: action.bound,
            setDemoBetHistory: action.bound,
            updateDemoBetHistory: action.bound,
            setBetHistory: action.bound,
            setBetHistoryFilter: action.bound,
            setCurrentWinners: action.bound,
            updateCurrentWinners: action.bound,
            resetBetHistory: action.bound,
            resetTopWinners: action.bound,
            setLiveBets: action.bound,
            updateLiveBets: action.bound,
            spliceLiveBets: action.bound,
            setBetHistoryRequestAdditionalParams: action.bound,
            setTournamentId: action.bound,
            setPendingBets: action.bound,
            getTopWinners: flow.bound,
            getBetHistory: flow.bound,
            getRepliedBetData: flow.bound,
        });
    }
    Object.defineProperty(BetsStore.prototype, "betsService", {
        get: function () {
            return ApiServices.get(ApiServiceTypes.BetsService);
        },
        enumerable: false,
        configurable: true
    });
    BetsStore.prototype.getTopWinners = function (params, customTopWinnersParser) {
        var _a, skip, _b, take, _c, fetchPath, gameId;
        var _this = this;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_d) {
            _a = params.skip, skip = _a === void 0 ? this.topWinners.data.length : _a, _b = params.take, take = _b === void 0 ? this.topWinnersDefaultTake : _b, _c = params.fetchPath, fetchPath = _c === void 0 ? BetsFetchDefaultPaths.TopWinners : _c, gameId = params.gameId;
            if (!this.topWinnersTotalCount ||
                !this.topWinners.data.length ||
                (this.topWinners.data.length + 1 < this.topWinnersTotalCount && this.topWinners.status !== RequestStatus.Pending)) {
                this.fetchingTopWinners();
                this.betsService
                    .getBets(__assign({ skip: skip, take: take }, (gameId ? { gameId: gameId } : {})), fetchPath)
                    .then(function (_a) {
                    var _b = _a.data.result, items = _b.items, count = _b.count;
                    _this.topWinnersTotalCount = count;
                    _this.fetchedTopWinners(items, customTopWinnersParser);
                })
                    .catch(function (error) {
                    _this.setTopWinners(_this.topWinners.failed(error));
                });
            }
            return [2 /*return*/];
        });
    };
    BetsStore.prototype.setTopWinners = function (topWinners) {
        this.topWinners = topWinners;
    };
    BetsStore.prototype.getRepliedBetData = function () {
        var _this = this;
        return __generator(this, function (_a) {
            this.betsService
                .getBetDataByBetId()
                .then(function (_a) {
                var result = _a.data.result;
                _this.setRepliedBetData(result);
            })
                .catch(function () { return _this.setRepliedBetData(null); });
            return [2 /*return*/];
        });
    };
    BetsStore.prototype.getBetHistory = function (params, customStatus, customBetHistoryParser, isGetViaSocket) {
        var _a, skip, _b, take, params_1, gameLiveConnection;
        var _this = this;
        if (params === void 0) { params = {}; }
        if (customBetHistoryParser === void 0) { customBetHistoryParser = function (data) { return data; }; }
        if (isGetViaSocket === void 0) { isGetViaSocket = false; }
        return __generator(this, function (_c) {
            _a = params.skip, skip = _a === void 0 ? this._betHistorySkip : _a, _b = params.take, take = _b === void 0 ? this.betsDefaultTake : _b;
            if (this.isAllowToGetBetsHistory && this._betHistory.status !== RequestStatus.Pending) {
                this.fetchingBetHistory();
                params_1 = __assign(__assign({ skip: skip, take: take, gameId: gameConfigStore.gameId, status: customStatus !== undefined
                        ? customStatus
                        : this.betHistoryFilter === BetHistoryFilterTypes.All
                            ? null
                            : this.betHistoryFilter }, (applicationStore.isDemo ? { demoUserId: userInfoStore.userId } : {})), (this.betHistoryRequestAdditionalParams || {}));
                this.customBetHistoryParser = customBetHistoryParser;
                this.customStatus = customStatus;
                if (isGetViaSocket) {
                    gameLiveConnection = userSettingsStore.gameLiveConnection;
                    gameLiveConnection.getUserBetsHistory(params_1);
                }
                else {
                    this.betsService
                        .getBets(params_1)
                        .then(function (data) { return _this.getBetHistoryDataParser(data); })
                        .catch(function (error) {
                        _this.setBetHistory(_this._betHistory.failed(error));
                    });
                }
            }
            return [2 /*return*/];
        });
    };
    BetsStore.prototype.getBetHistoryDataParser = function (_a) {
        var items = _a.data.result.items;
        if (!(items === null || items === void 0 ? void 0 : items.length)) {
            this.isAllowToGetBetsHistory = false;
        }
        this._betHistorySkip += items.length;
        this.fetchedBetHistory(items);
    };
    BetsStore.prototype.setBetHistory = function (bets) {
        this._betHistory = bets;
    };
    BetsStore.prototype.setRepliedBetData = function (betData) {
        this.repliedBetData = betData;
        userInfoStore.setUserId(betData === null || betData === void 0 ? void 0 : betData.userId);
        roundInfoStore.setRoundId(betData === null || betData === void 0 ? void 0 : betData.roundId);
        if (betData === null || betData === void 0 ? void 0 : betData.freeBet) {
            freeBetStore.setFreeBets([betData === null || betData === void 0 ? void 0 : betData.freeBet]);
            freeBetStore.setActivateFreeBet(betData === null || betData === void 0 ? void 0 : betData.freeBet);
        }
    };
    BetsStore.prototype.setDemoBetHistory = function (bets) {
        this._demoBetHistory = bets;
    };
    BetsStore.prototype.updateDemoBetHistory = function (bets) {
        this._demoBetHistory = __spreadArray(__spreadArray([], __read(bets), false), __read(this._demoBetHistory), false);
    };
    BetsStore.prototype.setCurrentWinners = function (currentWinners) {
        if (this.currentWinnersTimeOutId) {
            clearTimeout(this.currentWinnersTimeOutId);
        }
        findUpdateHalfData(currentWinners);
        this.currentWinners = currentWinners;
    };
    BetsStore.prototype.updateCurrentWinnersWithDelay = function (currentWinners) {
        var _this = this;
        if (currentWinners.length) {
            findUpdateHalfData(currentWinners);
            this.currentWinnersTimeOutId = setTimeout(function () {
                _this.updateCurrentWinners(currentWinners);
            }, lobbyStore.roundFinAnimationDuration);
        }
    };
    BetsStore.prototype.updateCurrentWinners = function (currentWinners) {
        var currentWinnersResult = __spreadArray(__spreadArray([], __read(currentWinners), false), __read(this.currentWinners), false);
        if (currentWinnersResult.length > this.maxCurrentWinnersCount) {
            currentWinnersResult.splice(this.maxCurrentWinnersCount);
        }
        this.currentWinners = currentWinnersResult;
    };
    BetsStore.prototype.setLiveBets = function (liveBets) {
        this.liveBets = liveBets;
    };
    BetsStore.prototype.updateLiveBets = function (liveBet, isAddBetToTop) {
        var _a;
        var _this = this;
        if (Array.isArray(liveBet)) {
            (_a = this.pendingBets).push.apply(_a, __spreadArray([], __read(liveBet), false));
        }
        else {
            this.pendingBets.push(liveBet);
        }
        if (!this.renderTimeout) {
            this.renderTimeout = setTimeout(function () {
                _this.setPendingBets(isAddBetToTop);
            }, 150);
        }
    };
    BetsStore.prototype.setPendingBets = function (isAddBetToTop) {
        if (this.pendingBets.length === 0)
            return;
        if (isAddBetToTop) {
            this.liveBets = __spreadArray(__spreadArray([], __read(this.pendingBets), false), __read(this.liveBets), false);
        }
        else {
            this.liveBets = __spreadArray(__spreadArray([], __read(this.liveBets), false), __read(this.pendingBets), false);
        }
        this.pendingBets = [];
        this.renderTimeout = null;
    };
    BetsStore.prototype.spliceLiveBets = function (from, to) {
        this.liveBets.splice(from, to);
    };
    BetsStore.prototype.setBetHistoryFilter = function (filter, customStatus, customBetHistoryParser, isGetViaSocket) {
        this.betHistoryFilter = filter;
        this.resetBetHistory();
        this.getBetHistory({}, customStatus, customBetHistoryParser, isGetViaSocket);
    };
    BetsStore.prototype.fetchingBetHistory = function () {
        this.setBetHistory(this._betHistory.fetching());
    };
    BetsStore.prototype.fetchedBetHistory = function (response, customBetHistoryParser, customStatus) {
        if (customBetHistoryParser === void 0) { customBetHistoryParser = this.customBetHistoryParser; }
        if (customStatus === void 0) { customStatus = this.customStatus; }
        if (customStatus === null) {
            this.setBetHistory(this._betHistory.fetched(customBetHistoryParser(__spreadArray(__spreadArray([], __read(this._betHistory.data), false), __read(response), false))));
        }
        else {
            this.setBetHistory(this._betHistory.fetched(__spreadArray(__spreadArray([], __read(this._betHistory.data), false), __read(customBetHistoryParser(response)), false)));
        }
    };
    BetsStore.prototype.fetchingTopWinners = function () {
        this.setTopWinners(this.topWinners.fetching());
    };
    BetsStore.prototype.fetchedTopWinners = function (response, customTopWinnersParser) {
        var isGameHasHalfCashOut = gameConfigStore.isGameHasHalfCashOut;
        if (isGameHasHalfCashOut) {
            findUpdateHalfData(response, true);
        }
        var result = __spreadArray(__spreadArray([], __read(this.topWinners.data), false), __read(response), false);
        if (isGameHasHalfCashOut) {
            result.sort(function (a, b) { return b.winCoinAmount - a.winCoinAmount; });
        }
        var parsedResult = result;
        if (customTopWinnersParser) {
            parsedResult = customTopWinnersParser(result);
        }
        this.setTopWinners(this.topWinners.fetched(parsedResult));
    };
    BetsStore.prototype.resetTopWinners = function () {
        this.setTopWinners(this.topWinners.fetching(true));
    };
    BetsStore.prototype.resetBetHistory = function () {
        this._betHistorySkip = 0;
        this.isAllowToGetBetsHistory = true;
        this.setBetHistory(this._betHistory.fetching(true, RequestStatus.Done));
    };
    BetsStore.prototype.setBetHistoryRequestAdditionalParams = function (requestAdditionalParams) {
        this.betHistoryRequestAdditionalParams = requestAdditionalParams;
    };
    BetsStore.prototype.setTournamentId = function (tournamentId) {
        this._tournamentId = tournamentId;
    };
    Object.defineProperty(BetsStore.prototype, "tournamentId", {
        get: function () {
            if (!this._tournamentId) {
                var _a = parseQuery(window.location.search), _b = DefaultQueryParams.TournamentId, _c = _a[_b], tournamentId = _c === void 0 ? null : _c;
                this._tournamentId = tournamentId;
            }
            return this._tournamentId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BetsStore.prototype, "betHistory", {
        get: function () {
            // const { isDemo } = applicationStore;
            // isDemo ? { data: this._demoBetHistory } :
            // need to improve
            return this._betHistory;
        },
        enumerable: false,
        configurable: true
    });
    return BetsStore;
}());
var betStore = new BetsStore();

var FreeChipsStore = /** @class */ (function () {
    function FreeChipsStore() {
        this.freeChipsList = [];
        this.freeChipInfo = null;
        this.freeChipAwardedOrEnded = null;
        this.activeFreeChip = null;
        this.freeChipLimits = null;
        this.freeChipInLobby = null;
        this.freeChipPopupName = '';
        makeObservable(this, {
            freeChipInfo: observable.deep,
            freeChipsList: observable.deep,
            activeFreeChip: observable.deep,
            freeChipLimits: observable.deep,
            freeChipInLobby: observable.deep,
            freeChipAwardedOrEnded: observable.deep,
            freeChipPopupName: observable.deep,
            setFreeChipsList: action.bound,
            updateFreeChipList: action.bound,
            setFreeChipInfo: action.bound,
            setFreeChipInLobby: action.bound,
            setFreeChipAwardedOrEnded: action.bound,
            setActiveFreeChip: action.bound,
            setFreeChipLimits: action.bound,
            setFreeChipPopupName: action.bound,
            handleShowAwardedFreeChip: action.bound,
            handleEndedFreeChip: action.bound,
            handleFreeChipRemainingCountDown: action.bound,
            resetActiveFreeChip: action.bound,
            handleUpdateFreeChipTotalWin: action.bound,
            handleChangeFreeChipStatus: action.bound,
            sendClaimFreeBet: action.bound,
            resetFreeChipStoreData: action.bound,
        });
    }
    FreeChipsStore.prototype.handleShowAwardedFreeChip = function () {
        var pendingFreeChipIndex = this.freeChipsList.findIndex(function (item) { return item.status === FreeBetsStatus.Pending; });
        if (pendingFreeChipIndex >= 0) {
            this.setFreeChipAwardedOrEnded(this.freeChipsList[pendingFreeChipIndex]);
            this.setFreeChipPopupName(FreeChipNames.freeChipWin);
        }
    };
    FreeChipsStore.prototype.handleEndedFreeChip = function (endedFreeChips, showPopupTimer) {
        var _this = this;
        if (showPopupTimer === void 0) { showPopupTimer = 3000; }
        endedFreeChips.forEach(function (endedFreeChip, i) {
            var finishedFreeChipIndex = _this.freeChipsList.findIndex(function (item) { return item.id === endedFreeChip.freeBetId; });
            if (finishedFreeChipIndex >= 0) {
                setTimeout(function () {
                    _this.setFreeChipAwardedOrEnded(__assign(__assign({}, _this.freeChipsList[finishedFreeChipIndex]), endedFreeChip));
                    _this.setFreeChipPopupName(FreeChipNames.freeChipEnded);
                    _this.freeChipsList[finishedFreeChipIndex] = __assign(__assign({}, _this.freeChipsList[finishedFreeChipIndex]), { status: FreeBetsStatus.Finished, totalWin: endedFreeChip.totalAmount });
                    setTimeout(function () {
                        _this.setFreeChipPopupName(null);
                        _this.setFreeChipAwardedOrEnded(null);
                    }, i * showPopupTimer + showPopupTimer);
                }, i * showPopupTimer);
            }
        });
    };
    // this would not be called in bet closed
    FreeChipsStore.prototype.sendClaimFreeBet = function (_a) {
        var _this = this;
        var freeChip = _a.freeChip, actionType = _a.actionType, _b = _a.isClickable, isClickable = _b === void 0 ? false : _b, _c = _a.callBack, callBack = _c === void 0 ? null : _c;
        var claimedFreeChipIndex = this.freeChipsList.findIndex(function (item) { return item.id === freeChip.id; });
        if (claimedFreeChipIndex >= 0) {
            ApiServices.get(ApiServiceTypes.FreeChipService)
                .sendClaimFreeBet(this.freeChipsList[claimedFreeChipIndex].id)
                .then(function () {
                _this.freeChipsList[claimedFreeChipIndex].status = FreeBetsStatus.Accepted;
                if (actionType === FreeChipPopupActions.USE_NOW && isClickable && !callBack) {
                    _this.setActiveFreeChip(freeChip);
                    _this.setFreeChipPopupName(null);
                }
                else {
                    _this.setFreeChipPopupName(null);
                    if (callBack) {
                        callBack();
                    }
                }
                _this.setFreeChipAwardedOrEnded(null);
                _this.handleShowAwardedFreeChip();
            })
                .catch(function () { });
        }
    };
    FreeChipsStore.prototype.setFreeChipsList = function (list) {
        this.freeChipsList = list;
        this.handleShowAwardedFreeChip();
    };
    FreeChipsStore.prototype.setFreeChipInLobby = function (freeChip) {
        this.freeChipInLobby = freeChip;
    };
    FreeChipsStore.prototype.updateFreeChipList = function (freeChips) {
        this.freeChipsList = __spreadArray(__spreadArray([], __read(this.freeChipsList), false), __read(freeChips), false);
        this.handleShowAwardedFreeChip();
    };
    FreeChipsStore.prototype.setFreeChipAwardedOrEnded = function (freeChip) {
        this.freeChipAwardedOrEnded = freeChip;
    };
    FreeChipsStore.prototype.setFreeChipInfo = function (freeChip) {
        this.freeChipInfo = freeChip;
        this.setFreeChipPopupName(FreeChipNames.freeChipInfo);
    };
    FreeChipsStore.prototype.setActiveFreeChip = function (freeChip) {
        var limits = gameConfigStore.limits;
        if (this.activeFreeChip && this.activeFreeChip.id === freeChip.id) {
            this.resetActiveFreeChip();
            return;
        }
        if (limits) {
            var additionalLimits_1 = limits.additionalLimits, maxBet_1 = limits.maxBet;
            var freeChipLimits = Object.keys(additionalLimits_1).reduce(function (acc, cur) {
                acc.additionalLimits[cur] = __assign(__assign({}, additionalLimits_1[cur]), { maxBet: freeChip.amount > maxBet_1 ? maxBet_1 : freeChip.amount });
                return acc;
            }, {
                additionalLimits: {},
            });
            this.setFreeChipLimits(freeChipLimits);
        }
        this.activeFreeChip = freeChip;
        if (this.freeChipInLobby) {
            this.freeChipInLobby = null;
        }
    };
    FreeChipsStore.prototype.setFreeChipLimits = function (limits) {
        this.freeChipLimits = limits;
    };
    FreeChipsStore.prototype.setFreeChipPopupName = function (name) {
        this.freeChipPopupName = name;
    };
    FreeChipsStore.prototype.handleUpdateFreeChipTotalWin = function (winAmount) {
        var _this = this;
        var activeFreeChipIndex = this.freeChipsList.findIndex(function (item) { return item.id === _this.activeFreeChip.id; });
        this.freeChipsList[activeFreeChipIndex].totalWin += winAmount;
    };
    FreeChipsStore.prototype.handleChangeFreeChipStatus = function (index, newStatus) {
        var _a;
        if ((_a = this.freeChipsList) === null || _a === void 0 ? void 0 : _a[index]) {
            this.freeChipsList[index].status = newStatus;
        }
    };
    FreeChipsStore.prototype.handleFreeChipRemainingCountDown = function (id) {
        var freeChipIndex = this.freeChipsList.findIndex(function (item) { return item.id === id; });
        if (freeChipIndex >= 0) {
            this.freeChipsList[freeChipIndex].remainingCount -= 1;
            this.activeFreeChip.remainingCount = this.freeChipsList[freeChipIndex].remainingCount;
            if (!this.freeChipsList[freeChipIndex].remainingCount) {
                this.freeChipsList[freeChipIndex].status = FreeBetsStatus.Finished;
            }
        }
    };
    FreeChipsStore.prototype.resetActiveFreeChip = function () {
        this.activeFreeChip = null;
        this.freeChipLimits = null;
    };
    FreeChipsStore.prototype.resetFreeChipStoreData = function () {
        this.freeChipsList = [];
        this.freeChipInfo = null;
        this.freeChipAwardedOrEnded = null;
        this.activeFreeChip = null;
        this.freeChipLimits = null;
        this.freeChipPopupName = '';
    };
    return FreeChipsStore;
}());
var freeChipsStore = new FreeChipsStore();

var TableBetHistoryStore = /** @class */ (function () {
    function TableBetHistoryStore() {
        this.fetchPaths = BetsFetchDefaultPaths;
        this.fetchParamNames = BetsFetchDefaultParamNames;
        this.queryState = {
            skip: 0,
            take: 15,
        };
        this.selectedHistoryRow = null;
        this.showRoundBet = false;
        this.firstStep = {
            data: {
                items: [],
                count: 0,
            },
            pending: false,
        };
        this.thirdStep = {
            data: {},
            pending: false,
        };
        this.secondStep = {
            data: {},
            pending: false,
        };
        makeObservable(this, {
            queryState: observable,
            selectedHistoryRow: observable.deep,
            firstStep: observable.deep,
            thirdStep: observable.deep,
            secondStep: observable.deep,
            fetchPaths: observable.deep,
            fetchParamNames: observable.deep,
            showRoundBet: observable,
            getFirstStep: flow.bound,
            getSecondStep: flow.bound,
            getThirdStep: flow.bound,
            removeThirdStep: action.bound,
            setSelectedHistoryRow: action.bound,
            setFirstStepPending: action.bound,
            setSecondStepPending: action.bound,
            setThirdStepPending: action.bound,
            setFetchPaths: action.bound,
            setFetchParamNames: action.bound,
            betsService: computed,
        });
    }
    Object.defineProperty(TableBetHistoryStore.prototype, "betsService", {
        get: function () {
            return ApiServices.get(ApiServiceTypes.BetsService);
        },
        enumerable: false,
        configurable: true
    });
    TableBetHistoryStore.prototype.setSelectedHistoryRow = function (payload) {
        this.selectedHistoryRow = payload;
    };
    TableBetHistoryStore.prototype.setShowRoundBet = function (arg) {
        this.showRoundBet = arg;
    };
    TableBetHistoryStore.prototype.setFirstStepPending = function () {
        this.firstStep.pending = !this.firstStep.pending;
    };
    TableBetHistoryStore.prototype.handleBetHistoryUpdate = function () {
        var getDay = getStartEndDay(moment().format());
        this.getFirstStep(this.queryState);
        this.getSecondStep({
            key: moment(getDay.startDate).format('YYYY-MM-DDT00:00:00'),
            date: getDay,
        });
    };
    TableBetHistoryStore.prototype.getFirstStep = function (payload) {
        var _a, _b, gameId, concat, options, result, items, all, firstStep, _c, firstData, firstStepData;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _a = parseQuery(window.location.search), _b = DefaultQueryParams.GameId, gameId = _a[_b];
                    concat = payload.concat, options = __rest(payload, ["concat"]);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    this.setFirstStepPending();
                    return [4 /*yield*/, this.betsService.getBets(__assign({ gameId: gameId }, options), this.fetchPaths.FirstStep)];
                case 2:
                    result = (_e.sent()).data.result;
                    items = result.items, all = __rest(result, ["items"]);
                    firstStep = __assign(__assign({}, all), { items: __spreadArray([], __read(items.sort(function (a, b) { return +moment(b.date) - +moment(a.date); })), false) });
                    if (firstStep.items.length && !((_d = Object.keys(this.secondStep.data)) === null || _d === void 0 ? void 0 : _d.length)) {
                        _c = __read(firstStep.items, 1), firstData = _c[0];
                        this.getSecondStep({ key: firstData.date, date: getStartEndDay(firstData.date) });
                    }
                    if (concat) {
                        firstStepData = this.firstStep.data;
                        this.firstStep = {
                            data: {
                                items: __spreadArray(__spreadArray([], __read(firstStepData.items), false), __read(firstStep.items), false).sort(function (a, b) { return +moment(b.date) - +moment(a.date); }),
                                count: firstStep.count,
                            },
                            pending: false,
                        };
                    }
                    else {
                        this.firstStep = {
                            data: firstStep,
                            pending: false,
                        };
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _e.sent();
                    this.setFirstStepPending();
                    iframeService.sendReload();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    };
    TableBetHistoryStore.prototype.setSecondStepPending = function () {
        this.secondStep.pending = !this.secondStep.pending;
    };
    TableBetHistoryStore.prototype.getSecondStep = function (payload) {
        var _a, _b, gameId, key, date, result;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = parseQuery(window.location.search), _b = DefaultQueryParams.GameId, gameId = _a[_b];
                    key = payload.key, date = payload.date;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    this.setSecondStepPending();
                    return [4 /*yield*/, this.betsService.getBets(__assign({ gameId: gameId }, date), this.fetchPaths.SecondStep)];
                case 2:
                    result = (_d.sent()).data.result;
                    this.secondStep = {
                        data: __assign(__assign({}, this.secondStep.data), (_c = {}, _c[key] = result.items, _c)),
                        pending: false,
                    };
                    return [3 /*break*/, 4];
                case 3:
                    _d.sent();
                    this.setSecondStepPending();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    };
    TableBetHistoryStore.prototype.setThirdStepPending = function () {
        this.thirdStep.pending = !this.thirdStep.pending;
    };
    TableBetHistoryStore.prototype.getThirdStep = function (option) {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    this.setThirdStepPending();
                    return [4 /*yield*/, this.betsService.getBets(option, this.fetchPaths.ThirdStep)];
                case 1:
                    result = (_a.sent()).data.result;
                    this.thirdStep = {
                        data: Array.isArray(result.items) ? result.items[0] : result,
                        pending: false,
                    };
                    return [3 /*break*/, 3];
                case 2:
                    _a.sent();
                    this.setThirdStepPending();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    };
    TableBetHistoryStore.prototype.removeThirdStep = function () {
        this.thirdStep = {
            data: {},
            pending: false,
        };
    };
    TableBetHistoryStore.prototype.setFetchPaths = function (fetchPaths) {
        this.fetchPaths = __assign(__assign({}, this.fetchPaths), fetchPaths);
    };
    TableBetHistoryStore.prototype.setFetchParamNames = function (fetchParamNames) {
        this.fetchParamNames = __assign(__assign({}, this.fetchParamNames), fetchParamNames);
    };
    return TableBetHistoryStore;
}());
var tableBetHistoryStore = new TableBetHistoryStore();

var LoadingStore = /** @class */ (function () {
    function LoadingStore() {
        this.progress = 0;
        this.gameLoading = true;
        this.isSoundLoaded = false;
        this.isGameInitialLoaded = false;
        this.isTranslationsLoaded = false;
        this.isPixiLoaded = false;
        this.isAssetsIsLoaded = false;
        this.isAdditionalLoading = false;
        this.timerFinished = false;
        this.isOneTimeTableLoads = false;
        makeObservable(this, {
            progress: observable,
            gameLoading: observable,
            isOneTimeTableLoads: observable,
            isSoundLoaded: observable,
            isGameInitialLoaded: observable,
            isPixiLoaded: observable,
            isTranslationsLoaded: observable,
            isAdditionalLoading: observable,
            updateLoading: action.bound,
            updateIsAdditionalLoading: action.bound,
            timerFinished: observable,
            startLoaderTimer: action.bound,
            setTimeOutStartLoaderTimer: action.bound,
            setIsOneTimeTableLoads: action.bound,
        });
    }
    LoadingStore.prototype.setIsOneTimeTableLoads = function (bool) {
        this.isOneTimeTableLoads = bool;
    };
    LoadingStore.prototype.startLoaderTimer = function () {
        var _this = this;
        this.timerFinished = false;
        setTimeout(function () {
            _this.setTimeOutStartLoaderTimer();
        }, 3000);
    };
    LoadingStore.prototype.setTimeOutStartLoaderTimer = function () {
        this.timerFinished = true;
    };
    LoadingStore.prototype.updateIsAdditionalLoading = function (isAdditionalLoading) {
        this.isAdditionalLoading = isAdditionalLoading;
    };
    LoadingStore.prototype.updateLoading = function (data) {
        var newState = __assign({ isSoundLoaded: this.isSoundLoaded, isGameInitialLoaded: this.isGameInitialLoaded, isTranslationsLoaded: this.isTranslationsLoaded, isAssetsIsLoaded: this.isAssetsIsLoaded, isPixiLoaded: this.isPixiLoaded }, data);
        var isSoundLoaded = newState.isSoundLoaded, isGameInitialLoaded = newState.isGameInitialLoaded, isTranslationsLoaded = newState.isTranslationsLoaded, isAssetsIsLoaded = newState.isAssetsIsLoaded;
        var props = [isSoundLoaded, isGameInitialLoaded, isTranslationsLoaded, isAssetsIsLoaded];
        if (gameConfigStore.gameConfigs.isGameHasPixi) {
            props.push(newState.isPixiLoaded);
            this.isPixiLoaded = newState.isPixiLoaded;
        }
        this.progress = Math.ceil(this.calculateProgress(props));
        this.gameLoading = Math.ceil(this.progress) !== 100;
        if (!this.gameLoading) {
            iframeService.sendLoadedState();
            loadingStore.startLoaderTimer();
        }
        this.isSoundLoaded = isSoundLoaded;
        this.isAssetsIsLoaded = isAssetsIsLoaded;
        this.isGameInitialLoaded = isGameInitialLoaded;
        this.isTranslationsLoaded = isTranslationsLoaded;
    };
    // Add dynamic observable property
    LoadingStore.prototype.addObservableProperty = function (propertyName, value) {
        var _a;
        extendObservable(this, (_a = {},
            _a[propertyName] = observable(value),
            _a));
    };
    // Add dynamic action
    LoadingStore.prototype.addAction = function (actionName, actionFn) {
        var _a;
        extendObservable(this, (_a = {},
            _a[actionName] = action(actionFn),
            _a));
    };
    LoadingStore.prototype.calculateProgress = function (arr) {
        return arr.reduce(function (acc, curr, i, self) { return acc + (Number(curr) / self.length) * 100; }, 0);
    };
    return LoadingStore;
}());
var loadingStore = new LoadingStore();

var baseUrl = 'https://pg-stage.rpd.cloud';
var translationEndPoint = 'translations/api/v1/Translations';
var filesEndPoint = 'pg-files';
var liveEnvironment = function (gameNameForUrl) { return ({
    chatHttpUrl: "".concat(window.location.origin, "/chat"),
    httpUrl: "".concat(window.location.origin, "/").concat(gameNameForUrl),
    socketUrl: "".concat(window.location.origin, "/").concat(gameNameForUrl, "/api/"),
    chatSocketUrl: "".concat(window.location.origin, "/chat/api/hubs/chat"),
    httpFilesUrl: "".concat(window.location.origin, "/").concat(filesEndPoint),
    httpTranslationUrl: "".concat(window.location.origin, "/").concat(translationEndPoint),
    platformApiUrl: "".concat(window.location.origin, "/api/games/").concat(gameConfigStore.gameId, "/replay"),
}); };
var stageEnvironment = function (gameNameForUrl) { return ({
    chatHttpUrl: "".concat(baseUrl, "/chat"),
    httpUrl: "".concat(baseUrl, "/").concat(gameNameForUrl),
    httpFilesUrl: "".concat(baseUrl, "/").concat(filesEndPoint),
    socketUrl: "".concat(baseUrl, "/").concat(gameNameForUrl, "/api/"),
    chatSocketUrl: "".concat(baseUrl, "/chat/api/hubs/chat"),
    httpTranslationUrl: "".concat(baseUrl, "/").concat(translationEndPoint),
    platformApiUrl: "".concat(baseUrl, "/api/games/").concat(gameConfigStore.gameId, "/replay"),
}); };
var environmentBuilder = function (gameNameForUrl) {
    if (process.env.REACT_APP_ENV === EnvironmentTypes.Production) {
        return liveEnvironment(gameNameForUrl);
    }
    return stageEnvironment(gameNameForUrl);
};

var validateBalanceOnBet = function (bet) {
    var _a;
    var currentBetTotalAmount = 0;
    if (Array.isArray(bet === null || bet === void 0 ? void 0 : bet.betData) && (bet === null || bet === void 0 ? void 0 : bet.betData.length)) {
        bet.betData.forEach(function (item) {
            var _a;
            if ((item === null || item === void 0 ? void 0 : item.markets) && ((_a = item === null || item === void 0 ? void 0 : item.markets) === null || _a === void 0 ? void 0 : _a.length)) {
                item.markets.forEach(function (market) {
                    currentBetTotalAmount += market.amount;
                });
            }
            else if (item.bet && item.bet.amount) {
                currentBetTotalAmount = item.bet.amount;
            }
            else if (item.includedBets && item.includedBets.length) {
                item.includedBets.forEach(function (includedBet) {
                    currentBetTotalAmount += includedBet.amount;
                });
            }
            else {
                currentBetTotalAmount += item.amount;
            }
        });
    }
    else if ((_a = bet === null || bet === void 0 ? void 0 : bet.betData) === null || _a === void 0 ? void 0 : _a.amount) {
        var amount = (bet === null || bet === void 0 ? void 0 : bet.betData).amount;
        if (+amount > userInfoStore.balance) {
            currentBetTotalAmount = amount;
        }
    }
    else {
        var amount = bet.amount;
        if (+amount > userInfoStore.balance) {
            currentBetTotalAmount = amount;
        }
    }
    return +currentBetTotalAmount <= userInfoStore.balance;
};

export { gameConfigStore as $, FreeBetStore as A, BaseLiveConnection as B, ChatService as C, userInfoStore as D, UserInfoStore as E, FreeChipService as F, GameLiveConnection as G, freeChipsStore as H, IframeService as I, FreeChipsStore as J, statisticsStore as K, LobbyLiveConnection as L, StatisticsStore as M, applicationStore as N, ApplicationStore as O, PostMessage as P, userSettingsStore as Q, RoundsService as R, StatisticsService as S, TranslationService as T, UsersService as U, UserSettingsStore as V, tableBetHistoryStore as W, TableBetHistoryStore as X, profileAvatarStore as Y, ProfileAvatarStore as Z, loadingStore as _, plus as a, GameConfigStore as a0, doBetStore as a1, betDataStore as a2, AMOUNT as a3, WIN_AMOUNT_KEY as a4, FREE_BET_WIN_AMOUNT_KEY as a5, freeBetsWinData as a6, isObject as a7, calculateSumByKey as a8, calculateTotalBetAmount as a9, calculateSumByFreeBet as aa, calculateTotalWinAmount as ab, checkDoBetResultAndUpdateSectionData as ac, buildCurrentLiveBetsOnRoundFin$1 as ad, getCurrentFreeBetSectionAmountByWinType as ae, checkShowMaxPayoutPopUp as af, checkShowMaxPayoutPopUpByGame as ag, autoCashOutResultReportEventMaxPayout as ah, setExtraFreeBetData as ai, checkShowMaxPayoutNotifications as aj, getFreeBetSectionIndexes as ak, hideFreeBetMaxPayoutPopUpAfterAutoCashOut as al, hideFreeBetMaxPayoutPopUpAfterCashOut as am, buildCurrentLiveBetsOnRoundFin as an, minus as b, toDecimal as c, divide as d, environmentBuilder as e, checkAndSendStakeUpdate as f, checkCashOutResultAndUpdateGameSectionData as g, checkResultReportDataAndUpdateGameSectionData as h, iframeService as i, PostMessageListenerMessages as j, httpClient as k, BetsService as l, multiply as m, chatService as n, betStore as o, parseNumberByPrecision as p, BetsStore as q, popupStore as r, setHttpClientInterceptors as s, toFixed as t, PopupStore as u, validateBalanceOnBet as v, lobbyStore as w, LobbyStore as x, platformMessageStore as y, freeBetStore as z };
